/* eslint-disable no-param-reassign */
import isEmpty from 'lodash/isEmpty';
import cloneDeep from 'lodash/cloneDeep';
import fromPairs from 'lodash/fromPairs';
import isEqual from 'lodash/isEqual';
import store from 'redux-v2/store';
import { v4 as uuidv4 } from 'uuid';
import sortBy from 'lodash/sortBy';
import {
  ColumnDataTypes,
  ColumnModes,
  DataSourceSelectionType,
  DimensionMode,
  DimensionStatus,
  draggableItemType,
  FieldEntitiesType,
  MAX_DESC_CHARACTER_LIMIT,
  MAX_NAME_CHARACTER_LIMIT,
  MaxRowGroupingDimensionsToAllowSubTotals,
  MIN_CHARACTER_LIMIT,
  OperatorTypes,
} from 'core/constants/report';
import {
  IBuilder,
  IBuilderDimension,
  IBuilderFilter,
  IBuilderMeasure,
  IDimensionsMetaFields,
  IFilterGroup,
  IFilterGroupRender,
  IHierarchy,
  IReportBuilderColumn,
  IReportConfig,
  ISetDimensionsBinningPayload,
  ISorting,
  IRawTemplate,
  ReportBuilderStatus,
  ReportType,
  QuerySourceType,
  IReportMetaInfo,
  RequestType,
  QueryBuilderConfig,
  IReportMetaInfoV2,
  JoinItem,
  IBuilderDimensionMeasure,
  IReportBuilderCustomColumns,
  ICustomHierarchy,
  JoinType,
} from 'core/models/report-builder/report-builder';
import {
  IExpression, isAgg, newArrayJoinExpr, newArrayStringConcatExpr, newColumnExpr, newDateExpr,
} from 'core/models/report-expressions';
import { IDimension, ISetGroupingPayload } from 'core/models/report-redux';
import { VisualizationTypes } from 'core/constants/visualizations';

import {
  IColumn, IColumnDimension, IColumnProperties, ICustomFilterDefinition, IField, IFilterConfig, ILinkedFilterInfo,
  SubBuilderFiltersMetadata, IDimensionMetaField,
  ISetEntityGroupingPayload,
  ISetDimensionsEntityGroupingPayload,
  ISetMetaSelectorOptionsPayload,
  IFiltersMetaData,
} from 'core/models/report-response';
import {
  DefaultNumberFilterOperator, FilterType, GroupFilterId, LinkedFilterSource, NumberFilterOperatorTypes, NumberFilterTypes, UserFilterPayloadType,
} from 'core/constants/filter';
import { FilterModel, ObjModel, ReportResponseModel } from 'core/models';
import FilterFetchUtility from 'core/utils/filter-fetch-utility';
import { IVariables } from 'core/models/store';
import {
  areDimensionsEqual,
  getDefaultMeasures,
  getUpdateVisualization,
  isDefaultUserField,
  isDimensionCustom,
  isDrilldownPossible,
  isMeasureAndApplied,
  isMeasureCustom,
  isMeasureDynamic,
  isWrongInput,
  rebuildSortState,
  setDrilldownEnableFlag,
  sortColumns,
  validateAndAppendCountToName,
  getDefaultEntity,
  getDuplicateMeasuresDetails,
  getFieldIdentifier,
  getSavePayloadEntityGroupDimensionMetafields,
  getDestinationDimensionStatus,
  getUniqIdentiferForDrilldownColsWithId,
  isCustomHierarchyColumnOrDimension,
  isDateTypeOfField,
  reconcileFunnelAttributes,
  excludeBrokenComboMeasures,
  resolveFilterIDInCaseOfQueryIdPresent,
} from 'core/utils/report.util';
import {
  isEntityGrouped,
  updateEntityGroupedDimension,
  generateEntityStore,
  createEntityGroupedDimension,
  createEntityGroupedDrilldown,
  updateEntityGroupedDrilldown,
  addDimensionToGrouping,
  isDrilldownTabActive,
  getUpdatedMetaSelectorOptions,
  getOriginalDimensionIndex,
  isValidMetaSelectorOptions,
  updateEntityGroupStore,
  isColumnUserHidden,
  getHideTargetColumn,
} from 'core/utils/entity-grouping.util';
import { DateBinningFormatters } from 'core/constants/formatters';
import {
  getFilterConfigFromBuilder, getFilterConfigFromTemplate, isLargeOptionSetFilter, isPaginatedFilter, removeDuplicateObject,
} from 'core/utils/common.utility';
import { checkIsUserSalesGroupingField } from 'components/feature/Report/ReportSidebar/Settings/settings.utils';
import { IDateRangeTypes } from 'core/constants/date';
import { getDatesIfAbsoluteRangeIsRestricted, getDatesIfRelativeRangeIsRestricted } from 'core/utils/date.util';
import moment from 'moment-timezone';
import { buildCustomDimension, buildCustomMeasure, getDataTypeFromCustomColumn } from 'core/utils/report-expressions';
import {
  isValidArray, isValidArrayAndNotEmpty, isValidObjectAndNotEmpty, isValidUUID,
  truncateUUID,
} from 'components/feature/Report/ReportSidebar/common/helpers';
import { ObjGeneric } from 'core/models/obj';
import groupBy from 'lodash/groupBy';
import mapValues from 'lodash/mapValues';
import { getInitialVisualization } from 'redux-v2/report/report-store.utils';
import { ModuleName } from 'redux-v2/settings-store/settings-store-state';
import { getEntityJoinIdForCustomMeasure } from 'components/feature/ReportBuilderV2/ReportBuilderDetail/DrilldownTabContent/drilldown.util';
import {
  ROOT_QUERY_KEY,
  userDefaultFilterValue, UserDelimiter, UserHierarchy, UserNameConstant,
  userStatusEnum,
} from 'components/feature/Report/ReportSidebar/common/constants';
import {
  ICreateNewQueryPayload, ISwitchUserFieldFilterPayload, IUpdateQueryPayload, SwitchContext,
} from 'core/models/report-builder/report-builder-redux';
import { getDefaultJoinCriteria, extractJoinConditions, normalizeJoinConditions } from 'components/feature/ReportBuilderV2/DataSource/data-source.util';
import { getDataSourceTitle, isListReport, SubQueryPanelType } from 'core/utils/report-builder.util';
import { FeatureContext, PageContext } from 'core/constants/common';
import { JoinPrefix } from 'core/constants/report-expressions';
import {
  IReportBuilderState, IFilterBuilder, IFilterMetaInfo, IFilterMetaInfoStore, ICustomExpression,
  IAddMeasurePayload, IRemoveMeasurePayload, IMoveMeasurePayload, ISetMeasurePayload, DrilldownConfigMapping,
  DrilldownColumnConfig, DrilldownColumnConfigResponse, DrilldownFieldUpdationType, DrilldownFieldUpdationsAction,
  IdrilldownConfigInfo, DrillDownColumnConfigObj,
  IDrilldownSorting,
  ISortDrilldownColumnPayload,
  ExpressionContext,
  MeasureListWithJoinId,
  IDataSourceResponse,
  IDataSourceApiResponse,
  IQueryInfo,
  ISelectedQueryInfo,
  IDataSourceMapping,
  ReportType as SubQueryReportType,
  IDataSourceItems,
  IDeleteDynamicFilterPayload,
  IQueryBuilder,
  SaveSubQueryPayload,
  IQueryBuilderUpdatedInfo,
  UpdateType,
  IDataSourceFieldType,
  ISetDimensionPayload,
} from 'redux-v2/report-builder/report-builder-store.state';
import { builderMeasuresListSelector, fieldSelectors } from './report-builder-store.selectors';
import { IGlobalState } from '../../core/models/redux';
import initialReportBuilderState from './report-builder-store.initial-state';

// Update the selected report template with type as custom and status as draft
// @templateItem - Selected template
export const selectedReportTemplate = (
  templateItem: IRawTemplate,
  filterMetaInfo: IFilterMetaInfo[],
): IReportConfig => {
  const { ReportConfig } = templateItem;

  if (isValidArrayAndNotEmpty(filterMetaInfo) && isValidArrayAndNotEmpty(ReportConfig?.Builder)) {
    const groupIdFilterList = filterMetaInfo.filter((filterInfo) => filterInfo?.ID?.startsWith(GroupFilterId));

    const updatedFilters = groupIdFilterList.map((groupIdFilter) => {
      const render: IFilterGroupRender = {
        ID: groupIdFilter.ID,
        Type: groupIdFilter.Type,
        DefaultValue: null,
        LinkedTo: groupIdFilter.LinkedTo,
        Label: groupIdFilter.Label,
        Metadata: groupIdFilter.Metadata,
        StyleConfig: null,
      };

      return {
        ...groupIdFilter,
        IsAdditional: false,
        AlwaysEnabled: false,
        DataType: ColumnDataTypes.String,
        Render: render,
      };
    });

    const reportConfigCopy = cloneDeep(ReportConfig);
    const existingFilterGroup = reportConfigCopy.Builder[0]?.Filter?.FilterGroup || [];

    // Add only filters that are not already present
    updatedFilters.forEach((filter) => {
      const alreadyExists = existingFilterGroup?.some((config) => config.ID === filter.ID);
      if (!alreadyExists) {
        existingFilterGroup.push(filter);
      }
    });

    reportConfigCopy.Status = ReportBuilderStatus.DRAFT;
    reportConfigCopy.Details = {
      ...reportConfigCopy.Details,
      Type: ReportType.Custom,
    };

    return reportConfigCopy;
  }

  return {
    ...ReportConfig,
    Status: ReportBuilderStatus.DRAFT,
    Details: {
      ...ReportConfig.Details,
      Type: ReportType.Custom,
    },
  };
};

// Update the report config with report ID and Title, description to empty
// @state - Report builder state
// @payload - Report ID
export const getUpdatedPayloadAfterInitialSave = (
  state: IReportBuilderState,
  payload: string,
): IReportConfig => {
  const reportBuilderPayload = state.updatedReportBuilderInfo.reportBuilderSavePayload;
  const updatedVisualization = getInitialVisualization(reportBuilderPayload?.Visualization, false);
  return {
    ...reportBuilderPayload,
    ReportConfigId: payload,
    Details: {
      ...reportBuilderPayload.Details,
      Title: '',
      Description: '',
    },
    Visualization: {
      Type: updatedVisualization.type,
      Builder: { ...reportBuilderPayload.Visualization.Builder, Properties: updatedVisualization.attributes },
      ...(updatedVisualization?.DisplayName ? { DisplayName: updatedVisualization?.DisplayName } : {}),
    },
  };
};

// Validation check for the report builder save.
// @Title - Title of the report builder form
// @Description - Description of the report builder form
// @state - Report builder state
export const getIsReportBuilderSaveFormDisable = (
  Title: string,
  Description: string,
  state: IReportBuilderState,
) => isWrongInput(Title)
  || isWrongInput(Description)
  || Title.length > MAX_NAME_CHARACTER_LIMIT
  || Description.length > MAX_DESC_CHARACTER_LIMIT
  || Title.trim().length < MIN_CHARACTER_LIMIT
  || Description.trim().length < MIN_CHARACTER_LIMIT
  || !Title.trim().length
  || !Description.trim().length
  || (isEqual(
    state.updatedReportBuilderInfo.selectedTemplate.ReportConfig,
    state.updatedReportBuilderInfo.reportBuilderSavePayload,
  ) && !state.reportEditInfo.isEditing);

// Validation specific to filter block.
// @filterConfig - Configuration of the filter
// @appliedFilters - Filter response and data
export const getIsFilterFormDisable = ({
  filterConfig,
  appliedFilters,
}: IFilterBuilder) => {
  const addedFilterConfig = filterConfig.filter((el) => !el.IsRemoved);
  const dropdownFilterIds = addedFilterConfig
    .filter(
      (config: IFilterConfig) => ![
        FilterType.PRE_APPLIED,
        FilterType.MultiTextSearch,
        FilterType.DateRange,
        FilterType.UserMultiSelect,
      ].includes(config.Type),
    )
    .filter((config: IFilterConfig) => !isLargeOptionSetFilter(config))
    // Custom filters and their constituents manage their own dropdown loading — don't block the form
    .filter((config: IFilterConfig) => !config.IsCustomFilter && !config.AssociatedCustomFilterId)
    .map((item: IFilterConfig) => item.ID);

  const userFieldsConfig = addedFilterConfig.filter(
    (config: IFilterConfig) => isPaginatedFilter(config),
  );
  const isUserFieldValueEmpty = userFieldsConfig?.some((config: IFilterConfig) => {
    const filter = appliedFilters[config.ID]?.FilterResponse;
    return filter?.Type === UserFilterPayloadType.In
      && isEmpty(isLargeOptionSetFilter(config) ? filter?.Values : filter?.UserIds);
  });

  return (
    isUserFieldValueEmpty
    || dropdownFilterIds.some((id: string) => isEmpty(appliedFilters[id]?.FilterResponse))
  );
};

export const getAppliedDimensions = (
  state: IReportBuilderState,
  reportConfig: IReportConfig,
  filteMetaInfo?: IFilterConfig[],
): IDimension[] => {
  const { Columns } = reportConfig;
  return getAppliedDimensionsFromColumns(Columns, filteMetaInfo);
};

export const getAppliedDimensionsFromColumns = (columns: IReportBuilderColumn[], filteMetaInfo?: IFilterConfig[]) => {
  const availableDimensions: IDimension[] = [];

  columns?.forEach((item: IReportBuilderColumn) => {
    if (item.Props.Dimension || item.Props.ParentDimension) {
      const dimension = {
        Name: item.Name,
        Id: item.Id,
        ReferTo: item.Props.ReferTo,
        ...item.Props.Dimension,
        BuilderConfig: {
          ...item.BuilderConfig,
          Entity: item?.BuilderConfig?.Entity,
          DisplayName: item.Name,
        },
        IsMasked: item.Props.IsMasked,
        Mode: item.Props?.Mode,
        Props: item.Props,
        IsUserDynamicField: item?.Props?.IsUserDynamicField,
        // For metafields Applied does not exists so setting NotApplied as default
        Applied: item?.Props?.Dimension
          ? item?.Props?.Dimension?.Applied
          : DimensionStatus.NotApplied,
      } as IDimension;
      if (
        item.BuilderConfig?.DataType === ColumnDataTypes.DateTime
        && !item.Props.Dimension.DimensionProp
      ) {
        // set default date binning props for date dimensions in template
        dimension.DimensionProp = {
          ...dimension.DimensionProp,
          DataType: item.BuilderConfig.DataType,
        };
        dimension.Props.Dimension.DimensionProp = {
          ...dimension.DimensionProp,
          Props: {
            ...dimension.DimensionProp.Props,
          },
        };
      }
      availableDimensions.push(dimension);
    }
  });
  return reorderAppliedDimensions(availableDimensions);
};

export const reOrderDimensions = (
  appliedDimensions: IDimension[],
): IDimension[] => {
  const [row, col, unapplied] = appliedDimensions.reduce(
    (acc, dim) => {
      if (dim.Applied === DimensionStatus.NotApplied) {
        acc[2].push(dim);
      } else if (dim.DimensionMode !== DimensionMode.RowGroup) {
        acc[1].push(dim);
      } else {
        acc[0].push(dim);
      }
      return acc;
    },
    [[], [], []] as IDimension[][],
  );
  return [...row, ...col, ...unapplied];
};

export const reOrderDimensionsForSubQuery = (
  appliedDimensions: IDimension[],
): IDimension[] => {
  const groupingDimensions = appliedDimensions?.filter(
    (dim) => dim?.Applied !== DimensionStatus.NotApplied,
  );
  const availableDimensions = appliedDimensions?.filter(
    (dim) => dim?.Applied === DimensionStatus.NotApplied,
  );
  return [
    ...groupingDimensions,
    ...availableDimensions,
  ];
};

export const getMeasureColumns = (
  reportConfig: IReportConfig,
  takeOnlyApplied?: boolean,
  removeCustomMeasures: boolean = false,
): IColumn[] => {
  const {
    Columns: columns, Builder: builders,
  } = reportConfig;
  return getMeasureColumnsFromBuilder(columns, builders, reportConfig.CalculatedColumns, takeOnlyApplied, removeCustomMeasures);
};

export const getMeasureColumnsFromBuilder = (
  columns: Array<IReportBuilderColumn>,
  builders: Array<IBuilder>,
  calculatedColumns: IBuilderMeasure[],
  takeOnlyApplied?: boolean,
  removeCustomMeasures: boolean = false,
) => {
  const measures = builders
    ?.map((builder) => builder.Select.Measures)
    ?.concat(calculatedColumns ?? [])
    ?.flat();

  const updatedColumns = removeCustomMeasures ? columns?.filter((col: IColumn) => !col.Props.Measure?.IsCustomExpression) : columns;
  return updatedColumns
    ?.filter((column) => (!column.Props?.Dimension && !column?.Props?.ParentDimension) && (!takeOnlyApplied
          || column?.Props?.Mode !== ColumnModes.NotApplied))
    ?.map((column): IReportBuilderColumn => {
      const measure = measures.find((measureItem) => measureItem.Id === column.Id);
      return {
        ...column,
        Props: {
          ...column.Props,
          Description: column?.Props?.Description ?? measure?.Description,
          Measure: {
            // incoming measures don't have the Measure object which we need for isMeasure and others
            Name: column.Name,
            IsMeasure: true,
            IsCustomExpression: column?.Props?.Measure?.IsCustomExpression || undefined,
            Expression: column?.Props?.Measure?.Expression || undefined,
            Entity: column?.Props?.Measure?.Entity,
            IsPreDefined: column?.Props?.Measure?.IsPreDefined,
            JoinID: column?.Props?.Measure?.JoinID,
          },
        },
        BuilderConfig: {
          ...column.BuilderConfig,
          DataType: measure?.DataType || ColumnDataTypes.Default,
        },
      };
    });
};

export const getMeasureColumnsFromSubqueryBuilder = (
  updatedInfo: IQueryBuilderUpdatedInfo,
  removeCustomMeasures: boolean = true,
) => {
  const { AppliedMeasures } = updatedInfo;
  const measures = Array.from(AppliedMeasures);

  const updatedColumns = removeCustomMeasures ? measures?.filter((col: IColumn) => !col.Props.Measure?.IsCustomExpression) : measures;
  return updatedColumns
    ?.filter((column: IReportBuilderColumn) => (!column.Props?.Dimension && !column?.Props?.ParentDimension) && ((column?.Props?.Mode !== ColumnModes.NotApplied
          && column?.Props?.Mode !== ColumnModes.Hidden)))
    ?.map((column: IReportBuilderColumn) => ({
      ...column,
      Props: {
        ...column.Props,
        Description: column?.Props?.Description,
        Measure: {
          // incoming measures don't have the Measure object which we need for isMeasure and others
          Name: column.Name,
          IsMeasure: true,
          IsCustomExpression: column?.Props?.Measure?.IsCustomExpression || undefined,
          Expression: column?.Props?.Measure?.Expression || undefined,
          Entity: column?.Props?.Measure?.Entity,
          IsPreDefined: column?.Props?.Measure?.IsPreDefined,
          JoinID: column?.Props?.Measure?.JoinID,
        },
      },
      BuilderConfig: {
        ...column.BuilderConfig,
      },
    }));
};

export const getSavePayloadDimensionColumns = (
  availableDimensions: IDimension[],
  appliedFilters: IFilterConfig[],
  queryId?: string,
  isListReportType?: boolean,
): Array<IReportBuilderColumn> => {
  const columns: Array<IReportBuilderColumn> = [];

  availableDimensions?.forEach((dim: IDimension) => {
    let shouldExcludeColumn = false;

    // removing all unapplied columns from columns array in payload
    if (dim?.Applied === DimensionStatus.NotApplied) {
      shouldExcludeColumn = true;
    }

    if (
      (dim.Applied !== DimensionStatus.NotApplied
        || (!dim.Props.IsAdditional && !dim?.BuilderConfig?.IsDynamicField))
      && !dim?.Props?.ParentDimension
      && !shouldExcludeColumn
    ) {
      const isDynamicField = dim?.BuilderConfig?.IsDynamicField && !dim?.Props?.ReferTo;
      columns.push({
        Id: dim.Id,
        Name: isDynamicField ? dim.BuilderConfig.DisplayName : dim.Name,
        Props: {
          ...dim.Props,
          Dimension: getDimensionProps(dim, dim.Props),
          Mode: dim.Mode,
          IsAdditional: isDynamicField || dim?.Props?.Dimension?.IsCustomExpression || dim?.Props?.IsUserDynamicField ? true : dim?.Props?.IsAdditional || false,
          QueryId: dim?.Props?.QueryId || queryId,
        },
      });
      // For Join template there can be duplicate parentDimension so adding extra ReferTo checks as well.
      const referredDim = availableDimensions.find(
        (item: IDimension) => dim.Id === item?.Props?.ParentDimension && dim?.ReferTo === item?.Id,
      );
      if (referredDim) {
        columns.push({
          Id: referredDim.Id,
          Name: referredDim.Name,
          Props: { ...referredDim.Props, Action: referredDim.Props.Action, QueryId: referredDim?.Props?.QueryId || queryId },
        });
      }
    }
  });

  columns.filter((item) => {
    if (item?.Props?.IsAdditional && item?.Props?.Dimension?.Applied === DimensionStatus.NotApplied) {
      return true;
    }
    if (columns?.find((col) => col.Id === item.Props.ReferTo && col.Props.IsAdditional && col.Props.Dimension.Applied === DimensionStatus.NotApplied)) {
      return true;
    }

    return false;
  });
  return columns;
};

export const getSavePayloadMeasureColumns = (
  appliedMeasures: IColumn[],
  defaultMeasures: IReportBuilderColumn[],
  report: IReportConfig,
  queryId?: string,
): IColumn[] => {
  const measures: IColumn[] = [];
  const isCalculated = fromPairs((report?.CalculatedColumns || []).map((c) => [c.Alias, true]));
  appliedMeasures.forEach((measure) => {
    if (isMeasureAndApplied(measure) || measure?.Props?.Mode === ColumnModes.Hidden) {
      measures.push({
        Id: measure.Id,
        Name: measure.Name,
        Props: {
          ...measure.Props,
          Measure: isMeasureCustom(measure)
            ? { ...measure?.Props?.Measure, Expression: measure.Props.Measure.Expression }
            : undefined, // For pre-defined measures Measure expression will be null/ undefined
          IsAdditional: isMeasureDynamic(measure) || isMeasureCustom(measure),
          DrilldownEnabled: isCalculated[measure.Id]
            && (isMeasureCustom(measure) || isAgg(measure?.Props?.Measure?.Expression ?? {} as IExpression)) ? false : measure?.Props?.DrilldownEnabled,
          QueryId: measure?.Props?.QueryId || queryId,
        },
      });
    }
  });
  defaultMeasures
    .filter((item) => !measures.find((measure) => measure.Id === item.Id) && !item?.Props?.IsAdditional)
    // Filter Not applied pre defined measures
    .forEach((measure) => measures.push({
      Id: measure.Id,
      Name: measure.Name,
      Props: {
        ...measure.Props,
        Mode: ColumnModes.NotApplied,
        Measure: undefined,
        QueryId: measure?.Props?.QueryId || queryId,
      },
    }));
  return measures;
};

export const getSavePayloadBuilderDimensions = (
  appliedDimensions: IDimension[],
  builderDimensions: IBuilderDimension[],
  appliedFilters: IFilterConfig[],
  NameSpaceInfo?: Object,
  Namespace?: string,
  isAugumented?: boolean,
  queryId?: string,
): Array<IBuilderDimension> => {
  const appliedUserFilter = appliedFilters.find((filter:IFilterConfig) => filter?.Type === FilterType.UserMultiSelect);
  const linkedField = isValidArrayAndNotEmpty(appliedDimensions) ? (appliedDimensions.find((dim:IDimension) => dim?.BuilderConfig?.Alias === appliedUserFilter?.Alias && appliedUserFilter?.Entity === dim?.BuilderConfig?.Entity)) : undefined;
  const newBuilderDimensions = isValidArrayAndNotEmpty(builderDimensions) ? cloneDeep(builderDimensions.filter((item: IBuilderDimension) => !item.IsAdditional)) : [];
  appliedDimensions?.forEach((dim: IDimension) => {
    // For reports updating the binning value of already applied dimensions
    if (dim?.Applied === DimensionStatus.Applied && dim?.BuilderConfig?.DataType === ColumnDataTypes.DateTime) {
      newBuilderDimensions?.forEach((item) => {
        if (item.Id === dim.Id) {
          item.GroupByExpression.SubType = dim?.DimensionProp?.Props?.BinningType as DateBinningFormatters;
          item.RangeFill = dim?.Props?.Dimension?.RangeFill;
        }
      });
    }

    if (((dim.Applied !== DimensionStatus.NotApplied || isEqual(linkedField, dim))
      || (!dim.Props.IsAdditional && !dim?.BuilderConfig?.IsDynamicField))
      && !dim?.Props?.ParentDimension
      && !newBuilderDimensions?.find(
        (item: IBuilderDimension) => item.Id === dim.Id,
      )
    ) {
      if ((dim.Applied === DimensionStatus.NotApplied && queryId)) {
        return;
      }
      const isDynamicField = dim?.BuilderConfig?.IsDynamicField && !dim?.Props?.ReferTo;
      const updatedAlias = isAugumented && (dim.Props.IsAdditional || dim?.BuilderConfig?.IsDynamicField)
        ? getUpdatedAlias(
          NameSpaceInfo[Namespace as keyof object],
          dim?.BuilderConfig?.SchemaName,
          dim.BuilderConfig?.Entity,
        )
        : dim?.BuilderConfig?.Alias;
      if (dim?.IsCustomExpression && dim?.Expression) {
        newBuilderDimensions.push({
          GroupByExpression: dim.Expression,
          Alias: dim.Name,
          IsTypeAlteringExpression: false,
          DataType: dim?.BuilderConfig?.DataType,
          IsCustomExpression: dim?.IsCustomExpression,
          IsAdditional: true,
          Id: dim.Id,
          RangeFill: dim?.Props?.Dimension?.RangeFill,
          QueryId: dim?.Props.QueryId || queryId,
          IsSourceCustomColumn: dim?.Props?.IsSourceCustomColumn,
          Description: dim?.Props?.Description,
        });
      } else if (checkIsUserSalesGroupingField(dim)) {
        // For Dynamic having no metafield we pass the Name
        const columnExpr = newColumnExpr(
          isDynamicField ? dim.BuilderConfig.DisplayName : dim.Name,
          updatedAlias,
          dim?.BuilderConfig?.DataType,
          dim?.BuilderConfig?.JoinID,
          dim?.BuilderConfig?.Entity,
        );
        // if a query's Sales Group field is added as a dimension in parent,
        // then the group expression should be a columnExpr
        // if Sales Group field belongs to current query or builder and is added as a dimension
        // then it should be newArrayStringConcatExpr (to show comma separated values)
        newBuilderDimensions?.push({
          GroupByExpression: dim.BuilderConfig?.EntityName ? columnExpr : newArrayStringConcatExpr(columnExpr),
          Alias: isDynamicField ? dim?.BuilderConfig.DisplayName : dim.Name,
          IsTypeAlteringExpression: false,
          DataType: dim?.BuilderConfig?.DataType,
          IsAdditional: true,
          IsCustomExpression: dim?.IsCustomExpression,
          Id: dim.Id,
          QueryId: dim?.Props.QueryId || queryId,
          IsSourceCustomColumn: dim?.Props?.IsSourceCustomColumn,
          RangeFill: dim?.Props?.Dimension?.RangeFill,
          Description: dim?.Props?.Description,
        });
      } else if (dim?.BuilderConfig?.DataType === ColumnDataTypes.DateTime) {
        newBuilderDimensions.push({
          GroupByExpression: newDateExpr(
            dim?.DimensionProp?.Props?.BinningType as DateBinningFormatters,
            newColumnExpr(
              isDynamicField ? dim?.BuilderConfig?.DisplayName : dim.Name,
              updatedAlias,
              dim?.BuilderConfig?.DataType,
              dim?.BuilderConfig?.JoinID,
              dim?.BuilderConfig?.Entity,
            ),
          ),
          Alias: isDynamicField ? dim?.BuilderConfig?.DisplayName : dim.Name,
          IsTypeAlteringExpression: false,
          DataType: dim?.BuilderConfig?.DataType,
          IsAdditional: true,
          IsCustomExpression: dim?.IsCustomExpression,
          Id: dim.Id,
          QueryId: dim?.Props.QueryId || queryId,
          IsSourceCustomColumn: dim?.Props?.IsSourceCustomColumn,
          RangeFill: dim?.Props?.Dimension?.RangeFill,
          Description: dim?.Props?.Description,
        });
      } else if (dim?.Applied) {
        const columnExpr = newColumnExpr(
          isDynamicField ? dim.BuilderConfig.DisplayName : dim.Name,
          updatedAlias,
          dim?.BuilderConfig?.DataType,
          dim?.BuilderConfig?.JoinID,
          dim?.BuilderConfig?.Entity,
          !dim?.IsUserDynamicField,
        );
        // StringArray column data type check as 'Product' field is StringArray
        const isQueryField = !!dim?.BuilderConfig?.EntityName && dim.BuilderConfig.EntityName.length > 0;
        const shouldArrayJoin = dim?.BuilderConfig?.DataType === ColumnDataTypes.StringArray && !isQueryField;
        newBuilderDimensions.push({
          GroupByExpression: shouldArrayJoin ? newArrayJoinExpr(columnExpr) : columnExpr,
          Alias: isDynamicField ? dim.BuilderConfig.DisplayName : dim.Name,
          IsTypeAlteringExpression: false,
          DataType: dim?.BuilderConfig?.DataType,
          IsCustomExpression: dim?.IsCustomExpression || ((dim?.BuilderConfig?.EntityName || dim?.BuilderConfig?.Entity === ExpressionContext.Custom) ? dim.Props?.Dimension?.IsCustomExpression : false),
          IsAdditional: true,
          Id: dim.Id,
          QueryId: dim?.Props.QueryId || queryId,
          IsSourceCustomColumn: dim?.Props?.IsSourceCustomColumn,
          RangeFill: dim?.Props?.Dimension?.RangeFill,
          Description: dim?.Props?.Description,
        });
      }
    }
  });

  // Remove dimensions that are no longer applied
  const appliedDimensionIds = new Set(
    appliedDimensions
      ?.filter((dim) => dim.Applied !== DimensionStatus.NotApplied)
      ?.map((dim) => dim.Id) || [],
  );
  const linkedFieldId = linkedField?.Id ?? null;

  return newBuilderDimensions.filter(
    (item) => appliedDimensionIds.has(item.Id) || item.Id === linkedFieldId,
  );
};

export const getSavePayloadBuilderMeasures = (
  appliedMeasures: IColumn[],
  originalMeasures: IBuilderMeasure[],
  queryId?: string,
): IBuilderMeasure[] => {
  const builderMeasures: IBuilderMeasure[] = [];
  appliedMeasures?.forEach((measure) => {
    const original = originalMeasures?.find((m) => m.Id === measure.Id);
    if (isMeasureDynamic(measure)) {
      builderMeasures.push({
        Id: measure.Id,
        Alias: measure.Name,
        DataType: measure?.BuilderConfig?.DataType,
        MeasureExpression: { ...measure.Props.Measure.Expression },
        IsGrandTotal: false,
        DrillDownSettings: undefined,
        IsCustomExpression: measure?.Props?.Measure?.IsCustomExpression || measure?.Props?.IsSourceCustomColumn,
        IsAdditional: true,
        QueryId: measure.Props?.QueryId || queryId,
        IsSourceCustomColumn: measure?.Props?.IsSourceCustomColumn,
        Description: measure?.Props?.Description,
      });
    } else if (original) {
      builderMeasures.push({
        Id: original.Id,
        ...original,
        QueryId: measure?.Props?.QueryId || queryId,
        IsSourceCustomColumn: measure?.Props?.IsSourceCustomColumn,
        Description: measure?.Props?.Description ?? original?.Description,
      });
    }
  });

  if (isValidArrayAndNotEmpty(originalMeasures)) {
    originalMeasures.forEach((measure) => {
      const isAlreadyAdded = builderMeasures.find((m) => m.Id === measure.Id);
      const isUsed = appliedMeasures.find((m) => m.Id === measure.Id);

      if (!isAlreadyAdded && (!measure.IsAdditional || !!isUsed)) {
        const measureObj = appliedMeasures?.find((m) => m.Id === measure.Id);
        if (!measureObj && queryId) return;
        builderMeasures.push({
          Id: measure.Id,
          ...measure,
          QueryId: measureObj?.Props?.QueryId || queryId,
          IsSourceCustomColumn: false,
        });
      }
    });
  }

  return builderMeasures.filter((m) => !!m);
};

// Filter value based on the filter type (Part of the template)
// @item - Filter group part of the report raw config
// @appliedFilters - Filter response and data
export const getDefaultValue = (
  item: IFilterGroup,
  appliedFilters: ObjModel.ObjGeneric<FilterModel.IFilterResponse>,
) => {
  // For constituent filters (with AssociatedCustomFilterId), prefer the parent custom
  // filter's applied value — but only when that wrapper key actually exists in the
  // appliedFilters map. In a query-report (preview/save), the local appliedFilters is
  // keyed by the constituent's own ID (the sub-query treats the constituent as a
  // standalone filter), so the wrapper key is absent and we must fall back to item.ID.
  const appliedFilterKey = (item.AssociatedCustomFilterId && appliedFilters?.[item.AssociatedCustomFilterId])
    ? item.AssociatedCustomFilterId
    : item.ID;
  if (item.Render.Type === FilterType.UserMultiSelect) {
    return appliedFilters[appliedFilterKey]?.FilterResponse?.UserIds;
  }
  if (isLargeOptionSetFilter(item)) {
    return appliedFilters[appliedFilterKey]?.FilterResponse?.Values;
  }
  if (item.Render.Type === FilterType.PRE_APPLIED) {
    return item.Render.DefaultValue;
  }
  if (
    item.Render.Type === FilterType.LSQMetadataMultiSelect
    || item.Render.Type === FilterType.GroupMultiSelect
    || item.Render.Type === FilterType.CustomDefinedMultiSelect
  ) {
    return appliedFilters[appliedFilterKey]?.FilterResponse?.length
      === appliedFilters[appliedFilterKey]?.FilterOptions?.length
      ? null
      : appliedFilters[appliedFilterKey]?.FilterResponse;
  }

  if ((item.Render.Type === FilterType.NumberInteger || item.Render.Type === FilterType.NumberDecimal) && item.Operator !== OperatorTypes.BETWEEN) {
    return appliedFilters[appliedFilterKey]?.FilterResponse?.Value;
  }
  return appliedFilters[appliedFilterKey]?.FilterResponse;
};

// Update the filter default value and label of the filter group in report raw config
// @filterGroup - Filter group part of the report raw config
// @appliedFilters - Filter response and data
export const updateReportTemplateFilterBuilder = (
  filterGroup: IFilterGroup[],
  appliedFilters: ObjModel.ObjGeneric<FilterModel.IFilterResponse>,
  filterConfig: Array<IFilterConfig>,
  userFilterGroup:IFilterGroup,
  queryId?:string,
): IFilterGroup[] => {
  let relatedFilter: IFilterGroup = null;
  const containsUserFilter = isValidArrayAndNotEmpty(filterGroup) && filterGroup?.findIndex((item: IFilterGroup) => item?.Render?.Type === FilterType.UserMultiSelect && item.IsPrimaryUserFilter) > -1;
  if (!isEmpty(userFilterGroup)) filterGroup?.push(userFilterGroup);
  const result = ((filterGroup?.map((item: IFilterGroup) => {
    // Drop a constituent only when truly orphaned in filterConfig — neither the parent
    // custom filter wrapper nor the constituent itself is present. In a query report
    // (preview/save) the local filterConfig holds the constituent as a standalone row
    // (the wrapper is a main-report-level concept and isn't included), so the
    // wrapper-only check would wrongly drop it. Allowing a match by the constituent's
    // own ID keeps the row in the payload as the standalone filter for that query.
    if (item.AssociatedCustomFilterId
      && !filterConfig?.some((fc: IFilterConfig) => fc.ID === item.AssociatedCustomFilterId
        || fc.ID === item.ID)) {
      return null;
    }
    const filter = filterConfig?.find((filterItem: IFilterConfig) => item.ID === filterItem.ID);
    const linkedItem = filterConfig.find((linked) => linked.LinkedPreAppliedFilterId === item.ID);
    const joinId = linkedItem ? linkedItem?.JoinID : filter?.JoinID || item?.JoinID;
    if (filter) {
      if (userFilterGroup) {
        relatedFilter = filterGroup?.find((filterGroupItem:IFilterGroup) => filterGroupItem.Alias === item.Alias && filterGroupItem.ID !== item.ID);
      }
      const Status = item.Render.Type === FilterType.UserMultiSelect ? appliedFilters?.[item.ID]?.userStatus : undefined;
      return ({
        ...item,
        Alias: item.AlwaysEnabled && ((item.Render.Type === FilterType.UserMultiSelect && item.IsPrimaryUserFilter) || relatedFilter) && containsUserFilter ? userFilterGroup?.Alias || item.Alias : item.Alias,
        IsUserIDFilter: filter?.IsUserIDFilter ?? item?.IsUserIDFilter,
        JoinID: joinId,
        LinkedDimensionAlias: item.AlwaysEnabled && (item.Render.Type !== FilterType.UserMultiSelect && relatedFilter) && containsUserFilter ? userFilterGroup?.Alias : item.LinkedDimensionAlias,
        LinkedDimensionId: item.AlwaysEnabled && (item.Render.Type !== FilterType.UserMultiSelect && relatedFilter) && containsUserFilter ? userFilterGroup?.LinkedDimensionId : item.LinkedDimensionId,
        QueryId: filter.QueryId || queryId,
        Render: {
          ...item.Render,
          DefaultValue: getDefaultValue(item, appliedFilters),
          Label: appliedFilters[item.ID]?.label || item.Render.Label,
          ShowInMainReport: filter?.Render?.ShowInMainReport || false,
          LinkedQueryId: filter?.Render?.ShowInMainReport ? queryId : null,
          Metadata: {
            ...item.Render.Metadata,
            ...(Status ? { Status } : {}),
            // Sales Group hide-from-report-page is set on the FE filterConfig
            // entry's Metadata (reducer side); template-source filters merge
            // their Metadata from item.Render.Metadata (BE snapshot), so the
            // FE write must be pulled in explicitly here. Scoped strictly to
            // standalone main-report GroupMultiSelect — other filter types
            // and any sub-query filter (QueryId set) are untouched.
            ...(filter?.Type === FilterType.GroupMultiSelect && !filter?.QueryId
              ? { HideFromReportPage: !!filter?.Metadata?.HideFromReportPage }
              : {}),
          },
        },
      });
    }
    return null;
  })?.filter((group:IFilterGroup) => !isEmpty(group))) || []).filter(Boolean);

  return result;
};

// Update the sub filters default value and label of the filter group in report raw config (Part of the template)
// @subFilterArray - Sub Filter array part of the report raw config
// @appliedFilters - Filter response and data
export const getSubFilterBuilderConfig = (
  subFilterArray: Array<IBuilderFilter>,
  appliedFilters: ObjModel.ObjGeneric<FilterModel.IFilterResponse>,
  filterConfig: Array<IFilterConfig>,
  userFilterGroup?: IFilterGroup,
  queryId?: string,
) => {
  const a = cloneDeep(subFilterArray);
  a?.forEach((subFilter: IBuilderFilter) => {
    // eslint-disable-next-line no-param-reassign
    subFilter.FilterGroup = updateReportTemplateFilterBuilder(
      subFilter.FilterGroup,
      appliedFilters,
      filterConfig,
      userFilterGroup,
      queryId,
    );

    // eslint-disable-next-line no-param-reassign
    subFilter.SubFilters = getSubFilterBuilderConfig(
      subFilter.SubFilters,
      appliedFilters,
      filterConfig,
      userFilterGroup,
      queryId,
    );
  });
  return a;
};

// Returns updated filter group for the report raw config payload on save.
// @filterConfig - Configuration of the filter
// @appliedFilters - Filter response and data
// @filter - Filter group part of the report raw config
export const getSavePayloadBuilderFilters = (
  filterConfig: IFilterConfig[],
  appliedFilters: ObjModel.ObjGeneric<FilterModel.IFilterResponse>,
  filter: IBuilderFilter,
  queryId?: string,
): IBuilderFilter => {
  const nonAdditionalFilterGroup = filter?.FilterGroup?.filter((item) => item.IsAdditional !== true);
  const reportTemplateFilters = updateReportTemplateFilterBuilder(
    nonAdditionalFilterGroup,
    appliedFilters,
    filterConfig,
    null,
    queryId,
  );
  const filterGroupData = [
    ...reportTemplateFilters || [],
    ...getFilterGroupDetail(
      filterConfig?.filter((item) => item.IsDynamic === true),
      appliedFilters,
      queryId,
    ),
  ];
  const removedDuplicateItems = removeDuplicateObject(filterGroupData, 'ID', 'AssociatedCustomFilterId');
  const userFilterGroup = removedDuplicateItems?.find((item: IFilterGroup) => item.Render.Type === FilterType.UserMultiSelect && item.IsPrimaryUserFilter);

  const allFiltersWithoutPrimaryUserFilter = removedDuplicateItems?.filter((filterItem: IFilterGroup) => !(filterItem.Render.Type === FilterType.UserMultiSelect && filterItem.IsPrimaryUserFilter));

  const updatedFilterValuesList = allFiltersWithoutPrimaryUserFilter.map((filterItem: IFilterGroup) => {
    if (filterItem.Render.Type === FilterType.UserMultiSelect && !filterItem.IsPrimaryUserFilter) {
      const defaultData = filterItem.Render.DefaultValue;
      const status = filterItem.Render.Metadata?.Status || userStatusEnum.Both;
      return {
        ...filterItem,
        Render: {
          ...filterItem.Render,
          DefaultValue: getDefaultValue(filterItem, appliedFilters),
          DropdownMetaData: {
            DropdownSelectType: defaultData?.Type,
            UserStatusType: status,
          },
        },
      };
    }
    return filterItem;
  });

  return {
    FilterGroup: isValidArrayAndNotEmpty(updatedFilterValuesList) ? updatedFilterValuesList : [],
    GroupOperator: 'AND',
    SubFilters:
      filter?.SubFilters !== null
        ? getSubFilterBuilderConfig(filter?.SubFilters, appliedFilters, filterConfig, userFilterGroup, queryId)
        : null,
  };
};

// Create filter group part of report raw config for the additional filter added
// @filterConfig - Configuration of the filter
// @appliedFilters - Filter response and data
export const getFilterGroupDetail = (
  filterConfig: Array<IFilterConfig>,
  appliedFilters: ObjModel.ObjGeneric<FilterModel.IFilterResponse>,
  queryId?: string,
): IFilterGroup[] => {
  const builderFilters: Array<IFilterGroup> = [];
  // Skip IsCustomFilter UI entries — constituent filters are already in filterConfig
  // with AssociatedCustomFilterId set, so they're processed directly.
  const expandedFilterConfig = filterConfig.filter((c: IFilterConfig) => !c.IsCustomFilter);
  expandedFilterConfig.forEach((config: IFilterConfig) => {
    const {
      AlwaysEnabled,
      LinkedDimensionAlias,
      ID,
      Alias,
      JoinID,
      DataType,
      Type,
      Metadata,
      LinkedTo,
      Label,
      StyleConfig,
      IsDynamic,
      LinkedPreAppliedFilterId,
      LinkedDimensionId,
      QueryId,
      Render,
      IsLargeOptionSetField,
      IsPrimaryUserFilter,
      IsUserIDFilter,
      DropdownMetaData,
      DefaultValue,
      AssociatedCustomFilterId,
    } = config;

    // Prefer the parent custom filter's applied value only when that wrapper key
    // actually exists in the passed-in appliedFilters. In a SubBuilder context
    // (e.g. query preview/save) the wrapper lives only in the main report's
    // appliedFilters, so the SubBuilder's map is keyed by the constituent's own
    // ID — falling back to ID ensures the user's in-SubBuilder edit isn't lost.
    const appliedFilterKey = (AssociatedCustomFilterId && appliedFilters?.[AssociatedCustomFilterId])
      ? AssociatedCustomFilterId
      : ID;
    let value;

    if (
      Type === FilterType.LSQMetadataMultiSelect
      || Type === FilterType.GroupMultiSelect
      || Type === FilterType.CustomDefinedMultiSelect
    ) {
      if (IsLargeOptionSetField) {
        value = appliedFilters[appliedFilterKey]?.FilterResponse;
      } else {
        value = appliedFilters[appliedFilterKey]?.FilterResponse?.length
          === appliedFilters[appliedFilterKey]?.FilterOptions?.length
          ? null
          : appliedFilters[appliedFilterKey]?.FilterResponse;
      }
    } else if (NumberFilterTypes.includes(Type)) {
      const operator = appliedFilters[appliedFilterKey]?.FilterResponse?.Operator || DefaultNumberFilterOperator;
      if (operator === OperatorTypes.BETWEEN) {
        value = {
          Type: NumberFilterOperatorTypes.Absolute,
          Value: {
            From: appliedFilters[appliedFilterKey]?.FilterResponse?.Value.From,
            To: appliedFilters[appliedFilterKey]?.FilterResponse?.Value.To,
          },
        };
      } else if (operator === OperatorTypes.IS_NOT_NULL || operator === OperatorTypes.IS_NULL) {
        value = [];
      } else {
        value = appliedFilters[appliedFilterKey]?.FilterResponse?.Value ?? DefaultValue;
      }
    } else {
      value = appliedFilters[appliedFilterKey]?.FilterResponse;
    }
    builderFilters.push({
      LinkedDimensionAlias,
      AlwaysEnabled,
      ID,
      Alias,
      JoinID,
      DataType,
      IsAdditional: IsDynamic,
      Operator: getOperatorValue(Type, appliedFilters[appliedFilterKey]),
      LinkedDimensionId,
      QueryId: QueryId || queryId,
      IsLargeOptionSetField,
      IsPrimaryUserFilter,
      IsUserIDFilter,
      AssociatedCustomFilterId,
      Render: {
        ID,
        Type,
        DefaultValue: value,
        Metadata,
        LinkedTo: LinkedPreAppliedFilterId || LinkedTo,
        Label,
        StyleConfig,
        ShowInMainReport: Render?.ShowInMainReport,
        LinkedQueryId: Render?.ShowInMainReport ? Render?.LinkedQueryId : null,
        DropdownMetaData,
      },
    });
  });
  return builderFilters;
};

// Decides filter operator based on the filter type
// @Type - Filter Type
export const getOperatorValue = (Type: FilterType, appliedFilter: FilterModel.IFilterResponse) => {
  if (Type === FilterType.PRE_APPLIED) {
    return OperatorTypes.EQ;
  }
  if (Type === FilterType.DateRange) {
    return OperatorTypes.BETWEEN;
  }

  if (NumberFilterTypes.includes(Type)) {
    return appliedFilter?.FilterResponse?.Operator || DefaultNumberFilterOperator;
  }
  return OperatorTypes.IN;
};

// Convert to filter config based on the filter group of report raw  config
// @builderFilter - Filter group part of the report raw config
// @filterMetaInformation - Additional filter information shared inside the report template
export const filterBuilderToFilterConfig = (
  builderFilter: IBuilderFilter,
  filterMetaInformation?: IFilterMetaInfo[],
  partitionFilters?: Array<string>,
  isSubBuilder: boolean = false,
) => {
  const filterConfig: IFilterConfig[] = [];

  builderFilter?.FilterGroup?.forEach((filterItem: IFilterGroup) => {
    const {
      Render: {
        Label,
        DefaultValue,
        LinkedTo,
        ID,
        StyleConfig,
        Type,
        Metadata,
        ShowInMainReport,
        LinkedQueryId,
        DropdownMetaData,
      },
      LinkedDimensionId,
      LinkedDimensionAlias,
      Alias,
      JoinID,
      DataType,
      AlwaysEnabled,
      QueryId,
      IsAdditional,
      IsLargeOptionSetField,
      IsPrimaryUserFilter,
      IsUserIDFilter,
      Operator,
      AssociatedCustomFilterId,
    } = filterItem;

    const entityInfo: { [key: string]: IFilterMetaInfoStore } = filterMetaInformation?.reduce(
      (
        obj: { [key: string]: IFilterMetaInfoStore },
        item: IFilterMetaInfo,
      ) => {
        obj[item?.ID] = {
          Entity: item?.Entity,
          IsPartitionColumn: item?.IsPartitionColumn,
          Metadata: item?.Metadata,
          NamespaceEntity: item?.NamespaceEntity,
          NsDisplayName: item?.NsDisplayName,
          Namespace: item?.Namespace,
          LinkedTo: item?.LinkedTo,
          Label: item?.Label,
        };
        return obj;
      },
      {},
    );

    const config: IFilterConfig = {
      SchemaName: '',
      Label,
      DefaultValue,
      QueryId,
      ID,
      JoinID,
      LinkedTo: (entityInfo && entityInfo[ID]?.LinkedTo) || LinkedTo,
      StyleConfig,
      Type,
      LinkedDimensionAlias,
      IsDynamic: false,
      IsAdditional,
      Alias,
      Render: {
        ShowInMainReport,
        LinkedQueryId,
        DropdownMetaData,
      },
      LinkedDimensionId,
      Entity: entityInfo && entityInfo[ID]?.Entity,
      NamespaceEntity: entityInfo && entityInfo[ID]?.NamespaceEntity,
      Namespace: entityInfo && entityInfo[ID]?.Namespace,
      NsDisplayName: entityInfo && entityInfo[ID]?.NsDisplayName,
      IsRemoved: false,
      IsMasked: false,
      DataType,
      Metadata: entityInfo && entityInfo[ID]?.Metadata
        ? { ...entityInfo[ID]?.Metadata }
        : { ...Metadata },
      AlwaysEnabled,
      IsPartitionColumn: (entityInfo && entityInfo[ID]?.IsPartitionColumn) || (partitionFilters && partitionFilters.includes(ID)),
      IsLargeOptionSetField,
      IsPrimaryUserFilter,
      IsUserIDFilter,
      DropdownMetaData,
      ...(Operator ? { Operator } : {}),
      ...(AssociatedCustomFilterId ? { AssociatedCustomFilterId } : {}),
    };
    if (isSubBuilder) {
      if (ShowInMainReport) {
        config.IsAdditional = false;
        if (ID && entityInfo && isValidObjectAndNotEmpty(entityInfo[ID])) {
          config.Label = entityInfo[ID]?.Label;
        }
        filterConfig.push(config);
      }
    } else {
      filterConfig.push(config);
    }
  });
  if (builderFilter?.SubFilters !== null) {
    builderFilter?.SubFilters?.forEach((subFilter: IBuilderFilter) => {
      const subFiltersArray = filterBuilderToFilterConfig(
        subFilter,
        filterMetaInformation,
        null,
        isSubBuilder,
      );
      filterConfig.push(...subFiltersArray);
    });
  }

  return filterConfig;
};

// Returns applied filter based on the filter group of report raw  config
// @state - Report builder state
// @variables - can be fetched from the auth store
export const getAppliedFilterFromTemplate = (
  state: IReportBuilderState,
  variables?: IVariables,
  reportFilterConfig?: IFilterConfig[],
  filterMetaInfoType?: UserFilterPayloadType,
) => {
  const newAppliedFilters: ObjModel.ObjGeneric<FilterModel.IFilterResponse> = {};
  const fetchFilter = new FilterFetchUtility(variables);
  const filterConfig = reportFilterConfig || getFilterConfigFromTemplate(state.updatedReportBuilderInfo.reportBuilderSavePayload, state.filterBuilder.filterMetaInfo);

  filterConfig.forEach((item) => {
    const userFilterPayload = item.Type === FilterType.UserMultiSelect && item.IsPrimaryUserFilter
      ? {
        Type: filterMetaInfoType || UserFilterPayloadType.All,
        UserIds: item.DefaultValue,
      }
      : {
        Type: item.DropdownMetaData?.DropdownSelectType || UserFilterPayloadType.All,
        UserIds: item.DefaultValue,
      };

    newAppliedFilters[item.ID] = fetchFilter.GetDefaultSingleFilter(
      item,
      item.Type === FilterType.UserMultiSelect
        ? userFilterPayload
        : item.DefaultValue,
    );
    newAppliedFilters[item.ID] = {
      ...newAppliedFilters[item.ID],
      label: item.Label,
    };
  });

  return newAppliedFilters;
};

export const getDimensionProps = (
  dim: IDimension,
  props: IColumnProperties,
): IColumnDimension => ({
  ...props?.Dimension,
  Applied: dim?.Applied,
  Orderable: dim?.Orderable,
  DimensionProp: dim.IsCustomExpression ? undefined : dim?.DimensionProp,
  DimensionMode: dim?.DimensionMode,
  Expression: dim?.Expression,
  IsCustomExpression: dim.IsCustomExpression,
  CustomEntity: dim.IsCustomExpression ? FieldEntitiesType.Custom : undefined,
});

// Return the unapplied Custom Measures from report builder State
// @expressionStore: Report Builder Expression Store
// @payload: Updated Measure Info
export const getUnappliedCustomMeasures = (expressionStore: ObjModel.ObjGeneric<ICustomExpression>):IColumn[] => {
  const unAppliedCustomMeasures:IColumn[] = [];

  Object.keys(expressionStore || {}).forEach((expKey) => {
    if (expressionStore[expKey].Mode === ColumnModes.NotApplied) { // all the unapplied ones will have the mode 3(Not Applied)
      const exp = expressionStore[expKey];
      const unapppliedCusMes = buildCustomMeasure(exp.displayName, exp.Mode, exp.jsonExpression, exp.uniqueId, exp.Formatter, exp.DataType, undefined, undefined, exp.description);
      delete unapppliedCusMes.BuilderConfig;
      unAppliedCustomMeasures.push(unapppliedCusMes);
    }
  });

  return unAppliedCustomMeasures;
};

// Generate the report raw config which is payload for the report builder save.
export const getSaveReportConfigPayload = (state?:IReportBuilderState): IReportConfig => {
  const newState = cloneDeep(state) || store.getState().reportBuilder as IReportBuilderState;
  const partitionColumnFilterDateLimit = store?.getState()?.settings?.data?.Configuration[ModuleName.ReportBuilder].Settings?.Filter?.StringFieldPartitionFilterLimit;
  const template = newState.updatedReportBuilderInfo.selectedTemplate;
  const savePayloadReportConfig: IReportConfig = cloneDeep(newState.updatedReportBuilderInfo.reportBuilderSavePayload);
  let defaultBuilderMeasures: IBuilderMeasure[] = [];
  const allFilters = newState.filterBuilder.filterConfig.filter(
    (config: IFilterConfig) => config.IsRemoved !== true && !config?.ShowInMainReport,
  );
  const appliedDimensions = newState.updatedReportBuilderInfo.appliedDimensions;
  let appliedUserDimension = null as IDimension;
  const { customFilterDefinitions } = newState.filterBuilder;

  // drop broken custom variable measures
  if (savePayloadReportConfig?.Visualization?.Type === VisualizationTypes.ComboChart) {
    newState.updatedReportBuilderInfo.appliedMeasures = excludeBrokenComboMeasures(
      newState.updatedReportBuilderInfo.appliedMeasures,
      newState.updatedReportBuilderInfo.expressionStore,
      customFilterDefinitions,
    );
  }
  const addedBuilderFilter = newState.filterBuilder.filterConfig.filter((config: IFilterConfig) => {
    if (config.IsRemoved === true || config.ShowInMainReport) return false;
    // Exclude SubBuilder constituent filters — they belong in SubBuilders[].Filter, not main Builder[].Filter
    if (config.AssociatedCustomFilterId && config.QueryId) {
      const parentDef = customFilterDefinitions.find((d) => d.ID === config.AssociatedCustomFilterId);
      const linkedInfo = parentDef?.LinkedFilters?.find((lf) => lf.FilterId === config.ID);
      if (linkedInfo?.Source === LinkedFilterSource.SubBuilder) return false;
    }
    return true;
  });

  const primaryUserFilter = addedBuilderFilter.find((filItem: IFilterConfig) => filItem.Type === FilterType.UserMultiSelect && filItem.IsPrimaryUserFilter);
  if (primaryUserFilter) {
    appliedUserDimension = appliedDimensions.find((dim: IDimension) => primaryUserFilter.LinkedDimensionId === dim.Id);
  }
  let newAppliedFilters = newState?.filterBuilder?.appliedFilters;
  if (isStringFieldApplied(appliedDimensions)) {
    newAppliedFilters = getUpdatedAppliedFiltersForPartitionColumn(
      newState.filterBuilder.filterConfig,
      newAppliedFilters,
      partitionColumnFilterDateLimit,
    );
  }

  savePayloadReportConfig.Builder = savePayloadReportConfig.Builder.map(
    (item, builderIdx) => {
      defaultBuilderMeasures = [...defaultBuilderMeasures, ...item.Select.Measures || []];
      if (savePayloadReportConfig?.CalculatedColumns) {
        defaultBuilderMeasures = defaultBuilderMeasures.concat(savePayloadReportConfig.CalculatedColumns).flat();
      }
      const isUnionType = isValidArrayAndNotEmpty(item?.Joins) ? isUnionJoinType(item?.Joins) : false;
      return ({
        ...item,
        CustomHierarchies: newState?.updatedReportBuilderInfo?.customHierarchies,
        UnionConfig: isUnionType ? getUnionConfigFromJoins(item.Joins, item.Namespace) : null,
        Select: {
          ...item.Select,
          Dimensions: getSavePayloadBuilderDimensions(
            newState.updatedReportBuilderInfo.appliedDimensions,
            [
              ...newState.updatedReportBuilderInfo.selectedTemplate.ReportConfig
                .Builder[0].Select.Dimensions,
            ],
            newState?.filterBuilder?.filterConfig,
          ),
          Measures: [...getSavePayloadBuilderMeasures(
            newState.updatedReportBuilderInfo.appliedMeasures,
            template.ReportConfig.Builder[builderIdx].Select.Measures, // TODO: Find by namespace, not by index.
          ),

          ],
        },
        Filter: getSavePayloadBuilderFilters(
          addedBuilderFilter,
          newAppliedFilters,
          template.ReportConfig.Builder[builderIdx].Filter,
        ),
        Hierarchy: getReportHierarchy(appliedUserDimension, item?.Hierarchy),
      });
    },
  );

  try {
    if (isValidArrayAndNotEmpty(savePayloadReportConfig.SubBuilders)) {
      savePayloadReportConfig.SubBuilders = savePayloadReportConfig.SubBuilders.map((builder) => {
        const {
          templateFilters, appliedFilters, queryConfig, queryAppliedDimensions,
        } = getQueryInfo(builder.QueryId, newState.reportQueryBuilder);
        let queryNewAppliedFilters = appliedFilters;
        if (isStringFieldApplied(queryAppliedDimensions)) {
          queryNewAppliedFilters = getUpdatedAppliedFiltersForPartitionColumn(
            templateFilters,
            appliedFilters,
            partitionColumnFilterDateLimit,
          );
        }
        const queryId = builder.QueryId;
        return {
          ...builder,
          Filter: getSavePayloadBuilderFilters(
            templateFilters,
            queryNewAppliedFilters,
            queryConfig?.ReportConfig?.Builder[0].Filter,
            queryId,
          ),
        };
      });
    }
  } catch (err) {
    console.error(err);
  }
  const dimensions = getSavePayloadDimensionColumns(
    newState.updatedReportBuilderInfo.appliedDimensions,
    newState?.filterBuilder?.filterConfig,
    null,
    isListReport(newState?.updatedReportBuilderInfo.reportBuilderSavePayload?.Builder[0]?.Type),
  );

  const measures = getSavePayloadMeasureColumns(
    newState.updatedReportBuilderInfo.appliedMeasures,
    getDefaultMeasures(defaultBuilderMeasures, template.ReportConfig.Columns),
    template.ReportConfig,
  );

  savePayloadReportConfig.Columns = [...dimensions, ...measures];
  savePayloadReportConfig.Sorting = newState?.updatedReportBuilderInfo?.sortState;
  savePayloadReportConfig.DimensionsMetaFields = getSavePayloadDimensionMetafields(
    state,
    savePayloadReportConfig.DimensionsMetaFields,
    newState.updatedReportBuilderInfo.appliedDimensions,
    true,
    newState.updatedReportBuilderInfo.entityGroupStore,
    newState.updatedReportBuilderInfo.entityGroupOptionsMap,
    newState.reportQueryBuilder.SelectedQuery,
  );

  const filterMetaData = getFilterMetaDataInfo(
    allFilters,
    newAppliedFilters,
    newState.reportQueryBuilder.DynamicQueryList,
    isValidArrayAndNotEmpty(newState.reportQueryBuilder.DynamicQueryList),
    newState.updatedReportBuilderInfo?.reportBuilderSavePayload?.FiltersMetadata,
  );

  savePayloadReportConfig.FiltersMetadata = filterMetaData || newState.updatedReportBuilderInfo.reportBuilderSavePayload.FiltersMetadata;
  savePayloadReportConfig.CustomFilterDefinitions = newState.filterBuilder.customFilterDefinitions;

  // Resolve each custom filter definition's Operator at save time (custom-filter-expressions
  // feature; independent of UseVar). By now the constituent filters' operators are fully resolved,
  // so mirror that resolution for the wrapper: read a representative constituent's Type and run it
  // through getOperatorValue (dropdown → IN, date → BETWEEN, number → the selected operator). This
  // is the same helper that stamps Operator on every constituent in the Builder payload, so the
  // definition stays consistent — and a freshly-added dropdown (no value yet at add-time) still
  // gets IN. DataType/DefaultValue are kept current reactively in the reducer.
  savePayloadReportConfig.CustomFilterDefinitions.forEach((def) => {
    const constituent = def.LinkedFilters
      ?.map((lf) => newState.filterBuilder.filterConfig.find((f) => f.ID === lf.FilterId))
      .find(Boolean);
    if (constituent) {
      def.Operator = getOperatorValue(constituent.Type, newState.filterBuilder.appliedFilters[def.ID]);
    }
    // Keep the definition's DefaultValue current with the latest applied value so preview/save
    // ships the up-to-date value (mirrors the report-page path in report.util.ts). Only refresh
    // when an applied value exists for this custom filter; otherwise leave the saved default intact.
    const appliedValue = newState.filterBuilder.appliedFilters?.[def.ID]?.FilterResponse;
    if (appliedValue !== undefined) {
      def.DefaultValue = appliedValue;
    }
    // Backfill the FilterKey-derived fields from the fully-resolved render entry so every save
    // keeps the definition self-contained — including reports saved before these fields existed
    // (their render entry is rebuilt from the FilterKey constituent on load).
    const renderEntry = newState.filterBuilder.filterConfig.find((f) => f.ID === def.ID);
    if (renderEntry) {
      def.IsLargeOptionSetField = renderEntry.IsLargeOptionSetField;
      def.Metadata = renderEntry.Metadata;
    }
  });

  // Funnel charts: drop a stale funnelDimensionId / funnelMeasureId that points to a dimension or
  // measure the user has since removed (or hidden) from the report, before it is serialized into
  // Builder.Properties. The save payload and the live preview share this builder, so both surfaces
  // stay consistent with the report's current columns.
  if (savePayloadReportConfig?.Visualization?.Type === VisualizationTypes.FunnelChart
    && savePayloadReportConfig?.Visualization?.Builder?.Properties) {
    savePayloadReportConfig.Visualization.Builder.Properties = reconcileFunnelAttributes(
      savePayloadReportConfig.Visualization.Builder.Properties,
      newState.updatedReportBuilderInfo.appliedDimensions,
      newState.updatedReportBuilderInfo.appliedMeasures,
      newState.updatedReportBuilderInfo.expressionStore,
      newState.filterBuilder.customFilterDefinitions,
    );
  }

  savePayloadReportConfig.Visualization = getUpdateVisualization(
    savePayloadReportConfig?.Visualization?.DisplayName,
    savePayloadReportConfig?.Visualization?.Type,
    savePayloadReportConfig?.Visualization?.Builder?.Properties,
    savePayloadReportConfig?.Visualization?.DrilldownConfigMapping,
    savePayloadReportConfig?.Visualization?.DrilldownConfigIdMapping,
    savePayloadReportConfig?.Visualization?.DrilldownPagination,
    savePayloadReportConfig?.Builder[0]?.Type,
    savePayloadReportConfig?.Visualization?.ConditionalFormatting,
    newState.updatedReportBuilderInfo.linkedReportsConfig,
    savePayloadReportConfig?.Visualization?.Builder as ReportResponseModel.IChartVisualizationBuilder,
  );

  hydrateWithCustomFilters(
    savePayloadReportConfig,
    newState.filterBuilder.customFilterDefinitions,
    newState.filterBuilder.appliedFilters,
  );

  return savePayloadReportConfig;
};

// Resolves a linked filter by finding its source, stamping AssociatedCustomFilterId,
// and pushing it to filterConfig if not already there. Preserves the picker-supplied
// Source / Origin verbatim — the picker is authoritative per the ruleset:
//   QueryId populated                 → Source = SubBuilder, Origin = AppliedFilter
//   No QueryId but EntityName set     → Source = MainReport, Origin = AppliedDimension
//   Neither                           → Source = MainReport, Origin = AppliedFilter
// Used by both ADD_CUSTOM_FILTER and UPDATE_CUSTOM_FILTER reducers.
// Immer-only: must only be called from within a Redux Toolkit reducer
export const resolveAndLinkFilter = (
  state: IReportBuilderState,
  lf: ILinkedFilterInfo,
  filterId: string,
  additionalFilters: IFilterConfig[],
): ILinkedFilterInfo => {
  const linkedId = lf.FilterId;

  // Branch 1: filter is already in main filterConfig — stamp AssociatedCustomFilterId
  // in place. Also tag SubBuilder QueryPayload if applicable.
  const existingIndex = state.filterBuilder.filterConfig.findIndex((f) => f.ID === linkedId);
  if (existingIndex !== -1) {
    const existing = state.filterBuilder.filterConfig[existingIndex];
    existing.AssociatedCustomFilterId = filterId;
    // Linking a previously-removed filter as a constituent semantically re-applies it.
    // Without this, the entry stays soft-deleted and gets stripped from the save payload,
    // which drops the custom filter's constituent values out of the preview/fetch request.
    if (existing.IsRemoved) existing.IsRemoved = false;
    if (lf.Source === LinkedFilterSource.SubBuilder && lf.QueryId) {
      const query = (state.reportQueryBuilder.DynamicQueryList || []).find((q) => q.Id === lf.QueryId);
      const fg = query?.QueryPayload?.Filter?.FilterGroup?.find((f) => f.ID === linkedId);
      if (fg) fg.AssociatedCustomFilterId = filterId;
    }
    return { ...lf, Label: existing.Label || lf.Label };
  }

  if (lf.Source === LinkedFilterSource.SubBuilder && lf.QueryId) {
    // Branch 2: resolve from SubBuilder's QueryPayload.Filter.FilterGroup and push a
    // copy into main filterConfig. Preserves lf.Origin (expected: AppliedFilter).
    const query = (state.reportQueryBuilder.DynamicQueryList || []).find((q) => q.Id === lf.QueryId);
    const fg = query?.QueryPayload?.Filter?.FilterGroup?.find((f) => f.ID === linkedId);
    if (fg) {
      fg.AssociatedCustomFilterId = filterId;
      const {
        Label, Type, DefaultValue, Metadata, DropdownMetaData: renderDropdownMetaData,
      } = fg.Render || {};
      state.filterBuilder.filterConfig.push({
        ...fg,
        Label,
        Type,
        DefaultValue,
        Metadata,
        QueryId: query.Id,
        DropdownMetaData: fg.DropdownMetaData || renderDropdownMetaData,
        IsDynamic: true,
        AssociatedCustomFilterId: filterId,
      });
      return { ...lf, Label: Label || lf.Label };
    }
  } else {
    // Branch 3: resolve from main report additionalFilters (dimension pool) and push a
    // new entry into filterConfig. Preserves lf.Origin (expected: AppliedDimension for
    // query-dimension-derived entries via EntityName, AppliedFilter for main standalone).
    //
    // additionalFilters can contain MULTIPLE entries with the same ID — e.g. a single
    // Filter-Id surfaces once per joined entity (User CreatedOn vs Lead CreatedOn under
    // the same schema-level Filter-Id). The picker drops dimension-derived duplicates
    // when a SubBuilder applied filter already represents the same field, so a naive
    // find-by-ID here would pick the entry the picker rejected and bind the constituent
    // to the wrong namespace. Mirror the picker rule below so the resolved candidate
    // matches what the user actually selected.
    const allMatches = (additionalFilters || []).filter((f) => f.ID === linkedId);
    const queryIds = (state.reportQueryBuilder?.DynamicQueryList || [])
      .map((q) => q.Id)
      .filter(Boolean) as string[];
    const stripQueryIdSuffix = (id?: string) => {
      if (!id) return id;
      const matched = queryIds.find((qid) => id.endsWith(`_${qid}`));
      return matched ? id.slice(0, -(matched.length + 1)) : id;
    };
    const queryAppliedLinkedDimensionIds = new Set<string>();
    (state.reportQueryBuilder?.DynamicQueryList || []).forEach((q) => {
      (q?.QueryPayload?.Filter?.FilterGroup || []).forEach((fg) => {
        if (fg.LinkedDimensionId) queryAppliedLinkedDimensionIds.add(fg.LinkedDimensionId);
      });
    });
    const sourceFilter = allMatches.find((f) => {
      if (!f.EntityName) return true;
      const normalized = stripQueryIdSuffix(f.LinkedDimensionId);
      return !(normalized && queryAppliedLinkedDimensionIds.has(normalized));
    }) || allMatches[0];
    if (sourceFilter) {
      state.filterBuilder.filterConfig.push({
        ...sourceFilter,
        IsDynamic: true,
        AssociatedCustomFilterId: filterId,
      });
      return { ...lf, Label: sourceFilter.Label || lf.Label };
    }
  }

  return lf;
};

// Hydrates the save payload with custom filter metadata:
// 1. Sets AssociatedCustomFilterId and updated DefaultValue on constituent filters
//    that are part of a custom filter definition (both main Builder and SubBuilder).
// 2. Removes orphaned AssociatedCustomFilterId from filters that are no longer
//    part of any custom filter definition (e.g., filter was unlinked but the key
//    persisted from a previous save).
export const hydrateWithCustomFilters = (
  savePayload: IReportConfig,
  definitions: ICustomFilterDefinition[],
  appliedFilters: ObjModel.ObjGeneric<FilterModel.IFilterResponse>,
): void => {
  // Build a set of all constituent filter IDs from current definitions
  const constituentFilterIds = new Set<string>();
  if (isValidArrayAndNotEmpty(definitions)) {
    definitions.forEach((def) => {
      def.LinkedFilters.forEach((lf) => {
        const resolvedFilterId = resolveFilterIDInCaseOfQueryIdPresent(lf.FilterId, lf?.QueryId);
        constituentFilterIds.add(resolvedFilterId);
      });
    });
  }

  // Flat list of all filter items across Builder and SubBuilders
  const allFilterItems: IFilterGroup[] = [
    ...(savePayload.Builder?.flatMap((b) => b.Filter?.FilterGroup || []) || []),
    ...(savePayload.SubBuilders?.flatMap((sb) => sb.Filter?.FilterGroup || []) || []),
  ];

  // Clean up: remove orphaned AssociatedCustomFilterId from filters
  // that are no longer linked to any custom filter definition
  allFilterItems.forEach((fg) => {
    const resolvedFilterIdWithQuery = resolveFilterIDInCaseOfQueryIdPresent(fg.ID, fg?.QueryId);
    if (fg.AssociatedCustomFilterId && !constituentFilterIds.has(resolvedFilterIdWithQuery)) {
      delete fg.AssociatedCustomFilterId;
    }
  });

  // Stamp: set AssociatedCustomFilterId and custom filter value on constituent filters
  if (!isValidArrayAndNotEmpty(definitions)) return;

  definitions.forEach((def) => {
    const customApplied = appliedFilters[def.ID]?.FilterResponse;
    if (!customApplied) return;

    def.LinkedFilters.forEach((lf) => {
      // Match by exact ID, or with _{QueryId} suffix (SubBuilder filter IDs include the suffix)
      let matchingItems: IFilterGroup[] = [];
      if (lf?.QueryId) {
        // Match on the query-resolved id. A SubBuilder constituent carries its query identity
        // either as a `_{QueryId}` suffix on its ID (no QueryId field) or as a QueryId field on
        // a bare ID — both normalise to the same suffixed id here. Additionally requiring
        // fg.QueryId === lf.QueryId would miss the suffix-only case (fg.QueryId undefined).
        matchingItems = allFilterItems.filter((fg) => {
          const resolvedFilterIdWithqueryId = resolveFilterIDInCaseOfQueryIdPresent(fg.ID, fg?.QueryId);
          const resolvedLinkedFilterIdWithQueryId = resolveFilterIDInCaseOfQueryIdPresent(lf.FilterId, lf?.QueryId);
          return resolvedFilterIdWithqueryId === resolvedLinkedFilterIdWithQueryId;
        });
      } else {
        matchingItems = allFilterItems.filter((fg) => fg.ID === lf.FilterId
        || (lf.QueryId && fg.ID === `${lf.FilterId}_${lf.QueryId}`));
      }
      if (!isValidArrayAndNotEmpty(matchingItems)) return;

      // A query-applied LOS constituent has copies in BOTH the main Builder FilterGroup and
      // its SubBuilders FilterGroup under the same _{QueryId}-suffixed ID, and the SubBuilder
      // copy is the one that drives the sub-query. find() stamps only the first match (the
      // main-builder copy, since Builder items are concatenated before SubBuilder items) and
      // leaves the SubBuilder copy stale — so the saved/previewed report ignored the latest
      // selection. For LOS constituents stamp every copy; all other constituent types keep
      // the original single-match behaviour (no duplicate copies in play for them).
      const isLos = matchingItems.some((fg) => isLargeOptionSetFilter(fg));
      const itemsToStamp = isLos ? matchingItems : [matchingItems[0]];

      itemsToStamp.forEach((filterItem) => {
        filterItem.AssociatedCustomFilterId = def.ID;

        if (filterItem.Render.Type === FilterType.UserMultiSelect) {
          // Use UserStatus from the custom filter definition, not the constituent's own metadata
          const status = def.UserStatus || filterItem.Render.Metadata?.Status || userStatusEnum.Both;
          filterItem.Render.DefaultValue = customApplied?.UserIds;
          filterItem.Render.DropdownMetaData = {
            DropdownSelectType: customApplied?.Type,
            UserStatusType: status,
          };
        } else if (
          (filterItem.Render.Type === FilterType.NumberInteger
            || filterItem.Render.Type === FilterType.NumberDecimal)
          && filterItem.Operator !== OperatorTypes.BETWEEN
        ) {
          // Mirror getDefaultValue's Number branch — a standalone number filter stores
          // Render.DefaultValue as the raw value (FilterResponse.Value), not the
          // { Operator, Value } envelope. Without this unwrap, constituents would
          // ship the envelope and diverge from the standalone payload shape.
          filterItem.Render.DefaultValue = customApplied?.Value;
        } else {
          filterItem.Render.DefaultValue = customApplied;
        }
      });
    });
  });
};

const getQueryInfo = (queryId: string, queryBuilder: IQueryBuilder) => {
  const queryList = queryBuilder.DynamicQueryList;
  const queryInfo = queryList.find((query) => query.Id === queryId);
  const queryConfigData = queryInfo.QueryDataInfo?.updatedInfo?.filterBuilder?.filterConfig?.filter((item) => item.IsRemoved !== true);
  if (isValidObjectAndNotEmpty(queryInfo)) {
    const appliedFilters = queryInfo.QueryDataInfo?.updatedInfo?.filterBuilder?.appliedFilters;
    const queryAppliedDimensions = queryInfo.QueryDataInfo?.updatedInfo?.AppliedDimensions;
    return {
      templateFilters: queryConfigData,
      appliedFilters,
      queryConfig: queryInfo.QueryConfig,
      queryAppliedDimensions,
    };
  }
  return {};
};

// Returns the filter meta data info based on the newly added filter.
// @addedFiltersConfig - Filter config of the newly added filter
// @appliedFilters - Filter response and data
export const getFilterMetaDataInfo = (
  addedFiltersConfig: IFilterConfig[],
  appliedFilters: ObjModel.ObjGeneric<FilterModel.IFilterResponse>,
  queryList?: IQueryInfo[],
  isQueryExists?: boolean,
  originalFiltersMetadata?: IFiltersMetaData,
) => {
  const userFilterId = addedFiltersConfig?.find(
    (config) => config.Type === FilterType.UserMultiSelect && config.IsPrimaryUserFilter,
  )?.ID || '';
  const subBuilderFiltersMetadata: SubBuilderFiltersMetadata[] = [];
  if (isQueryExists && isValidArrayAndNotEmpty(queryList)) {
    queryList.forEach((query) => {
      const subBuilderFiltersMetadataForCurrQuery = isValidObjectAndNotEmpty(originalFiltersMetadata) ? originalFiltersMetadata?.SubBuilderFiltersMetadata?.find((metadata) => metadata.QueryId === query?.Id) : null;
      const queryFilterBuilder = query?.QueryDataInfo?.updatedInfo?.filterBuilder;
      const appliedUserFilterId = isValidArrayAndNotEmpty(queryFilterBuilder?.filterConfig) ? queryFilterBuilder?.filterConfig.find((filter) => filter.Type === FilterType.UserMultiSelect && filter?.IsPrimaryUserFilter)?.ID : '';
      if (appliedUserFilterId) {
        subBuilderFiltersMetadata.push({
          UserDropdownSelectType: queryFilterBuilder?.UserDropdownSelectType,
          FilterId: appliedUserFilterId,
          QueryId: query?.Id,
        });
      } else if (!isValidObjectAndNotEmpty(query?.QueryDataInfo?.updatedInfo) && isValidObjectAndNotEmpty(subBuilderFiltersMetadataForCurrQuery)) {
        subBuilderFiltersMetadata.push(subBuilderFiltersMetadataForCurrQuery);
      }
    });
  }
  if (userFilterId) {
    const DropdownValueType = appliedFilters[userFilterId].FilterResponse.Type;
    return {
      UserDropdownSelectType: DropdownValueType,
      SubBuilderFiltersMetadata: subBuilderFiltersMetadata,
    };
  }
  if (isValidArrayAndNotEmpty(subBuilderFiltersMetadata)) {
    return {
      UserDropdownSelectType: UserFilterPayloadType.All,
      SubBuilderFiltersMetadata: subBuilderFiltersMetadata,
    };
  }
  return null;
};

// Reset user and group filters on a filter builder when UserContext changes.
// Clears DefaultValue, FilterResponse, FilterOptions, shouldLoad and UserDropdownSelectType
// so that filters are re-fetched for the new context.
export const resetFilterBuilderInStoreDueToUserContextChange = (filterBuilder: IFilterBuilder) => {
  filterBuilder.UserDropdownSelectType = undefined;
  filterBuilder.filterConfig.forEach((filter) => {
    if (filter.Type === FilterType.UserMultiSelect || filter.Type === FilterType.GroupMultiSelect) {
      filter.DefaultValue = [];
      if (filterBuilder.appliedFilters[filter.ID]) {
        // UserMultiSelect needs a valid FilterResponse shape so downstream code
        // (getDefaultValue, getSelectedValueCountForUserFilter) doesn't crash on null access.
        // GroupMultiSelect uses null so getValueForMultiSelect selects all options after re-fetch.
        filterBuilder.appliedFilters[filter.ID].FilterResponse = filter.Type === FilterType.UserMultiSelect
          ? { Type: 'ALL', UserIds: null }
          : null;
        filterBuilder.appliedFilters[filter.ID].FilterOptions = [];
        filterBuilder.appliedFilters[filter.ID].shouldLoad = true;
      }
    }
  });
};

// When UserContext changes (e.g. Sales → All), the UserMultiSelect and GroupMultiSelect
// filters in the save payload (Builder.Filter / SubBuilders.Filter / QueryPayload.Filter)
// hold stale DefaultValues from the previous context. This function recursively walks
// the FilterGroup and SubFilters tree and resets DefaultValue to null so the filters
// are re-evaluated with the new user context on the next load.
// @builderFilter - The IBuilderFilter node (with FilterGroup and SubFilters) to reset.
export const updateSalesGroupAndUserFiltersInPayloadDueToUserContextChange = (builderFilter: IBuilderFilter) => {
  if (!builderFilter) return;
  if (isValidArrayAndNotEmpty(builderFilter.FilterGroup)) {
    builderFilter.FilterGroup.forEach((fg) => {
      if (fg.Render?.Type === FilterType.UserMultiSelect || fg.Render?.Type === FilterType.GroupMultiSelect) {
        fg.Render.DefaultValue = null;
      }
    });
  }
  if (isValidArrayAndNotEmpty(builderFilter.SubFilters)) {
    builderFilter.SubFilters.forEach((sf) => updateSalesGroupAndUserFiltersInPayloadDueToUserContextChange(sf));
  }
};

// When a ShowInMainReport query filter is changed from the main report, this function
// updates the corresponding DefaultValue in the SubBuilder's Filter payload tree
// (FilterGroup + SubFilters) so that the save/preview payload carries the latest value
// even when QueryDataInfo has not been initialised (user never visited the subquery page).
// @builderFilter - The SubBuilder's IBuilderFilter node to walk.
// @filterId - The filter ID to match against FilterGroup[].ID.
// @filterValue - The raw FilterResponse value from the filter change action.
// @filterType - The FilterType of the changed filter.
export const updateQueryFilterDefaultValueInSubBuilderPayload = (
  builderFilter: IBuilderFilter,
  filterId: string,
  filterValue: any,
  filterType: FilterType,
) => {
  if (!builderFilter) return;
  if (isValidArrayAndNotEmpty(builderFilter.FilterGroup)) {
    builderFilter.FilterGroup.forEach((fg) => {
      if (fg.ID === filterId || (fg.Render && fg.Render?.ID === filterId)) {
        fg.Render.DefaultValue = getSerializedDefaultValue(filterValue, filterType, fg.IsLargeOptionSetField, fg.Operator);
      }
    });
  }
  if (isValidArrayAndNotEmpty(builderFilter.SubFilters)) {
    builderFilter.SubFilters.forEach((sf) => updateQueryFilterDefaultValueInSubBuilderPayload(sf, filterId, filterValue, filterType));
  }
};

// Extracts the serialized DefaultValue from a FilterResponse, mirroring the logic in getDefaultValue.
// @filterValue - The raw FilterResponse value.
// @filterType - The FilterType of the filter.
// @isLargeOptionSetField - Whether the filter is a large option set field.
// @operator - The operator of the filter (for number filters).
const getSerializedDefaultValue = (
  filterValue: any,
  filterType: FilterType,
  isLargeOptionSetField: boolean,
  operator: string,
) => {
  if (filterType === FilterType.UserMultiSelect) {
    return filterValue?.UserIds;
  }
  if (isLargeOptionSetField) {
    return filterValue?.Values;
  }
  if (NumberFilterTypes.includes(filterType) && operator !== OperatorTypes.BETWEEN) {
    return filterValue?.Value;
  }
  return filterValue;
};

// Overlays the main report's current filter values onto a subquery's appliedFilters
// for all ShowInMainReport filters. Used when initialising a subquery for the first
// time (QueryConfig was null) so the subquery picks up values the user set at the
// main report level instead of stale template defaults.
// @subQueryFilterBuilder - The subquery's filterBuilder (filterConfig + appliedFilters).
// @mainAppliedFilters - The main report's state.filterBuilder.appliedFilters.
export const overlayMainReportFilterValues = (
  subQueryFilterBuilder: IFilterBuilder,
  mainAppliedFilters: ObjModel.ObjGeneric<FilterModel.IFilterResponse>,
) => {
  if (!subQueryFilterBuilder?.filterConfig || !mainAppliedFilters) return;
  subQueryFilterBuilder.filterConfig.forEach((filterCfg) => {
    if (filterCfg.Render?.ShowInMainReport && mainAppliedFilters[filterCfg.ID]) {
      subQueryFilterBuilder.appliedFilters[filterCfg.ID] = {
        ...subQueryFilterBuilder.appliedFilters[filterCfg.ID],
        FilterResponse: mainAppliedFilters[filterCfg.ID].FilterResponse,
      };
    }
  });
};

// if the save fails, reset the filter to template value
// @savePayloadReportConfig - report builder save config
// @state - Report builder state
export const resetFilterOnFailure = (
  savePayloadReportConfig: IReportConfig,
  state: IReportBuilderState,
) => {
  // TODO: Augmented filter to be taken care
  const templateFilter = state.updatedReportBuilderInfo.selectedTemplate.ReportConfig.Builder[0]
    .Filter;
  // eslint-disable-next-line no-param-reassign
  savePayloadReportConfig.Builder = savePayloadReportConfig.Builder.map(
    (item: IBuilder) => ({
      ...item,
      Filter: templateFilter,
    }),
  );
  return savePayloadReportConfig;
};

// Return the updated State on additional Dimension success.
// @state: Report Builder State
// @payload: Additional dimension API response
export const getAppliedDimensionsOnSuccess = (
  state: IReportBuilderState,
  payload: IColumn[],
  isSubQuery?: boolean,
): IDimension[] => {
  const newState = state;
  let appliedDimensions;
  if (isSubQuery) {
    appliedDimensions = newState.reportQueryBuilder.SelectedQueryData.updatedInfo.AppliedDimensions;
  } else {
    appliedDimensions = newState.updatedReportBuilderInfo.appliedDimensions;
  }

  const dynamicDimensions = payload?.map(
    (dim: IColumn) => ({
      Applied: DimensionStatus.NotApplied,
      Orderable: dim.Props?.Dimension?.Orderable,
      ZeroAnchor: dim.Props?.Dimension?.ZeroAnchor,
      DimensionMode: dim.Props?.Dimension?.DimensionMode,
      BuilderConfig: {
        ...(dim.BuilderConfig?.Entity === ExpressionContext.Custom
          ? {
            ...dim.BuilderConfig,
            uniqueKey: dim.BuilderConfig?.SchemaName,

          } : dim.BuilderConfig),
      },
      Name: dim.Props?.ReferTo
        ? dim?.Name
        : dim?.BuilderConfig?.DisplayName || dim?.Name, // handling for dynamic meta fields by checking referToCol
      IsMasked: dim.Props.IsMasked,
      DimensionProp: dim.Props?.Dimension?.DimensionProp,
      Mode: dim.Props?.Mode,
      ReferTo: dim.Props?.ReferTo,
      ParentDimension: dim.Props?.ParentDimension,
      Props: dim.Props,
      IsUserDynamicField: dim?.Props?.IsUserDynamicField,
      Id: dim.Id,
    } as IDimension),
  ) || [];
  const combinedDimensions = [...appliedDimensions, ...dynamicDimensions];
  const uniqueDimensions = combinedDimensions?.filter(
    (value, index, self) => index === self.findIndex((dim) => dim.Id === value.Id),
  ) || [];
  // Reorder the unique dimensions
  const finalDimensions = reorderAppliedDimensions(uniqueDimensions);
  return finalDimensions;
};

// Return the updated State on change grouping order.
// @state: Report Builder State
// @payload: Updated grouping info
export const getStateOnSetGrouping = (
  state: IReportBuilderState,
  payload: ISetGroupingPayload,
): IReportBuilderState => {
  const newState = state;
  const {
    sourceIndex, status, mode, destinationIndex, isSwapEnabled, customDimension,
  } = payload;

  let updatedSource = sourceIndex;

  let newAppliedDimensions = newState.updatedReportBuilderInfo.appliedDimensions;
  const expressionStore = newState.updatedReportBuilderInfo.expressionStore;
  const entityGroupStore = newState.updatedReportBuilderInfo.entityGroupStore;

  // If customDimension is provided, use it directly instead of looking up from appliedDimensions
  let dimension: IDimension;
  if (customDimension) {
    const correspondingDimensionDetailsInAppliedDimensions = newAppliedDimensions.find((dim) => dim.Id === customDimension.Id);
    if (isValidObjectAndNotEmpty(correspondingDimensionDetailsInAppliedDimensions)) {
      dimension = { ...correspondingDimensionDetailsInAppliedDimensions, ...customDimension };
      if (isCustomHierarchyColumnOrDimension(dimension) && isDateTypeOfField(dimension)) {
        dimension.DimensionProp = {
          ...dimension.DimensionProp,
          Props: {
            ...dimension.DimensionProp?.Props,
            BinningType: DateBinningFormatters.NONE,
          },
        };
      }
    } else {
      dimension = customDimension;
    }
  } else {
    if (!newAppliedDimensions[updatedSource]?.BuilderConfig) {
      // For source we have to reorder the metafields in the list
      updatedSource = newAppliedDimensions.findIndex((dim, index) => index >= updatedSource && dim?.BuilderConfig);
    }
    dimension = newAppliedDimensions[updatedSource]; // source dimension
  }
  const desDimension = newAppliedDimensions[destinationIndex]; // destination dimension

  // if date-time field is added in column grouping
  if (
    status === DimensionStatus.Applied
    && mode === DimensionMode.ColumnGroup
    && dimension.DimensionProp?.Props.BinningType === DateBinningFormatters.NONE
    && !isCustomHierarchyColumnOrDimension(dimension) // custom hierarchy dimensions do not support binning type for date fields, i.e. bininng type is None.
  ) {
    dimension = {
      ...dimension,
      DimensionProp: {
        ...dimension.DimensionProp,
        Props: {
          ...dimension.DimensionProp.Props,
          BinningType: DateBinningFormatters.DATE_YEAR,
        },
      },
      Props: {
        ...dimension.Props,
        Dimension: {
          ...dimension.Props.Dimension,
          DimensionProp: {
            ...dimension.Props.Dimension.DimensionProp,
            Props: {
              ...dimension.Props.Dimension.DimensionProp.Props,
              BinningType: DateBinningFormatters.DATE_YEAR,
            },
          },
        },
      },
    };
  }

  // A column group dimension cannot be hidden.
  // When a field becomes a pivot via drag/swap, clear hide on it AND on its ReferTo target for meta fields
  const clearHideForColumnGroup = (dim: IDimension) => {
    if (!dim || dim.DimensionMode !== DimensionMode.ColumnGroup) return;
    const unhide = (target?: IDimension) => {
      if (target && target.Mode === ColumnModes.Hidden) {
        target.Mode = ColumnModes.Sortable;
        if (target.Props) target.Props.Mode = ColumnModes.Sortable;
      }
    };
    const referToId = dim.Props?.ReferTo || dim.ReferTo;
    if (referToId) {
      // meta field: the user-hide lives on the referenced _meta column
      unhide(newAppliedDimensions.find((d: IDimension) => d?.Id === referToId));
    } else {
      // regular dimension holds its own hide state
      unhide(dim);
    }
  };

  // if swapping is there, then before applying changes to source dimension, we should swap its values in
  // destination dimension.
  if (isSwapEnabled) {
    // if destination dimension is mandatory applied , then it should remain mandatory applied only,
    // if swapped to row grouping
    const desDimStatus = getDestinationDimensionStatus(desDimension, dimension);
    if (desDimension) {
      desDimension.Applied = desDimStatus;
      desDimension.DimensionMode = dimension?.DimensionMode;
      clearHideForColumnGroup(desDimension);
    }
  }
  // making state changes to source dimension (applicable for all cases)
  dimension.Applied = status;
  dimension.DimensionMode = mode;
  clearHideForColumnGroup(dimension);

  // swapping source dimension with destination dimension in case of swapping true
  if (isSwapEnabled) {
    newAppliedDimensions[destinationIndex] = dimension;
    newAppliedDimensions[updatedSource] = desDimension;
  }

  // change position of dimension to putBeforeIndex only in case of addition(no swapping)
  if (destinationIndex !== undefined && !isSwapEnabled) {
    newAppliedDimensions = newAppliedDimensions.filter((dim) => !areDimensionsEqual(dim, dimension));
    newAppliedDimensions.splice(destinationIndex, 0, dimension);
  }
  // At the time of deletion for custom Dimension the destination index will be zero
  if (destinationIndex === undefined && dimension.BuilderConfig?.Entity === FieldEntitiesType.Custom && dimension.IsCustomExpression) {
    newAppliedDimensions = [...newAppliedDimensions.filter((dim: IDimension) => dim?.Id !== dimension?.Id)];
    delete expressionStore[dimension.BuilderConfig.uniqueKey];
  }
  // At the time of deletion for entity group Dimension the destination index will be zero
  if (destinationIndex === undefined
    && isEntityGrouped(dimension)
    && dimension?.Id in entityGroupStore) {
    delete entityGroupStore[dimension?.Id];

    // find if there is at least 1 field persisting in the applied dimensions
    const originalDimensionIndex = getOriginalDimensionIndex(newAppliedDimensions, dimension);
    if (originalDimensionIndex > -1) newAppliedDimensions = [...newAppliedDimensions.filter((dim: IDimension) => !(dim?.Id === dimension?.Id || dim?.Props?.ParentDimension === dimension?.Id))];
  }

  /**
   * If a custom column, that had been not been created using custom column expression ( added with custom group button in the earlier features of reports),
   * is being removed, then we need to remove it completely from the applied dimensions list.
   * Else if the column has been created via the Custom columns section, then we can retain the field in the applied dimensions.
   * This is to ensure that the custom groupings created in earlier reports do not affect the custom columns created in the current report feature.
   */
  if (dimension.BuilderConfig?.Entity === FieldEntitiesType.Custom && status === DimensionStatus.NotApplied && destinationIndex === undefined) {
    const existingCustomColumns = cloneDeep(newState.updatedReportBuilderInfo?.expressionStore);
    if (!(isValidObjectAndNotEmpty(existingCustomColumns) && existingCustomColumns[dimension.BuilderConfig.Alias])) {
      newAppliedDimensions = newAppliedDimensions.filter((dim) => dim.Id !== dimension.Id);
    }
    dimension.Applied = DimensionStatus.NotApplied;
  }

  /**
   * If a custom hierarchy column is being removed, then we need to re-instate the columns back to the available dimensions
   */
  if (isCustomHierarchyColumnOrDimension(dimension) && status === DimensionStatus.NotApplied && destinationIndex === undefined) {
    const primaryDimInCustomHierarchy = newAppliedDimensions.find((dim) => dim.Id === dimension.Id);
    newAppliedDimensions = newAppliedDimensions.filter((dim) => dim.Id !== primaryDimInCustomHierarchy.Id);
    primaryDimInCustomHierarchy.Applied = DimensionStatus.NotApplied;
    /**
     * Before removing the custom hierarchy column ( which is essentially the parent column ) and re-instating that column in available dimensions,
     * the name needs to be updated to the original dimension name instead of the custom hierarchy name.
     */
    if (isValidArrayAndNotEmpty(newState.updatedReportBuilderInfo?.customHierarchies)) {
      const currentCustomHierarchy = newState?.updatedReportBuilderInfo?.customHierarchies?.[0];
      primaryDimInCustomHierarchy.Name = currentCustomHierarchy.ColumnsByID?.[primaryDimInCustomHierarchy?.Id]?.Column?.Name;
    }
    newAppliedDimensions.push(primaryDimInCustomHierarchy);
  }

  newAppliedDimensions = reOrderDimensions(newAppliedDimensions);

  // Remove columnId from conditional formatting rules when:
  // 1. A row-grouping dimension is unapplied (status === NotApplied)
  // 2. A dimension is swapped from row-grouping to column-grouping (conditional formatting not supported for column-grouping)
  const shouldRemoveFromConditionalFormatting = status === DimensionStatus.NotApplied
    || (mode === DimensionMode.ColumnGroup);
  if (shouldRemoveFromConditionalFormatting && dimension?.Id) {
    const columnIdToRemove = dimension.Id;
    const currentRules = cloneDeep(newState.updatedReportBuilderInfo.reportBuilderSavePayload.Visualization?.ConditionalFormatting?.Rules) ?? [];
    const updatedRules = currentRules.map((rule) => ({
      ...rule,
      ColumnsIds: rule.ColumnsIds?.filter((colId) => colId !== columnIdToRemove) || [],
    })).filter((rule) => rule.ColumnsIds.length > 0); // Remove rules with no columns
    if (isEmpty(newState.updatedReportBuilderInfo.reportBuilderSavePayload.Visualization?.ConditionalFormatting)) {
      newState.updatedReportBuilderInfo.reportBuilderSavePayload.Visualization.ConditionalFormatting = {
        Enabled: true,
        Rules: updatedRules,
      };
    } else {
      newState.updatedReportBuilderInfo.reportBuilderSavePayload.Visualization.ConditionalFormatting.Rules = updatedRules;
    }
  }

  if (shouldRemoveFromConditionalFormatting && dimension?.Id) {
    const builder = newState.updatedReportBuilderInfo.reportBuilderSavePayload.Visualization.Builder as ReportResponseModel.IChartVisualizationBuilder;
    if (builder?.XAxis?.Columns) {
      builder.XAxis.Columns = builder.XAxis.Columns.filter((id) => id !== dimension.Id);
    }
  }

  if (status === DimensionStatus.NotApplied && dimension?.Id) {
    const removedDimId = dimension.Id;
    const updatedLinkedReportsConfig = newState.updatedReportBuilderInfo.linkedReportsConfig.map((cfg) => {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { [removedDimId]: _removed, ...remainingDimensions } = cfg.LinkingConfig.Dimensions;
      return { ...cfg, LinkingConfig: { ...cfg.LinkingConfig, Dimensions: remainingDimensions } };
    });
    newState.updatedReportBuilderInfo.linkedReportsConfig = updatedLinkedReportsConfig;
    newState.updatedReportBuilderInfo.reportBuilderSavePayload.Visualization.LinkedReportsConfig = updatedLinkedReportsConfig;
  }

  // AC: keep at least one row grouping visible. If removing the visible one left every applied row group
  // hidden, unhide the first one's displayed column (reuses existing hide helpers) so a grouping always shows.
  const appliedRowGroups = newAppliedDimensions.filter((d) => d?.Applied !== DimensionStatus.NotApplied
    && d?.DimensionMode === DimensionMode.RowGroup && !d?.Props?.ParentDimension);
  if (appliedRowGroups.length && appliedRowGroups.every((d) => isColumnUserHidden(d, newAppliedDimensions))) {
    const target = getHideTargetColumn(appliedRowGroups[0], newAppliedDimensions);
    if (target?.Props) {
      (target as IDimension).Mode = ColumnModes.Sortable;
      target.Props.Mode = ColumnModes.Sortable;
    }
  }
  newState.updatedReportBuilderInfo.appliedDimensions = newAppliedDimensions;
  newState.updatedReportBuilderInfo.expressionStore = expressionStore;
  newState.updatedReportBuilderInfo.entityGroupStore = entityGroupStore;
  const isReportListType = isListReport(state.updatedReportBuilderInfo.reportBuilderSavePayload?.Builder[0]?.Type);
  newState.updatedReportBuilderInfo.sortState = rebuildSortState(
    newState.updatedReportBuilderInfo.sortState,
    newState.updatedReportBuilderInfo.appliedDimensions,
    newState.updatedReportBuilderInfo.appliedMeasures,
    [],
    false,
    false,
    isReportListType,
  );

  const rowGroupingDimensions = newAppliedDimensions.filter((dim) => dim.DimensionMode === DimensionMode.RowGroup && dim.Applied === DimensionStatus.Applied);
  if (rowGroupingDimensions.length > MaxRowGroupingDimensionsToAllowSubTotals) {
    newState.updatedReportBuilderInfo.reportBuilderSavePayload.Visualization.Builder = {
      ...newState.updatedReportBuilderInfo.reportBuilderSavePayload.Visualization.Builder,
      Properties: {
        ...newState.updatedReportBuilderInfo.reportBuilderSavePayload.Visualization.Builder?.Properties,
        showSubTotals: false,
      },
    };
  }

  return newState;
};

export const createNewQuery = (state: IReportBuilderState, payload: ICreateNewQueryPayload) => {
  state.reportQueryBuilder.SelectedQuery = payload?.QueryId;
  state.reportQueryBuilder.SelectedQueryData = cloneDeep(initialReportBuilderState.reportQueryBuilder.SelectedQueryData);
  state.reportQueryBuilder.SelectedQueryData.QueryJoinRelation = payload?.QueryJoinRelation;
  state.reportQueryBuilder.DataSourceMapping = {
    ...state.reportQueryBuilder.DataSourceMapping,
    [payload?.QueryId]: {
      Joins: [],
      PrimaryNamespace: '',
      JoinBlockIndexBeingEdited: payload?.JoinIndexBeingEdited,
      isEditMode: false,
      isDataSourceSaved: false,
    },
  };
  state.reportQueryBuilder.DynamicQueryList = [...state.reportQueryBuilder.DynamicQueryList, {
    Id: payload?.QueryId,
    Name: `Query ${state.reportQueryBuilder.DynamicQueryList.length + 1}`,
    ParentQueryId: payload?.QueryJoinRelation?.ParentQueryId,
    QueryPayload: null,
    LinkedQueryIds: [],
    Type: SubQueryReportType.Summary,
    QueryJoinRelation: payload?.QueryJoinRelation,
    IsDraft: true,
    QueryDataInfo: null,
  }];

  const breadcrumbsData = state.reportQueryBuilder.BreadcrumbData.map((breadcrumb) => ({
    ...breadcrumb,
    isActive: false,
  }));

  const length = breadcrumbsData.length;
  if (length > 0 && breadcrumbsData[length - 1].type === SubQueryPanelType.dataSource) {
    breadcrumbsData[length - 1].label = `${breadcrumbsData[length - 1].label} + ${state.reportQueryBuilder.DynamicQueryList?.slice(-1)?.pop()?.Name}`;
  }

  const breadcrumbItem = {
    label: `Query ${state.reportQueryBuilder.DynamicQueryList.length}`,
    isActive: false,
    queryId: state.reportQueryBuilder.SelectedQuery,
    type: SubQueryPanelType.query,
  };

  state.reportQueryBuilder.BreadcrumbData = [...breadcrumbsData, breadcrumbItem];
};

// Return the updated State on change grouping order for subQuery.
// @state: Report Builder State
// @payload: Updated grouping info
export const getStateOnSetGroupingForSubQuery = (
  state: IReportBuilderState,
  payload: ISetGroupingPayload,
): IReportBuilderState => {
  const newState = state;
  const {
    sourceIndex, destinationIndex, status,
  } = payload;
  let updatedSource = sourceIndex;
  const selectedQueryData = newState.reportQueryBuilder.SelectedQueryData;
  let newAppliedDimensions = selectedQueryData.updatedInfo.AppliedDimensions;
  const expressionStore = selectedQueryData.updatedInfo.ExpressionStore;

  if (!newAppliedDimensions[updatedSource]?.BuilderConfig) {
    // For source we have to reorder the metafields in the list
    updatedSource = newAppliedDimensions.findIndex((dim, index) => index >= updatedSource && dim?.BuilderConfig);
  }

  const dimension = newAppliedDimensions[updatedSource]; // source dimension
  dimension.Applied = status;
  // change position of dimension to putBeforeIndex only in case of addition(no swapping)
  if (destinationIndex !== undefined) {
    newAppliedDimensions = newAppliedDimensions.filter((dim) => !areDimensionsEqual(dim, dimension));
    newAppliedDimensions.splice(destinationIndex, 0, dimension);
  }
  // At the time of deletion for custom Dimension the destination index will be zero
  if (destinationIndex === undefined && dimension.BuilderConfig?.Entity === FieldEntitiesType.Custom && dimension.IsCustomExpression) {
    // newAppliedDimensions = [...newAppliedDimensions.filter((dim: IDimension) => dim?.Id !== dimension?.Id)];
    if (!dimension?.Props?.IsSourceCustomColumn) {
      delete expressionStore[dimension.BuilderConfig.uniqueKey];
    }
  }

  newAppliedDimensions = reOrderDimensionsForSubQuery(newAppliedDimensions);

  selectedQueryData.updatedInfo.AppliedDimensions = newAppliedDimensions;
  selectedQueryData.updatedInfo.ExpressionStore = expressionStore;
  selectedQueryData.updatedInfo.sortState = rebuildSortState(
    selectedQueryData.updatedInfo.sortState,
    selectedQueryData.updatedInfo.AppliedDimensions,
    selectedQueryData.updatedInfo.AppliedMeasures,
    [],
    false,
  );
  newState.reportQueryBuilder.SelectedQueryData = selectedQueryData;

  return newState;
};

// Return the updated State on dimension binning change.
// @state: Report Builder State
// @payload: Updated dimension info
export const getStateOnBinningChange = (
  state: IReportBuilderState,
  payload: ISetDimensionsBinningPayload,
): IReportBuilderState => {
  const newState = state;
  const { value, index } = payload;
  const newAppliedDimensions = newState.updatedReportBuilderInfo.appliedDimensions;
  const newAppliedDimension = newAppliedDimensions[index];
  newAppliedDimension.DimensionProp.Props.BinningType = value;
  newAppliedDimension.Props.Dimension.DimensionProp.Props.BinningType = value;
  newAppliedDimensions[index] = newAppliedDimension;
  newState.updatedReportBuilderInfo.appliedDimensions = newAppliedDimensions;
  return newState;
};

// Return the updated State on dimension binning change for subQuery.
// @state: Report Builder State
// @payload: Updated dimension info
export const getStateOnBinningChangeForSubQuery = (
  state: IReportBuilderState,
  payload: ISetDimensionsBinningPayload,
): IReportBuilderState => {
  const newState = state;
  const { value, index } = payload;
  const newAppliedDimensions = newState.reportQueryBuilder?.SelectedQueryData?.updatedInfo?.AppliedDimensions;
  const newAppliedDimension = newAppliedDimensions[index];
  newAppliedDimension.DimensionProp.Props.BinningType = value;
  newAppliedDimension.Props.Dimension.DimensionProp.Props.BinningType = value;
  newAppliedDimensions[index] = newAppliedDimension;
  newState.reportQueryBuilder.SelectedQueryData.updatedInfo.AppliedDimensions = newAppliedDimensions;
  return newState;
};
// Return the updated State on add measure.
// @state: Report Builder State
// @payload: Updated Measure Info
export const getStateOnAddMeasure = (
  state: IReportBuilderState,
  payload: IAddMeasurePayload,
): IReportBuilderState => {
  const { index, status } = payload;
  const {
    reportBuilderInfo: { additionalMeasures },
  } = state;
  if (index < 0 || index >= additionalMeasures.length) {
    return state;
  }

  const newMeasures = [...state.updatedReportBuilderInfo.appliedMeasures];
  const measure = additionalMeasures[index];
  const calculatedMeasuresList = state.updatedReportBuilderInfo.selectedTemplate.ReportConfig.CalculatedColumns;
  const isCalculated = fromPairs((calculatedMeasuresList || []).map((column) => [column?.Alias, true]));
  const isCalulatedMeasure = isCalculated[measure.Name];

  const updatedName = isMeasureDynamic(measure)
    ? validateAndAppendCountToName(measure, newMeasures)
    : measure.Name;

  const newMeasure = {
    ...measure,
    Name: updatedName,
    Id: getDuplicateMeasuresDetails(measure, newMeasures)?.sameMeasureCount > 0 ? uuidv4() : measure.Id,
    Props: {
      ...measure.Props,
      Mode: status,
      Measure: {
        ...measure.Props.Measure,
        Name: updatedName,
        JoinID: measure.Props.Measure.IsPreDefined ? measure.Props?.Measure?.JoinID || '' : measure?.BuilderConfig?.JoinID || '',
      },
      DrilldownEnabled: getIsDrilldownEnabledFlag(state, measure, isCalulatedMeasure),
    },
    BuilderConfig: {
      ...measure.BuilderConfig,
      DisplayName: updatedName,
    },
  };
  newMeasures.push(newMeasure);

  const newExprStore = updateExpressionStore(state, newMeasure, status);

  const drilldownConfigMapping = updateDrilldownConfigMapping(state, newMeasure, isCalulatedMeasure);
  const newState: IReportBuilderState = {
    ...state,
    updatedReportBuilderInfo: {
      ...state.updatedReportBuilderInfo,
      appliedMeasures: newMeasures,
      expressionStore: newExprStore,
      drilldownConfigInfo: {
        ...state.updatedReportBuilderInfo.drilldownConfigInfo,
        drilldownConfigMapping,
      },
    },
  };
  return getStateOnRebuildSortState(newState);
};

// Return the updated State on add measure for SubQuery.
// @state: Report Builder State
// @payload: Updated Measure Info
export const getStateOnAddMeasureForSubQuery = (
  state: IReportBuilderState,
  payload: IAddMeasurePayload,
): IReportBuilderState => {
  const { index, status } = payload;
  const {
    reportQueryBuilder: { SelectedQueryData: { additionalData: { AdditionalMeasures } } },
  } = state;
  if (index < 0 || index >= AdditionalMeasures.length) {
    return state;
  }

  const newMeasures = [...state.reportQueryBuilder?.SelectedQueryData?.updatedInfo?.AppliedMeasures];
  const measure = AdditionalMeasures[index];
  const calculatedMeasuresList: IBuilderMeasure[] = [];
  const isCalculated = fromPairs((calculatedMeasuresList || []).map((column) => [column?.Alias, true]));
  const isCalulatedMeasure = isCalculated[measure.Name];
  const updatedName = isMeasureDynamic(measure)
    ? validateAndAppendCountToName(measure, newMeasures)
    : measure.Name;

  const newMeasure: IColumn = {
    ...measure,
    Name: updatedName,
    Id: getDuplicateMeasuresDetails(measure, newMeasures)?.sameMeasureCount > 0 ? uuidv4() : measure.Id,
    Props: {
      ...measure.Props,
      Mode: status,
      Measure: {
        ...measure.Props.Measure,
        Name: updatedName,
        JoinID: measure.Props.Measure.IsPreDefined ? measure.Props?.Measure?.JoinID || '' : measure?.BuilderConfig?.JoinID || '',
      },
      DrilldownEnabled: getIsDrilldownEnabledFlag(state, measure, isCalulatedMeasure),
      QueryId: measure.Props?.QueryId,
    },
    BuilderConfig: {
      ...measure.BuilderConfig,
      DisplayName: updatedName,
    },
  };
  const expression = cloneDeep(newMeasure.Props?.Measure?.Expression);
  newMeasure.Props.Measure.Expression = expression;
  newMeasures.push(newMeasure);

  const newExprStore = updateExpressionStoreForSubQuery(state, newMeasure, status);

  const newState: IReportBuilderState = {
    ...state,
    reportQueryBuilder: {
      ...state.reportQueryBuilder,
      SelectedQueryData: {
        ...state.reportQueryBuilder?.SelectedQueryData,
        updatedInfo: {
          ...state.reportQueryBuilder?.SelectedQueryData?.updatedInfo,
          AppliedMeasures: newMeasures,
          ExpressionStore: newExprStore,
        },
      },
    },
  };

  return getStateOnRebuildSortStateForSubQuery(newState);
};

// updates drilldownConfigMapping to incorporate the newly added measure
// @state: Report Builder State
// @newMeasure: column
// @isCalulatedMeasure: boolean specifying if it is a calculatedColumn
const updateDrilldownConfigMapping = (state: IReportBuilderState, newMeasure: IColumn, isCalulatedMeasure:boolean) => {
  const drilldownConfigMapping = state.updatedReportBuilderInfo.drilldownConfigInfo.drilldownConfigMapping;
  const builderMeasuresList = builderMeasuresListSelector({ reportBuilder: state } as IGlobalState);
  let expr = newMeasure?.Props?.Measure?.Expression;
  if (!expr) {
    const currentMeasure = builderMeasuresList.find((builderMeasure: IBuilderMeasure) => builderMeasure.Id === newMeasure.Id);
    expr = currentMeasure?.MeasureExpression;
  }
  const isDrilldownDisabled = isCalulatedMeasure || !isDrilldownPossible(expr);
  if (isDrilldownDisabled) {
    return drilldownConfigMapping;
  }

  const defaultEntity = getDefaultEntity(state?.updatedReportBuilderInfo?.selectedTemplate?.ReportConfig);
  return groupByJoinIdAndEntity(
    state?.reportBuilderInfo.fields,
    newMeasure,
    state?.updatedReportBuilderInfo?.drilldownConfigInfo?.drilldownConfigMapping,
    state?.updatedReportBuilderInfo?.appliedMeasures,
    defaultEntity,
  );
};
// computes the DrilldownEnabled flag for the specified measure
// @state: Report Builder State
// @measure: column
// @isCalulatedMeasure: boolean specifying if it is a calculated column
const getIsDrilldownEnabledFlag = (state: IReportBuilderState, measure: IColumn, isCalulatedMeasure: boolean) => {
  if (isCalulatedMeasure || !state?.updatedReportBuilderInfo?.drilldownConfigInfo?.enableDrilldown) {
    return false;
  }
  if (measure?.Props?.Measure?.IsPreDefined) {
    return measure?.Props.AllowDrillDown;
  }
  return isDrilldownPossible(measure?.Props?.Measure?.Expression);
};
// updates the expression store with status property for the specified measure
// @state: Report Builder State
// @measure: column
// status: ColumnMode
const updateExpressionStore = (state: IReportBuilderState, measure: IColumn, status:ColumnModes) => {
  const newExprStore = { ...state.updatedReportBuilderInfo.expressionStore };
  if (isMeasureCustom(measure) && newExprStore[measure.BuilderConfig?.uniqueKey]) {
    newExprStore[measure.BuilderConfig.uniqueKey] = {
      ...newExprStore[measure.BuilderConfig.uniqueKey],
      Mode: status,
    };
  }
  return newExprStore;
};

// updates the expression store with status property for the specified measure for subQuery
// @state: Report Builder State
// @measure: column
// status: ColumnMode
const updateExpressionStoreForSubQuery = (state: IReportBuilderState, measure: IColumn, status:ColumnModes) => {
  const newExprStore = { ...state.reportQueryBuilder?.SelectedQueryData?.updatedInfo?.ExpressionStore };
  if (isMeasureCustom(measure) && newExprStore[measure.BuilderConfig?.uniqueKey]) {
    newExprStore[measure.BuilderConfig.uniqueKey] = {
      ...newExprStore[measure.BuilderConfig.uniqueKey],
      Mode: status,
    };
  }
  return newExprStore;
};

// Return the updated State on removing measure.
// @state: Report Builder State
// @payload: Updated Measure Info
export const getStateOnRemoveMeasure = (
  state: IReportBuilderState,
  payload: IRemoveMeasurePayload,
): IReportBuilderState => {
  const { index } = payload;

  const newMeasures = [...state.updatedReportBuilderInfo.appliedMeasures];
  if (index < 0 || index >= newMeasures.length) return state;

  const remMeasure = newMeasures.splice(index, 1)[0];
  const newExprStore = { ...state.updatedReportBuilderInfo.expressionStore };
  let remMeasureEntity = remMeasure.Props.Measure?.Entity;
  let remMeasureJoinId = remMeasure.Props.Measure?.JoinID;
  if (isMeasureCustom(remMeasure) && newExprStore[remMeasure.BuilderConfig?.uniqueKey]) {
    // If the measure to be removed is not derived from any custom column expression, then it must be a custom value, so delete it from the store
    // Else it must be derived from the custom column expression, so don't delete the original custom column expression from the store.
    // if (!Object.keys(newExprStore)?.some((exprKey) => remMeasure?.BuilderConfig?.Alias === exprKey)) {
    //   delete newExprStore[remMeasure.BuilderConfig.uniqueKey];
    // }

    if (!remMeasure?.Props?.IsSourceCustomColumn) {
      delete newExprStore[remMeasure.BuilderConfig.uniqueKey];
    }

    const defaultEntity = getDefaultEntity(state?.updatedReportBuilderInfo?.selectedTemplate?.ReportConfig);
    const fieldsData = fieldSelectors({ reportBuilder: state } as IGlobalState);
    const { Entity, JoinId } = getEntityJoinIdForCustomMeasure(fieldsData, remMeasure, defaultEntity);
    remMeasureEntity = Entity;
    remMeasureJoinId = JoinId;
  }

  const targetMeasure = {
    Name: remMeasure?.Name, JoinId: remMeasureJoinId || '', Entity: remMeasureEntity, Id: remMeasure?.Id,
  };
  const { newConfigMapping, newConfigColumns } = removeMeasureFromDrilldownConfigMapping(state.updatedReportBuilderInfo.drilldownConfigInfo, targetMeasure);
  // Remove measure from conditional formatting rules and filter out empty rules
  const currentRules = cloneDeep(state.updatedReportBuilderInfo?.reportBuilderSavePayload?.Visualization?.ConditionalFormatting?.Rules) || [];

  const updatedRules = currentRules.map((rule) => ({
    ...rule,
    ColumnsIds: rule.ColumnsIds?.filter((colId:string) => colId !== remMeasure.Id) || [],
  }))
    .filter((rule) => rule.ColumnsIds.length > 0);

  const updatedLinkedReportsConfig = state.updatedReportBuilderInfo.linkedReportsConfig
    .map((cfg) => ({
      ...cfg,
      MeasureIdList: cfg.MeasureIdList.filter((id) => id !== remMeasure.Id),
    }))
    .filter((cfg) => cfg.MeasureIdList.length > 0);

  const existingBuilder = state.updatedReportBuilderInfo.reportBuilderSavePayload?.Visualization?.Builder as ReportResponseModel.IChartVisualizationBuilder;
  const updatedBuilder: ReportResponseModel.IChartVisualizationBuilder = {
    ...existingBuilder,
    ...(existingBuilder?.YAxis ? {
      YAxis: { ...existingBuilder.YAxis, Columns: existingBuilder.YAxis.Columns.filter((id) => id !== remMeasure.Id) },
    } : {}),
    ...(existingBuilder?.ComboConfig ? {
      ComboConfig: existingBuilder.ComboConfig.filter((c) => c.columnId !== remMeasure.Id),
    } : {}),
  };

  const newState: IReportBuilderState = {
    ...state,
    updatedReportBuilderInfo: {
      ...state.updatedReportBuilderInfo,
      appliedMeasures: newMeasures,
      expressionStore: newExprStore,
      linkedReportsConfig: updatedLinkedReportsConfig,
      drilldownConfigInfo: {
        ...state.updatedReportBuilderInfo.drilldownConfigInfo,
        drilldownConfigMapping: newConfigMapping,
        drilldownColumnConfig: newConfigColumns,
      },
      reportBuilderSavePayload: {
        ...state.updatedReportBuilderInfo.reportBuilderSavePayload,
        Visualization: {
          ...state.updatedReportBuilderInfo.reportBuilderSavePayload?.Visualization,
          Builder: updatedBuilder,
          ConditionalFormatting: {
            ...state.updatedReportBuilderInfo?.reportBuilderSavePayload?.Visualization?.ConditionalFormatting,
            Rules: updatedRules,
          },
          LinkedReportsConfig: updatedLinkedReportsConfig,
        },

      },
    },

  };
  return getStateOnRebuildSortState(newState);
};

// Return the updated State on removing measure for subQuery.
// @state: Report Builder State
// @payload: Updated Measure Info
export const getStateOnRemoveMeasureForSubQuery = (
  state: IReportBuilderState,
  payload: IRemoveMeasurePayload,
): IReportBuilderState => {
  const { index } = payload;

  const newMeasures = [...state.reportQueryBuilder?.SelectedQueryData?.updatedInfo?.AppliedMeasures];
  if (index < 0 || index >= newMeasures.length) return state;

  const remMeasure = newMeasures.splice(index, 1)[0];
  const newExprStore = { ...state.reportQueryBuilder?.SelectedQueryData?.updatedInfo?.ExpressionStore };
  if (isMeasureCustom(remMeasure) && newExprStore[remMeasure.BuilderConfig?.uniqueKey]) {
    // If the measure to be removed is not derived from any custom column expression, then it must be a custom value, so delete it from the store
    // Else it must be derived from the custom column expression, so don't delete the original custom column expression from the store.
    if (!remMeasure?.Props?.IsSourceCustomColumn) {
      delete newExprStore[remMeasure.BuilderConfig.uniqueKey];
    }
  }

  const existingBuilder = state.updatedReportBuilderInfo.reportBuilderSavePayload?.Visualization?.Builder as ReportResponseModel.IChartVisualizationBuilder;
  const updatedBuilder: ReportResponseModel.IChartVisualizationBuilder = {
    ...existingBuilder,
    ...(existingBuilder?.YAxis ? {
      YAxis: { ...existingBuilder.YAxis, Columns: existingBuilder.YAxis.Columns.filter((id) => id !== remMeasure.Id) },
    } : {}),
    ...(existingBuilder?.ComboConfig ? {
      ComboConfig: existingBuilder.ComboConfig.filter((c) => c.columnId !== remMeasure.Id),
    } : {}),
  };

  const newState: IReportBuilderState = {
    ...state,
    updatedReportBuilderInfo: {
      ...state.updatedReportBuilderInfo,
      reportBuilderSavePayload: {
        ...state.updatedReportBuilderInfo.reportBuilderSavePayload,
        Visualization: {
          ...state.updatedReportBuilderInfo.reportBuilderSavePayload?.Visualization,
          Builder: updatedBuilder,
        },
      },
    },
    reportQueryBuilder: {
      ...state.reportQueryBuilder,
      SelectedQueryData: {
        ...state.reportQueryBuilder?.SelectedQueryData,
        updatedInfo: {
          ...state.reportQueryBuilder?.SelectedQueryData?.updatedInfo,
          AppliedMeasures: newMeasures,
          ExpressionStore: newExprStore,
        },
      },
    },
  };
  return getStateOnRebuildSortStateForSubQuery(newState);
};

// Return the updated State on measure change
// @state: Report Builder State
// @payload: Updated Measure Info
export const getStateOnMoveMeasure = (
  state: IReportBuilderState,
  payload: IMoveMeasurePayload,
): IReportBuilderState => {
  const { sourceIndex, destinationIndex } = payload;
  const newMeasures = [...state.updatedReportBuilderInfo.appliedMeasures];
  if (
    sourceIndex < 0
    || destinationIndex < 0
    || sourceIndex >= newMeasures.length
    || destinationIndex >= newMeasures.length
  ) {
    return state;
  }

  const removed = newMeasures.splice(sourceIndex, 1);
  if (removed.length === 0) return state;
  newMeasures.splice(destinationIndex, 0, removed[0]);
  return {
    ...state,
    updatedReportBuilderInfo: {
      ...state.updatedReportBuilderInfo,
      appliedMeasures: newMeasures,
    },
  };
};

// Return the updated State on measure change for subQuery
// @state: Report Builder State
// @payload: Updated Measure Info
export const getStateOnMoveMeasureForSubQuery = (
  state: IReportBuilderState,
  payload: IMoveMeasurePayload,
): IReportBuilderState => {
  const { sourceIndex, destinationIndex } = payload;
  const newMeasures = [...state.reportQueryBuilder?.SelectedQueryData?.updatedInfo?.AppliedMeasures];
  if (
    sourceIndex < 0
    || destinationIndex < 0
    || sourceIndex >= newMeasures.length
    || destinationIndex >= newMeasures.length
  ) {
    return state;
  }

  const removed = newMeasures.splice(sourceIndex, 1);
  if (removed.length === 0) return state;
  newMeasures.splice(destinationIndex, 0, removed[0]);
  return {
    ...state,
    reportQueryBuilder: {
      ...state.reportQueryBuilder,
      SelectedQueryData: {
        ...state.reportQueryBuilder?.SelectedQueryData,
        updatedInfo: {
          ...state.reportQueryBuilder?.SelectedQueryData?.updatedInfo,
          AppliedMeasures: newMeasures,
        },
      },
    },
  };
};

// Return the updated State on measure change
// @state: Report Builder State
// @payload: Updated Measure Info
export const getStateOnUpdateMeasure = (
  state: IReportBuilderState,
  payload: ISetMeasurePayload,
): IReportBuilderState => {
  const { index, newMeasure } = payload;
  const newMeasures = [...state.updatedReportBuilderInfo.appliedMeasures];
  const oldMeasure = { ...newMeasures[index] };
  newMeasures[index] = { ...newMeasure };

  const sortState = state.updatedReportBuilderInfo.sortState.map(
    (sort): ISorting => {
      if (sort.Id === oldMeasure.Id) {
        return { ...sort, Field: newMeasure.Name, Id: newMeasure?.Id };
      }
      return { ...sort };
    },
  );
  const drilldownConfigMapping = cloneDeep(state?.updatedReportBuilderInfo?.drilldownConfigInfo?.drilldownConfigMapping || {});
  Object.keys(drilldownConfigMapping)?.forEach((key: string) => {
    const measureIndex = drilldownConfigMapping?.[key]?.findIndex((measure) => measure?.Id === oldMeasure?.Id);
    if (measureIndex > -1) {
      drilldownConfigMapping[key][measureIndex].Name = newMeasure.Name;
    }
  }, {});

  const updatedState = {
    ...state,
    updatedReportBuilderInfo: {
      ...state.updatedReportBuilderInfo,
      appliedMeasures: newMeasures,
      drilldownConfigInfo: {
        ...state.updatedReportBuilderInfo.drilldownConfigInfo,
        drilldownConfigMapping,
      },
      sortState,
    },
  };
  return updatedState;
};

const applyDimensionUpdate = (
  dimensions: IDimension[],
  sortState: ISorting[],
  payload: ISetDimensionPayload,
  options: { propagateReferTo?: boolean } = {},
): { newDimensions: IDimension[]; newSortState: ISorting[] } => {
  const {
    index, displayName, description, Formatter, Mode,
  } = payload;
  const newDimensions = [...dimensions];
  const existingDimension = { ...newDimensions[index] };
  // Only rewrite DisplayName when the form actually changed them, description only edits
  const nameChanged = displayName !== existingDimension.BuilderConfig?.DisplayName;
  newDimensions[index] = {
    ...existingDimension,
    ...(nameChanged ? {
      Name: displayName,
      BuilderConfig: { ...existingDimension.BuilderConfig, DisplayName: displayName },
    } : {}),
    Props: {
      ...existingDimension.Props,
      Description: description,
      Formatter: {
        ...existingDimension.Props?.Formatter,
        ...Formatter,
      },
    },
  };

  // Resolving the meta column, refer to column gets acted upon.
  if (Mode !== undefined) {
    const referToId = existingDimension.Props?.ReferTo || existingDimension.ReferTo;
    let targetIndex = index;
    if (referToId) {
      const refIdx = newDimensions.findIndex((dim) => dim?.Id === referToId);
      if (refIdx > -1) targetIndex = refIdx;
    }
    const target = newDimensions[targetIndex];
    newDimensions[targetIndex] = {
      ...target,
      Mode,
      Props: { ...target.Props, Mode },
    };
  }

  if (options.propagateReferTo && nameChanged && existingDimension.ReferTo) {
    const referredDimensionIndex = newDimensions.findIndex((dim) => dim.Id === existingDimension.ReferTo);
    if (referredDimensionIndex > -1) {
      newDimensions[referredDimensionIndex] = {
        ...newDimensions[referredDimensionIndex],
        Name: displayName,
        BuilderConfig: { ...newDimensions[referredDimensionIndex].BuilderConfig, DisplayName: displayName },
      };
    }
  }

  const newSortState = (sortState || []).map(
    (sort): ISorting => {
      if (nameChanged && sort.Id === existingDimension.Id) {
        return { ...sort, Field: displayName };
      }
      return { ...sort };
    },
  );

  return { newDimensions, newSortState };
};

// Return the updated State on dimension display name change.
// @state: Report Builder State
// @payload: Updated Dimension Info
export const getStateOnUpdateDimension = (
  state: IReportBuilderState,
  payload: ISetDimensionPayload,
): IReportBuilderState => {
  const { newDimensions, newSortState } = applyDimensionUpdate(
    state.updatedReportBuilderInfo.appliedDimensions,
    state.updatedReportBuilderInfo.sortState,
    payload,
    { propagateReferTo: true },
  );

  const updatedState = {
    ...state,
    updatedReportBuilderInfo: {
      ...state.updatedReportBuilderInfo,
      appliedDimensions: newDimensions,
      sortState: newSortState,
    },
  };
  return updatedState;
};

// Return the updated State on measure change for subQuery
// @state: Report Builder State
// @payload: Updated Measure Info
export const getStateOnUpdateMeasureForSubQuery = (
  state: IReportBuilderState,
  payload: ISetMeasurePayload,
): IReportBuilderState => {
  const { index, newMeasure } = payload;
  const newMeasures = [...state.reportQueryBuilder?.SelectedQueryData?.updatedInfo?.AppliedMeasures];
  const oldMeasure = { ...newMeasures[index] };
  newMeasures[index] = newMeasure;

  const sortState = state.reportQueryBuilder?.SelectedQueryData?.updatedInfo?.sortState.map(
    (sort): ISorting => {
      if (sort.Id === oldMeasure.Id) {
        return { ...sort, Field: newMeasure.Name, Id: newMeasure?.Id };
      }
      return { ...sort };
    },
  );

  const updatedState = {
    ...state,
    reportQueryBuilder: {
      ...state.reportQueryBuilder,
      SelectedQueryData: {
        ...state.reportQueryBuilder?.SelectedQueryData,
        updatedInfo: {
          ...state.reportQueryBuilder?.SelectedQueryData?.updatedInfo,
          AppliedMeasures: state.reportQueryBuilder?.SelectedQueryData?.updatedInfo?.AppliedMeasures.map(
            (measure, i) => (i === index ? newMeasure : measure),
          ),
          sortState,
        },
      },
    },
  };
  return updatedState;
};

// Return the updated State on sub-query dimension display name / description change.
export const getStateOnUpdateDimensionForSubQuery = (
  state: IReportBuilderState,
  payload: ISetDimensionPayload,
): IReportBuilderState => {
  const { newDimensions, newSortState } = applyDimensionUpdate(
    state.reportQueryBuilder?.SelectedQueryData?.updatedInfo?.AppliedDimensions || [],
    state.reportQueryBuilder?.SelectedQueryData?.updatedInfo?.sortState || [],
    payload,
  );

  const updatedState = {
    ...state,
    reportQueryBuilder: {
      ...state.reportQueryBuilder,
      SelectedQueryData: {
        ...state.reportQueryBuilder?.SelectedQueryData,
        updatedInfo: {
          ...state.reportQueryBuilder?.SelectedQueryData?.updatedInfo,
          AppliedDimensions: newDimensions,
          sortState: newSortState,
        },
      },
    },
  };
  return updatedState;
};

// Get the updated Sort State
// @state - Report Builder State
// @noMultiSort - boolean to check the multiSort
export const getStateOnRebuildSortState = (
  state: IReportBuilderState,
  noMultiSort?: boolean,
): IReportBuilderState => {
  const {
    updatedReportBuilderInfo: { appliedDimensions, appliedMeasures, sortState },
  } = state;
  return {
    ...state,
    updatedReportBuilderInfo: {
      ...state.updatedReportBuilderInfo,
      sortState: rebuildSortState(
        sortState,
        appliedDimensions,
        appliedMeasures,
        [],
        noMultiSort,
      ),
    },
  };
};

export const getStateOnRebuildSortStateForSubQuery = (
  state: IReportBuilderState,
  noMultiSort?: boolean,
): IReportBuilderState => {
  const {
    reportQueryBuilder: { SelectedQueryData: { updatedInfo: { AppliedDimensions: appliedDimensions, AppliedMeasures: appliedMeasures, sortState } } },
  } = state;
  return {
    ...state,
    reportQueryBuilder: {
      ...state.reportQueryBuilder,
      SelectedQueryData: {
        ...state.reportQueryBuilder.SelectedQueryData,
        updatedInfo: {
          ...state.reportQueryBuilder.SelectedQueryData.updatedInfo,
          sortState: rebuildSortState(
            sortState,
            appliedDimensions,
            appliedMeasures,
            [],
            noMultiSort,
          ),
        },
      },
    },
  };
};

// Update the filter config based on the is partition condition
// @filterConfig - Filter config
// @appliedFilters - Filter response and data
// @partitionColumnFilterDateLimit - This is part of the setting
export const getUpdatedAppliedFiltersForPartitionColumn = (
  filterConfig: IFilterConfig[],
  appliedFilters: ObjModel.ObjGeneric<FilterModel.IFilterResponse>,
  partitionColumnFilterDateLimit: number,
): ObjModel.ObjGeneric<FilterModel.IFilterResponse> => {
  const newAppliedFilters = cloneDeep(appliedFilters);
  filterConfig.forEach((filter) => {
    if (filter.IsPartitionColumn && !filter?.IsRemoved) {
      const filterID = filter.ID;
      const filterResponse = newAppliedFilters[filterID]?.FilterResponse;
      if (filterResponse && filterResponse?.Type === IDateRangeTypes.Relative) {
        newAppliedFilters[filterID].FilterResponse = getDatesIfRelativeRangeIsRestricted(
          filterResponse?.Value,
          partitionColumnFilterDateLimit,
        );
      } else {
        newAppliedFilters[filterID].FilterResponse = getDatesIfAbsoluteRangeIsRestricted(
          moment(filterResponse?.Value?.From),
          moment(filterResponse?.Value?.To),
          partitionColumnFilterDateLimit,
        );
      }
    }
  });
  return newAppliedFilters;
};

// Validation check for the string field applied
// @appliedDimensions: Array which store all the applied Dimnsions
export const isStringFieldApplied = (appliedDimensions: IDimension[]) => appliedDimensions?.find(
  (dim) => dim.DimensionProp?.DataType === ColumnDataTypes.String
      && dim?.Applied === DimensionStatus.Applied,
);
// Validation check for the duplicate input.
// @inputString - input value.
// @comparisonData - Array of object from which need to check the duplicate value
// @propertyToCheck - Duplicate Value Key
export const getIsDuplicateInput = (inputString:string, comparisonData :Array<Object>, propertyToCheck:any) => {
  const lowerCaseInput = inputString.toLowerCase().trim();
  const filteredArray = comparisonData.filter((obj:any) => obj[propertyToCheck].toLowerCase().trim() === lowerCaseInput);
  return filteredArray.length > 0;
};

// Return the Updated Alias with Entity and SchemaName
export const getUpdatedAlias = (
  NameSpaceType: string,
  SchemaName: string,
  Entity: string,
) => {
  if (NameSpaceType !== Entity) {
    return `${Entity}${SchemaName}`;
  }
  return SchemaName;
};

// Combine renderReportConfig and RawReportConfig and returns the updated Config.
// @rawReportConfig: contains the rawReportConfig which is stored in redux store.
// @renderReportConfig: contains the renderReportConfig which is stored in redux store.
// Returns combined report config of IReportConfigType
export const getCombinedReportConfig = (rawReportConfig: IReportConfig, renderReportConfig: ReportResponseModel.IReportConfig): IReportConfig => {
  const updatedConfig = rawReportConfig;

  updatedConfig.Columns = renderReportConfig.Columns;
  updatedConfig.FiltersMetadata = renderReportConfig.FiltersMetadata;
  const updatedVisualization = getInitialVisualization(updatedConfig?.Visualization, false);
  updatedConfig.Visualization = {
    Type: updatedVisualization.type,
    Builder: { ...rawReportConfig.Visualization.Builder, Properties: updatedVisualization.attributes },
    ConditionalFormatting: updatedConfig.Visualization?.ConditionalFormatting,
    LinkedReportsConfig: renderReportConfig.Visualization?.LinkedReportsConfig ?? [],
  };

  updatedConfig.Columns = isValidArray(updatedConfig?.Columns) && updatedConfig?.Columns?.map((column:IColumn) => {
    if (column?.Props?.Measure?.IsCustomExpression) {
      const customMeasureBuilder = isValidArrayAndNotEmpty(updatedConfig.Builder) && updatedConfig.Builder[0].Select.Measures.find((measure) => measure?.Id === column?.Id);
      column = {
        ...column,
        BuilderConfig: {
          ...column.BuilderConfig,
          Alias: isMeasureCustom(column) ? column?.BuilderConfig?.Alias : column?.Name,
          Entity: FieldEntitiesType.Custom,
          uniqueKey: column.Id,
        },
        Props: {
          ...column?.Props,
          Measure: {
            ...column?.Props?.Measure,
            Expression: customMeasureBuilder.MeasureExpression,
          },
        },
      };
    }
    if (column?.Props?.Dimension?.IsCustomExpression) {
      column = {
        ...column,
        BuilderConfig: {
          ...column.BuilderConfig,
          uniqueKey: column.Id,
        },
      };
    }
    return column;
  });

  if (isValidArrayAndNotEmpty(updatedConfig.Builder)) {
    updatedConfig.Columns = updatedConfig.Columns.map((col) => {
      let correspondingDimensionOrMeasureInBuilder: IBuilderDimension | IBuilderMeasure;
      correspondingDimensionOrMeasureInBuilder = updatedConfig.Builder[0].Select.Dimensions?.find((dimension) => dimension?.Id === col?.Id);
      if (!correspondingDimensionOrMeasureInBuilder) {
        correspondingDimensionOrMeasureInBuilder = updatedConfig.Builder[0].Select.Measures?.find((measure) => measure?.Id === col?.Id);
      }
      return {
        ...col,
        Props: {
          ...col.Props,
          IsSourceCustomColumn: correspondingDimensionOrMeasureInBuilder?.IsSourceCustomColumn ?? false,
        },
      };
    });
  }
  return updatedConfig;
};

// Build Custom Expression from the report Config and update in the expression Store.
// @reportConfig: contains the rawReportConfig which is stored in redux store.
// @expressionStore: contains all the custom expressions as key value pair object which is stored in redux store.
// Returns updated Expression Store of type ObjGeneric<ICustomExpression>;
export const getExpressionStoreFromConfig = (reportConfig: IReportConfig, expressionStore: ObjGeneric<ICustomExpression>) : ObjGeneric<ICustomExpression> => {
  const updatedExpressionStore = { ...expressionStore };
  const columns = reportConfig?.Columns;
  const customColumns = reportConfig?.Builder?.[0]?.CustomColumns ?? [];

  const allColumns = [...customColumns, ...columns];
  return getExpressionStoreFromColumns(allColumns, updatedExpressionStore, reportConfig, customColumns);
};

export const getExpressionStoreFromColumns = (columns: IReportBuilderColumn[], updatedExpressionStore: ObjGeneric<ICustomExpression>, reportConfig: IReportConfig, customColumns:IReportBuilderColumn[]) => {
  if (isValidArrayAndNotEmpty(columns)) {
    columns?.forEach((column) => {
      let expression: ICustomExpression;
      const isColumnAMeasure = isMeasureCustom(column);
      /**
   * The below logic is added so as to differentiate between custom column expressions and custom groupings.
   * The custom grouping should translate to have ExpressionType set to `Dimension` in the expression store
   * and for custom columns to set to `Custom`.
   */
      const allBuilderColumns = [...reportConfig?.Builder?.[0]?.Select?.Measures, ...reportConfig?.Builder?.[0]?.Select?.Dimensions];
      const correspondingMeasureDetails = allBuilderColumns.find((measure) => measure?.Id === column?.Id);
      const isCustomColumn = customColumns.find((item) => item.Id === column.Id);
      if (isColumnAMeasure && !correspondingMeasureDetails?.IsSourceCustomColumn) {
        expression = {
          displayName: column.Name,
          description: column?.Props?.Description,
          jsonExpression: column?.Props?.Measure?.Expression,
          Mode: column?.Props?.Mode,
          uniqueId: column?.Id,
          Formatter: column?.Props?.Formatter,
          DataType: getDataTypeFromCustomColumn(column?.Props?.Measure?.Expression),
          ExpressionType: isCustomColumn ? ExpressionContext.Custom : ExpressionContext.Measure,
        };
      } else if (isDimensionCustom(column) && !correspondingMeasureDetails?.IsSourceCustomColumn) {
        expression = {
          displayName: column.Name,
          description: column?.Props?.Description,
          jsonExpression: column?.Props?.Dimension?.Expression,
          Mode: column?.Props?.Mode,
          uniqueId: column?.Id,
          Formatter: column?.Props?.Formatter,
          DataType: getDataTypeFromCustomColumn(column?.Props?.Dimension?.Expression),
          ExpressionType: isCustomColumn ? ExpressionContext.Custom : ExpressionContext.Dimension,
        };
      }
      if (expression) {
        updatedExpressionStore = {
          ...updatedExpressionStore,
          ...{
            [column?.Id]: expression,
          },
        };
      }
    });
  }

  return updatedExpressionStore;
};

// Updates isDynamic flag so the same additonal filter can be removed even after stored as a default filter in report config via report builder or save/saveAs.
// @filterConfig: contains the filterConfig which is stored in redux store.
// Returns updated filter Config of Type IFilterConfig[]
export const getUpdatedReportFilterConfig = (filterConfig: IFilterConfig[]): IFilterConfig[] => {
  const updatedFilterConfig = filterConfig;
  return isValidArrayAndNotEmpty(updatedFilterConfig) ? updatedFilterConfig.map((filter: IFilterConfig) => {
    filter.IsDynamic = filter.IsDynamic || filter.IsAdditional;
    return filter;
  }) : updatedFilterConfig;
};

// Reorder the Dimensions array set all the metafields at the end of the array
// @appliedDimensions: contains all the dimensions stored in redux store
// Returns the reordered array.
export const reorderAppliedDimensions = (appliedDimensions: IDimension[]): IDimension[] => {
  const metafields: IDimension[] = [];
  const dimensions: IDimension[] = isValidArrayAndNotEmpty(appliedDimensions) ? appliedDimensions.filter((dimension:IDimension) => {
    if (dimension?.Props?.ParentDimension) {
      metafields.push(dimension);
    }
    return !dimension?.Props?.ParentDimension;
  }) : [];

  return [...dimensions, ...metafields];
};

// Returns the updated report builder state on add dynamic filter
// @state: report builder state
// @index: index of newely added dynamic filter
export const getStateOnAddDynamicFilter = (state:IReportBuilderState, index:number) => {
  const newState = state;
  const { Title, Description } = newState.updatedReportBuilderInfo.reportBuilderSavePayload.Details;
  let newFilterConfig = newState.filterBuilder.filterConfig ?? [];
  newState.assortedInfo.isFormDisabled = getIsReportBuilderSaveFormDisable(Title, Description, state)
        || getIsFilterFormDisable(newState.filterBuilder);
  const newAppliedFilters = newState.filterBuilder.appliedFilters;

  const dynamicFilter = isValidArrayAndNotEmpty(newState?.reportBuilderInfo?.additionalFilters) && newState.reportBuilderInfo.additionalFilters[index];
  const userMultiSelectFilterData = isValidArrayAndNotEmpty(newFilterConfig) && newFilterConfig.find((config: IFilterConfig) => isPaginatedFilter(config));
  newFilterConfig = isValidArrayAndNotEmpty(newFilterConfig) ? newFilterConfig.filter(
    (config: IFilterConfig) => config.ID !== dynamicFilter?.ID,
  ) : [];
  dynamicFilter.IsPrimaryUserFilter = false;
  newFilterConfig.push(dynamicFilter);
  newAppliedFilters[dynamicFilter.ID] = new FilterFetchUtility(null).GetDefaultSingleFilter(dynamicFilter, null);
  if (
    dynamicFilter?.Entity === FieldEntitiesType.User
        && userMultiSelectFilterData
  ) {
    newState.filterBuilder.isUsersModified = true;
    newAppliedFilters[userMultiSelectFilterData.ID] = new FilterFetchUtility(null).GetDefaultSingleFilter(
      userMultiSelectFilterData,
      null,
    );
  }
  newState.filterBuilder.filterConfig = newFilterConfig;
  newState.filterBuilder.appliedFilters = newAppliedFilters;

  return newState;
};

// Returns the updated report query builder state on add dynamic filter in QueryBuilder
// @state: report builder state
// @index: index of newely added dynamic filter
export const getStateOnAddQueryDynamicFilter = (state:IReportBuilderState, index:number) => {
  const newState = state;
  let newFilterConfig = newState.reportQueryBuilder.SelectedQueryData.updatedInfo.filterBuilder.filterConfig;
  const newAppliedFilters = newState.reportQueryBuilder.SelectedQueryData.updatedInfo.filterBuilder.appliedFilters;

  const dynamicFilter = isValidArrayAndNotEmpty(newState?.reportQueryBuilder.SelectedQueryData?.additionalData?.AdditionalFilters) && newState?.reportQueryBuilder.SelectedQueryData?.additionalData?.AdditionalFilters[index];
  const userMultiSelectFilterData = isValidArrayAndNotEmpty(newFilterConfig) && newFilterConfig.find((config: IFilterConfig) => isPaginatedFilter(config));
  newFilterConfig = isValidArrayAndNotEmpty(newFilterConfig) ? newFilterConfig.filter(
    (config: IFilterConfig) => config.ID !== dynamicFilter?.ID,
  ) : [];
  dynamicFilter.IsPrimaryUserFilter = false;
  newFilterConfig.push(dynamicFilter);
  newAppliedFilters[dynamicFilter.ID] = new FilterFetchUtility({ reportId: state.assortedInfo.reportId }).GetDefaultSingleFilter(dynamicFilter, null);
  if (
    dynamicFilter?.Entity === FieldEntitiesType.User
        && userMultiSelectFilterData
  ) {
    newState.reportQueryBuilder.SelectedQueryData.updatedInfo.filterBuilder.isUsersModified = true;
    newAppliedFilters[userMultiSelectFilterData.ID] = new FilterFetchUtility({ reportId: state.assortedInfo.reportId }).GetDefaultSingleFilter(
      userMultiSelectFilterData,
      null,
    );
  }
  newState.reportQueryBuilder.SelectedQueryData.updatedInfo.filterBuilder.filterConfig = newFilterConfig;
  newState.reportQueryBuilder.SelectedQueryData.updatedInfo.filterBuilder.appliedFilters = newAppliedFilters;

  return newState;
};

export const getStateOnQueryDeleteDynamicFilter = (state:IReportBuilderState, payload: IDeleteDynamicFilterPayload) => {
  const { filterId } = payload;
  const newFilterConfig = state.reportQueryBuilder.SelectedQueryData.updatedInfo.filterBuilder.filterConfig;
  const newAppliedFilters = state.reportQueryBuilder.SelectedQueryData.updatedInfo.filterBuilder.appliedFilters;
  const index = newFilterConfig.findIndex(
    (config) => config.ID === filterId,
  );
  const userMultiSelectFilterData = newFilterConfig.find(
    (config) => config.Type === FilterType.UserMultiSelect,
  );
  const appliedDimensions = state.reportQueryBuilder.SelectedQueryData.updatedInfo.AppliedDimensions;
  const deletedFilter = index !== -1 ? newFilterConfig[index] : null;
  if (deletedFilter?.Type === FilterType.DateRange && isValidArrayAndNotEmpty(appliedDimensions) && deletedFilter?.LinkedDimensionId) {
    const isLinkedDimAppliedIndex = appliedDimensions.findIndex((dim: IDimension) => dim.Applied === DimensionStatus.Applied && truncateUUID(deletedFilter?.LinkedDimensionId) === dim.Id);
    if (isLinkedDimAppliedIndex !== -1) {
      appliedDimensions[isLinkedDimAppliedIndex] = {
        ...appliedDimensions[isLinkedDimAppliedIndex],
        RangeFill: 0,
        Props: {
          ...appliedDimensions[isLinkedDimAppliedIndex]?.Props,
          Dimension: {
            ...appliedDimensions[isLinkedDimAppliedIndex]?.Props?.Dimension,
            RangeFill: 0,
          },
        },
      };
    }
    state.reportQueryBuilder.SelectedQueryData.updatedInfo.AppliedDimensions = appliedDimensions;
  }
  if (index !== -1) {
    newFilterConfig[index].IsRemoved = true;
    if (
      newFilterConfig[index]?.Entity === FieldEntitiesType.User
            && userMultiSelectFilterData
    ) {
      state.filterBuilder.isUsersModified = true;
      newAppliedFilters[userMultiSelectFilterData.ID] = new FilterFetchUtility(null).GetDefaultSingleFilter(
        userMultiSelectFilterData,
        null,
      );
    }
  }
  delete newAppliedFilters[filterId];
  state.reportQueryBuilder.SelectedQueryData.updatedInfo.filterBuilder.appliedFilters = newAppliedFilters;
  state.reportQueryBuilder.SelectedQueryData.updatedInfo.filterBuilder.filterConfig = newFilterConfig;
  const { Title, Description } = state.updatedReportBuilderInfo.reportBuilderSavePayload.Details;
  state.assortedInfo.isFormDisabled = getIsReportBuilderSaveFormDisable(Title, Description, state)
          || getIsFilterFormDisable(state.filterBuilder);
};

export const deleteSubQueryFn = (state: IReportBuilderState, payload: string, slice: boolean) => {
  const { reportQueryBuilder } = state;
  const queryIdToDelete = payload;

  const queryToDelete = reportQueryBuilder.DynamicQueryList.find(
    (query) => query.Id === queryIdToDelete,
  );

  if (!queryToDelete) {
    return;
  }

  let { ParentQueryId } = queryToDelete;
  if (ParentQueryId) {
    const parentQuery = reportQueryBuilder.DynamicQueryList.find(
      (query) => query.Id === ParentQueryId,
    );

    if (parentQuery) {
      parentQuery.LinkedQueryIds = parentQuery.LinkedQueryIds.filter(
        (id) => id !== queryIdToDelete,
      );
    }
    if (!ParentQueryId) {
      ParentQueryId = ROOT_QUERY_KEY;
    }
    if (reportQueryBuilder.DataSourceMapping[ParentQueryId]) {
      const dataSourceMapping = reportQueryBuilder.DataSourceMapping[ParentQueryId];
      let joinIndex = -1;
      if (parentQuery?.QueryConfig?.Namespace === queryIdToDelete) {
        delete dataSourceMapping.Joins;
        // if the primary namespace is mapped to another query data source
        if (dataSourceMapping.PrimaryNamespace === queryIdToDelete) dataSourceMapping.PrimaryNamespace = null;
      } else if (isValidArrayAndNotEmpty(dataSourceMapping.Joins)) {
        dataSourceMapping.Joins = dataSourceMapping.Joins
          .map((join: JoinItem, index: number) => {
            if (join.With === queryIdToDelete) {
              joinIndex = index;
              return {
                ...join,
                With: '',
                On: null,
              };
            }
            return join;
          });
        if (slice) {
          dataSourceMapping.Joins = dataSourceMapping.Joins?.slice(0, joinIndex + 1);
        }
      } else { // Single query Exists
        dataSourceMapping.PrimaryNamespace = null;
      }
    }
  }

  state.reportQueryBuilder = reportQueryBuilder;
};

// Returns the drilldown config object for measures with name and joinId
// @newMeasure: when new measure gets added
export const getDrilldownMapping = (MeasureList: IColumn[], state: IReportBuilderState): DrilldownConfigMapping => {
  const updatedMeasuresList = isValidArrayAndNotEmpty(MeasureList) ? MeasureList.filter((measure: IColumn) => (Object.prototype.hasOwnProperty.call(measure?.Props, 'DrilldownEnabled')
    ? measure?.Props?.DrilldownEnabled : measure?.Props?.AllowDrillDown)) : [];

  const defaultEntity = getDefaultEntity(state?.updatedReportBuilderInfo?.selectedTemplate?.ReportConfig);
  const fieldsData = fieldSelectors({ reportBuilder: state } as IGlobalState);

  const modifiedMeasuresList = cloneDeep(updatedMeasuresList).map((measure: IColumn) => {
    if (measure.Props.Measure.IsCustomExpression || measure?.Props?.IsSourceCustomColumn) {
      const { Entity, JoinId } = getEntityJoinIdForCustomMeasure(fieldsData || [], measure, defaultEntity);
      measure.Props.Measure.Entity = Entity;
      measure.Props.Measure.JoinID = JoinId;
    }
    return measure;
  });
  const groupedByJoinId = groupBy(modifiedMeasuresList, 'Props.Measure.JoinId');
  const groupedByEntity:any = mapValues(groupedByJoinId, (items: IColumn) => groupBy(items, 'Props.Measure.Entity'));
  const drilldownConfigMapping:DrilldownConfigMapping = {};
  Object.keys(groupedByEntity || {})?.forEach((key: string) => {
    Object.keys(groupedByEntity[key])?.forEach((entityKey: string) => {
      const id = uuidv4();
      drilldownConfigMapping[id] = (groupedByEntity[key][entityKey])?.map((val: IColumn) => ({
        Name: val?.Name, JoinId: val?.Props?.Measure?.JoinID || '', Entity: val?.Props?.Measure?.Entity || '', Id: val?.Id,
      }));
    });
  });
  return drilldownConfigMapping;
};

// Returns the drilldown config object grouped by name and joinId for UI purpose
// @newMeasure: when new measure gets added
// @drilldownConfigMapping: existing mapping
// @appliedMeasures: existing applied measures

export const groupByJoinIdAndEntity = (fieldsData:Array<IField>, newMeasure: IColumn, drilldownConfigMapping: DrilldownConfigMapping, appliedMeasures: IColumn[], defaultEntity: string): DrilldownConfigMapping => {
  const mapping = cloneDeep(drilldownConfigMapping || {});

  let currentMeasureEntity = newMeasure?.Props?.Measure?.Entity;
  let currentMeasureJoinId = newMeasure?.Props?.Measure?.JoinID || '';

  if (newMeasure?.Props?.Measure?.IsCustomExpression || newMeasure?.Props?.IsSourceCustomColumn) {
    const { Entity, JoinId } = getEntityJoinIdForCustomMeasure(fieldsData, newMeasure, defaultEntity);
    currentMeasureEntity = Entity;
    currentMeasureJoinId = JoinId;
  }

  let isMeasureAdded = false;
  Object.keys(drilldownConfigMapping || {})?.forEach((key) => {
    const existJoinId = drilldownConfigMapping?.[key]?.[0]?.JoinId || '';
    const existingMeasure = appliedMeasures?.find((measure: IColumn) => measure?.Id === drilldownConfigMapping[key][0]?.Id);

    let existingMeasureEntity = existingMeasure?.Props?.Measure?.Entity;

    if (existingMeasure?.Props?.Measure?.IsCustomExpression || existingMeasure?.Props?.IsSourceCustomColumn) {
      const { Entity } = getEntityJoinIdForCustomMeasure(fieldsData, existingMeasure, defaultEntity);
      existingMeasureEntity = Entity;
    }

    if (currentMeasureJoinId === existJoinId && currentMeasureEntity === existingMeasureEntity) {
      mapping[key].push({
        Name: newMeasure?.Name, JoinId: currentMeasureJoinId, Entity: currentMeasureEntity, Id: newMeasure.Id,
      });
      isMeasureAdded = true;
    }
  });
  if (!isMeasureAdded) {
    const id = uuidv4();
    mapping[id] = [{
      Name: newMeasure?.Name, JoinId: currentMeasureJoinId, Entity: currentMeasureEntity, Id: newMeasure.Id,
    }];
  }
  return mapping;
};

// Returns the Initial column object
// @DefaultDrilldownResponse: default columns response from api
// @drilldownConfigMapping: existing mapping
// @drilldownConfigInfo: the config of drilldown which contains measure and column info

export const getInitialDrilldownConfigInfo = (DefaultDrilldownResponse: DrilldownColumnConfigResponse, drilldownConfigInfo: IdrilldownConfigInfo): DrilldownColumnConfig => {
  const drilldownConfig = {} as DrilldownColumnConfig;
  if (isValidObjectAndNotEmpty(drilldownConfigInfo.drilldownConfigMapping)) {
    Object.keys(DefaultDrilldownResponse || {})?.forEach((accordId: string) => {
      if (!drilldownConfigInfo?.drilldownColumnConfig?.[accordId]?.defaultColumns?.length) {
        const sortState = isValidArrayAndNotEmpty(DefaultDrilldownResponse?.[accordId]?.sortState) ? DefaultDrilldownResponse?.[accordId]?.sortState[0] : null;
        const sortColumn = DefaultDrilldownResponse[accordId]?.defaultColumns?.find((item:IColumn) => sortState?.Id === item.Id);
        const initialSort = {
          Field: sortColumn?.Name,
          Direction: sortState?.Direction,
          Id: sortColumn?.Id,
        };
        drilldownConfig[accordId] = {
          defaultColumns: DefaultDrilldownResponse[accordId]?.defaultColumns?.filter((dim:IColumn) => dim?.Props?.Mode !== ColumnModes.Hidden).map((column: IColumn) => ({
            ...column,
            Props: {
              ...column.Props,
              Dimension: {
                ...column.Props.Dimension,
                Applied: DimensionStatus.Applied,
              },
            },
          })) || [],
          sortState: [initialSort],
          additionalDrilldownColumns: [],
          isAdditionalColumnFetched: false,
        };
      }
    });
  }

  return drilldownConfig;
};

// Returns the updated column object when any param is updated
// @colObj: contains column info to be updated
// @drilldownColumnConfigInfo: column info of selected accordian

export const getUpdatedDrilldownColConfig = (state: IReportBuilderState, colObj: DrilldownFieldUpdationsAction):DrillDownColumnConfigObj => {
  const { updatedReportBuilderInfo: reportBuilder } = state;
  const drilldownColumnConfigInfo = state.updatedReportBuilderInfo.drilldownConfigInfo.drilldownColumnConfig;
  const curDrillDownConfig = cloneDeep(drilldownColumnConfigInfo[colObj?.groupingId]);
  let updatedName = colObj.column.BuilderConfig.IsDynamicField ? colObj.column.BuilderConfig.DisplayName : colObj.column.Name;
  if (!colObj.column.Props?.IsMetaFieldSelector) {
    updatedName = getUpdatedDrilldownColsName(updatedName, curDrillDownConfig.defaultColumns);
  }
  const entityGroupOptionsMap = state.updatedReportBuilderInfo.entityGroupOptionsMap;
  const entityGroupStore = state.updatedReportBuilderInfo.entityGroupStore;
  const updatedCol: DrilldownFieldUpdationsAction = {
    ...colObj,
    column: {
      ...colObj.column,
      Name: colObj.type === DrilldownFieldUpdationType.ADD ? updatedName : colObj.column.Name,
      Props: {
        ...colObj.column.Props,
        Dimension: {
          ...colObj.column.Props.Dimension,
          Applied: colObj.type === DrilldownFieldUpdationType.ADD ? DimensionStatus.Applied : DimensionStatus.NotApplied,
        },
      },
      BuilderConfig: {
        ...colObj.column?.BuilderConfig,
        DisplayName: colObj.column.BuilderConfig.IsDynamicField ? updatedName : colObj.column.BuilderConfig.DisplayName,
        IsDynamicField: colObj.type === DrilldownFieldUpdationType.ADD ? false : colObj.column.BuilderConfig.IsDynamicField,
      },
    },

  };
  if (isEntityGrouped(colObj.column)
  ) {
    if (colObj.type !== DrilldownFieldUpdationType.REMOVE) {
      const uniqueKey = getFieldIdentifier(updatedCol.column);
      if (isValidArrayAndNotEmpty(entityGroupOptionsMap[uniqueKey])) {
        const selectedOption = entityGroupOptionsMap[uniqueKey][entityGroupOptionsMap[uniqueKey].length - 1];
        const columnConfig = selectedOption.Config.at(-1);
        const augmentedCol: IColumn = {
          ...columnConfig,
          Name: columnConfig?.Name,
          ...columnConfig.Props.Dimension,
          BuilderConfig: columnConfig?.BuilderConfig,
          Id: columnConfig?.Id,
          Props: {
            ...columnConfig?.Props,
            Dimension: {
              ...columnConfig.Props.Dimension,
              Applied: colObj.type === DrilldownFieldUpdationType.ADD ? DimensionStatus.Applied : DimensionStatus.NotApplied,
            },
            IsAdditional: true,
          },
        };
        updateEntityGroupStore(entityGroupStore, augmentedCol);
        curDrillDownConfig?.defaultColumns.push(augmentedCol);
      }
    } else {
      curDrillDownConfig.defaultColumns = curDrillDownConfig?.defaultColumns.filter((col) => col.Id !== updatedCol.column.Id);
      if ((updatedCol.column?.Id in entityGroupStore)) {
        delete entityGroupStore[updatedCol.column?.Id];
      }
      const originalDimensionIndex = getOriginalDimensionIndex(curDrillDownConfig.additionalDrilldownColumns, updatedCol.column, true);
      if (originalDimensionIndex === -1) {
        curDrillDownConfig.additionalDrilldownColumns.push(updatedCol.column);
      }
    }
    curDrillDownConfig.sortState = rebuildSortState(curDrillDownConfig.sortState, reportBuilder.appliedDimensions, reportBuilder.appliedMeasures, curDrillDownConfig.defaultColumns, false, true);
    return curDrillDownConfig;
  }
  if (colObj.type === DrilldownFieldUpdationType.REMOVE) {
    curDrillDownConfig.defaultColumns = isValidArrayAndNotEmpty(curDrillDownConfig?.defaultColumns) ? curDrillDownConfig.defaultColumns?.filter((col: IColumn) => col.Id !== colObj?.column?.Id) : [];

    const updatedAddtCols = curDrillDownConfig.additionalDrilldownColumns.map((item: IColumn) => {
      if (item.Id === updatedCol.column?.Id) {
        return {
          ...item,
          Props: {
            ...item.Props,
            Dimension: {
              ...item.Props.Dimension,
              Applied: DimensionStatus.NotApplied,
            },
          },
        };
      }
      return item;
    });
    curDrillDownConfig.additionalDrilldownColumns = updatedAddtCols;
  } else {
    curDrillDownConfig?.defaultColumns?.push(updatedCol.column);

    const updatedAddtCols = curDrillDownConfig.additionalDrilldownColumns?.map((item: IColumn) => {
      if (item.Id === updatedCol.column?.Id) {
        return {
          ...item,
          Props: {
            ...item.Props,
            Dimension: {
              ...item.Props.Dimension,
              Applied: DimensionStatus.Applied,
            },
          },
        };
      }
      return item;
    });
    curDrillDownConfig.additionalDrilldownColumns = updatedAddtCols;
  }

  curDrillDownConfig.sortState = rebuildSortState(curDrillDownConfig.sortState, reportBuilder.appliedDimensions, reportBuilder.appliedMeasures, curDrillDownConfig.defaultColumns, false, true);
  return curDrillDownConfig;
};

// Returns the updated column object when any name or something updated
// @drilldownConfig: config of drilldown with measures and columns
// @payload: contains index, key is current accordian key and newMeasure is updated column
export const getStateOnUpdateDrilldownColumn = (
  drilldownConfig: IdrilldownConfigInfo,
  payload: {
    index: number;
    newMeasure: IColumn;
    key: string;
  },
): IdrilldownConfigInfo => {
  const { index, newMeasure, key } = payload;
  const newColumn = [...drilldownConfig.drilldownColumnConfig[key]?.defaultColumns];
  const oldColumn = { ...newColumn[index] };
  newColumn[index] = { ...newMeasure };

  const sortState = drilldownConfig.drilldownColumnConfig[key]?.sortState?.map(
    (sort: IDrilldownSorting): ISorting => {
      if (sort?.Field === oldColumn?.Name) {
        return { ...sort, Field: newMeasure.Name, Id: newMeasure?.Id };
      }
      return { ...sort };
    },
  );
  drilldownConfig.drilldownColumnConfig[key].defaultColumns = newColumn;
  drilldownConfig.drilldownColumnConfig[key].sortState = sortState;
  return drilldownConfig;
};

// Returns the updated column when user reorder the columns
// @drilldownColumnConfig: config of drilldown with measures and columns
// @payload: contains index, key is current accordian key and newMeasure is updated column
export const getStateOnMoveColumns = (
  drilldownColumnConfig: DrilldownColumnConfig,
  payload: {
    startElement:IColumn;
    endElement:IColumn;
    key: string;
  },
): IColumn[] => {
  const { startElement, endElement, key } = payload;
  const newColumns = cloneDeep(drilldownColumnConfig[key]?.defaultColumns);
  const sourceIndex = newColumns?.findIndex((col: IColumn) => getUniqIdentiferForDrilldownColsWithId(col) === getUniqIdentiferForDrilldownColsWithId(startElement));
  const destinationIndex = newColumns?.findIndex((col: IColumn) => getUniqIdentiferForDrilldownColsWithId(col) === getUniqIdentiferForDrilldownColsWithId(endElement));

  if (
    sourceIndex < 0
    || destinationIndex < 0
    || sourceIndex >= newColumns.length
    || destinationIndex >= newColumns.length
  ) {
    return newColumns;
  }

  const removed = newColumns.splice(sourceIndex, 1);
  if (removed.length === 0) return newColumns;
  newColumns.splice(destinationIndex, 0, removed[0]);
  return newColumns;
};

// Returns the updated name when dupliction scenario occures,
// @name: name of current column
// @allDefaultCols: all default columns
export const getUpdatedDrilldownColsName = (name: string, allDefaultCols: Array<IColumn>): string => {
  let updatedName = name || '';
  const originalName = updatedName.split('_')[0];
  const allNames = allDefaultCols.map((item:IColumn) => item.Name);
  let counter = 1;
  while (allNames.includes(updatedName)) {
    updatedName = `${originalName}_${counter}`;
    counter += 1;
  }
  return updatedName;
};

// Returns the sort object for current accordian columns
// @state: current state
// @payload: contains current accordian key, multisort and columnname info
export const sortDrilldownColumns = (state: IReportBuilderState, payload: ISortDrilldownColumnPayload): ISorting[] => {
  const { updatedReportBuilderInfo: reportBuilder } = state;
  const {
    key, multiSort, columnName, order, Id,
  } = payload;
  const drilldownSortState = reportBuilder?.drilldownConfigInfo?.drilldownColumnConfig[key]?.sortState;
  const drilldownColumns = reportBuilder?.drilldownConfigInfo?.drilldownColumnConfig[key]?.defaultColumns;
  const [sortState, hasChanged] = sortColumns(
    drilldownSortState,
    reportBuilder.appliedDimensions,
    reportBuilder.appliedMeasures,
    draggableItemType.DrilldownDim,
    columnName,
    order,
    multiSort,
    Id,
    drilldownColumns,
    true,
  );
  if (!hasChanged) return drilldownSortState;

  return sortState;
};

export const removeMeasureFromDrilldownConfigMapping = (
  config:IdrilldownConfigInfo,
  target:MeasureListWithJoinId,
) => {
  const newConfigMapping = cloneDeep(config.drilldownConfigMapping);
  const newConfigColumns = cloneDeep(config.drilldownColumnConfig);
  Object.keys(newConfigMapping).forEach((key) => {
    const index = newConfigMapping[key].findIndex(
      (item) => item.Name === target.Name && item.JoinId === target.JoinId,
    );

    if (index !== -1) {
      newConfigMapping[key].splice(index, 1);

      if (newConfigMapping[key].length === 0) {
        delete newConfigMapping[key];
        delete newConfigColumns[key];
      }
    }
  });
  return { newConfigMapping, newConfigColumns };
};

export const getUpdatedDrilldownCols = (drilldownColumnConfig:DrilldownColumnConfig) => {
  const updatedData = Object.keys(drilldownColumnConfig).reduce((acc: any, key: any) => {
    const currentObject = drilldownColumnConfig[key];
    const { defaultColumns, sortState } = currentObject;
    const filteredColumns = defaultColumns?.filter((column: IColumn) => column.Props.Dimension.Applied !== 0)?.map((column: IColumn) => ({
      ...column,
      BuilderConfig: {
        ...column.BuilderConfig,
        IsDynamicField: false,
      },
    }));

    acc[key] = {
      sortState,
      defaultColumns: filteredColumns,
    };
    return acc;
  }, {});
  return updatedData;
};

export const getUpdatedFetchdrilldownColumnsRes = (drilldownColumnConfigResponse: DrilldownColumnConfig,
  appliedMeasures: IColumn[], config: IdrilldownConfigInfo, calculatedMeasuresList: IBuilderMeasure[], state:IReportBuilderState) => {
  const drilldownColumns = {} as DrilldownColumnConfig;
  const newConfigMapping = cloneDeep(config.drilldownConfigMapping);
  const measureIds = appliedMeasures?.map((measure:IColumn) => measure?.Id) || [];

  // Filter drilldownConfigMapping to remove unwanted measures
  const filteredDrilldownConfigMapping = Object.keys(newConfigMapping).reduce((acc:DrilldownConfigMapping, key) => {
    const filteredMeasures = newConfigMapping[key].filter((measure:MeasureListWithJoinId) => measureIds.includes(measure.Id));

    if (filteredMeasures.length > 0) {
      acc[key] = filteredMeasures;
    }
    return acc;
  }, {});

  // adding measures to the drilldownConfig which were added in report page
  const doesDrilldownConfigExist = (measureId: string) => Object.values(filteredDrilldownConfigMapping).some((configList) => configList.some(({ Id }) => Id === measureId));

  const isCalculated = fromPairs((calculatedMeasuresList || []).map((column) => [column?.Alias, true]));

  const measuresWithoutDrilldownConfig = [] as IColumn[];
  const builderMeasuresList = builderMeasuresListSelector({ reportBuilder: state } as IGlobalState);

  appliedMeasures.forEach((measure: IColumn) => {
    let expr = measure?.Props?.Measure?.Expression;
    if (!expr) {
      const selectedMeasure = builderMeasuresList.find((builderMeasure: IBuilderMeasure) => builderMeasure.Id === measure.Id);
      expr = selectedMeasure?.MeasureExpression;
    }
    if (!doesDrilldownConfigExist(measure.Id) && !isCalculated[measure.Name] && isDrilldownPossible(expr)) {
      measuresWithoutDrilldownConfig.push(measure);
    }
  });

  const updatedMeasuresList = measuresWithoutDrilldownConfig?.map((measure: IColumn) => setDrilldownEnableFlag(measure)) || [];

  const additionalMapperInfo = getDrilldownMapping(updatedMeasuresList || [], state);

  // removing unwanted keys from drilldownConfig which are removed from drilldownMapper
  const accordIds = Object.keys(drilldownColumnConfigResponse || {}) || [];
  const mapperAccordIds = Object.keys(newConfigMapping || {}) || [];
  const updatedAccordIds = accordIds.filter((item:string) => mapperAccordIds.includes(item));
  let entityGroupStore = {};
  updatedAccordIds.forEach((key: string) => {
    const defaultCols = drilldownColumnConfigResponse[key]?.defaultColumns || [];
    const updatedCols = defaultCols.map((measure: IColumn) => ({
      ...measure,
      Props: {
        ...measure.Props,
        Dimension: {
          ...measure.Props.Dimension,
          Applied: DimensionStatus.Applied,
        },
      },
    }));
    drilldownColumns[key] = {
      ...drilldownColumnConfigResponse[key],
      defaultColumns: updatedCols,
      additionalDrilldownColumns: [],
      isAdditionalColumnFetched: false,
    };
    entityGroupStore = {
      ...entityGroupStore,
      ...generateEntityStore(updatedCols, state?.updatedReportBuilderInfo?.entityGroupStore),
    };
  });
  state.updatedReportBuilderInfo.entityGroupStore = {
    ...state.updatedReportBuilderInfo.entityGroupStore,
    ...entityGroupStore,
  };
  const configMapping = { ...filteredDrilldownConfigMapping, ...additionalMapperInfo };
  return { configMapping, drilldownColumns };
};

// Returns the updated drilldown mapper when custom expression is edited,
// @originalMeasure:current measure
// @updatedMeasure:new measure
// @config:drilldownConfigInfo
// @defaultEntity:default entity for the report
// @fieldsData:fields data api response
export const handleCustExpUpdateForDrilldownMapper = (
  originalMeasure:IColumn,
  updatedMeasure:IColumn,
  config: IdrilldownConfigInfo,
  defaultEntity: string,
  fieldsData: Array<IField>,
) => {
  let newConfigMapping = cloneDeep(config.drilldownConfigMapping);
  const newConfigColumns = cloneDeep(config.drilldownColumnConfig);

  const originalCol = getEntityJoinIdForCustomMeasure(fieldsData, originalMeasure, defaultEntity);
  const originalColMeasure = { joinId: originalCol.JoinId, entity: originalCol.Entity };

  const newCol = getEntityJoinIdForCustomMeasure(fieldsData, updatedMeasure, defaultEntity);
  const newColMeasure = { joinId: newCol.JoinId, entity: newCol.Entity };

  const isEntityOrJoinIdModified = !isEqual(originalColMeasure, newColMeasure);
  // this shouldn't be compare with id key as this is specifically to check if measure name is modified or not
  const isNameModified = originalMeasure.Name !== updatedMeasure.Name;

  const isOnlyNameModified = isNameModified && !isEntityOrJoinIdModified;
  const changeDetected = isEntityOrJoinIdModified || isNameModified;

  const isDrilldownAllowed = isDrilldownPossible(updatedMeasure.Props.Measure?.Expression);

  if (!changeDetected) {
    return { newConfigMapping, newConfigColumns };
  }
  Object.keys(newConfigMapping).forEach((key) => {
    const index = newConfigMapping[key]?.findIndex(
      (item) => item.Name === originalMeasure.Name && item.JoinId === originalColMeasure.joinId,
    );
    if (index !== -1) {
      if (isOnlyNameModified) {
        newConfigMapping[key][index] = { ...newConfigMapping[key][index], Name: updatedMeasure.Name, Id: updatedMeasure?.Id };
      } else {
        newConfigMapping[key].splice(index, 1);
        if (newConfigMapping[key].length === 0) {
          delete newConfigMapping[key];
          delete newConfigColumns[key];
        }
      }
    }
  });

  if (isDrilldownAllowed && isEntityOrJoinIdModified) {
    const id = uuidv4();
    newConfigMapping = {
      ...newConfigMapping,
      [id]: [{
        Id: updatedMeasure.Id, Name: updatedMeasure.Name, JoinId: newColMeasure.joinId, Entity: newColMeasure.entity,
      }],
    };
  }

  return { newConfigMapping, newConfigColumns };
};
// Returns the updated report builder state on switch user filter
// @state: report builder state
// @payload: index of filters
export const getStateOnSwitchUserFilter = (state:IReportBuilderState, payload:ISwitchUserFieldFilterPayload) => {
  const newState = state;
  let newFilterConfig = newState.filterBuilder.filterConfig;
  const { Title, Description } = newState.updatedReportBuilderInfo.reportBuilderSavePayload.Details;
  const { index } = payload;
  const primaryUserFilter = newFilterConfig?.find((filter: IFilterConfig) => filter.Type === FilterType.UserMultiSelect && filter.IsPrimaryUserFilter);
  if (isValidArrayAndNotEmpty(newFilterConfig) && isValidObjectAndNotEmpty(primaryUserFilter)) {
    newState.assortedInfo.isFormDisabled = getIsReportBuilderSaveFormDisable(Title, Description, state)
        || getIsFilterFormDisable(newState.filterBuilder);
    const newAppliedFilters = newState.filterBuilder.appliedFilters;

    const preAppliedUserFilter = newFilterConfig.find((filter) => filter.Type === FilterType.PRE_APPLIED && filter.DefaultValue === userDefaultFilterValue);
    if (primaryUserFilter) {
      delete newAppliedFilters[primaryUserFilter?.ID];
    }
    const additionalUserFilters = isValidArrayAndNotEmpty(newState?.reportBuilderInfo.additionalFilters) ? newState?.reportBuilderInfo.additionalFilters.filter((filter: IFilterConfig) => filter.Type === FilterType.UserMultiSelect) : [];

    const dynamicFilter = additionalUserFilters[index];

    newFilterConfig = isValidArrayAndNotEmpty(newFilterConfig) && newFilterConfig.filter(
      (config: IFilterConfig) => config?.ID !== dynamicFilter?.ID && primaryUserFilter?.ID !== config?.ID,
    );

    if (dynamicFilter && !dynamicFilter?.LinkedTo) {
      dynamicFilter.LinkedTo = primaryUserFilter?.LinkedTo;
      dynamicFilter.LinkedPreAppliedFilterId = preAppliedUserFilter?.ID || '';
      dynamicFilter.DataType = primaryUserFilter?.DataType;
    }
    if (dynamicFilter) {
      dynamicFilter.IsPrimaryUserFilter = true;
      newFilterConfig.push(dynamicFilter);
      newAppliedFilters[dynamicFilter.ID] = new FilterFetchUtility(null).GetDefaultSingleFilter(dynamicFilter, null);

      const userMultiSelectFilterData = isValidArrayAndNotEmpty(newFilterConfig) && newFilterConfig.find(
        (config: IFilterConfig) => config.Type === FilterType.UserMultiSelect && config.IsPrimaryUserFilter,
      );

      if (userMultiSelectFilterData) {
        newState.filterBuilder.isUsersModified = true;
        newAppliedFilters[userMultiSelectFilterData.ID] = new FilterFetchUtility(null).GetDefaultSingleFilter(
          userMultiSelectFilterData,
          null,
        );
      }
    }

    newState.filterBuilder.filterConfig = newFilterConfig;
    newState.filterBuilder.appliedFilters = newAppliedFilters;
  }

  return newState;
};

// Returns the updated report builder state on switch filter filter
// @state: report builder state
// @payload: index of filters
export const getStateOnSwitchUserFilterInSubQueryBuilder = (state:IReportBuilderState, payload:ISwitchUserFieldFilterPayload) => {
  const newState = state;
  const { index } = payload;
  const { filterConfig, appliedFilters } = newState.reportQueryBuilder.SelectedQueryData.updatedInfo.filterBuilder;
  const { AdditionalFilters: additionalFilters } = newState.reportQueryBuilder.SelectedQueryData.additionalData;
  let newFilterConfig = filterConfig;
  const newAppliedFilters = appliedFilters;

  const primaryUserFilter = newFilterConfig?.find((filter: IFilterConfig) => filter.Type === FilterType.UserMultiSelect && filter.IsPrimaryUserFilter);
  if (isValidArrayAndNotEmpty(newFilterConfig) && isValidObjectAndNotEmpty(primaryUserFilter)) {
    const preAppliedUserFilter = newFilterConfig.find((filter) => filter.Type === FilterType.PRE_APPLIED && filter.DefaultValue === userDefaultFilterValue);
    if (primaryUserFilter) {
      delete newAppliedFilters[primaryUserFilter?.ID];
    }
    const additionalUserFilters = isValidArrayAndNotEmpty(additionalFilters) ? additionalFilters.filter((filter: IFilterConfig) => filter.Type === FilterType.UserMultiSelect) : [];

    const dynamicFilter = additionalUserFilters[index];

    newFilterConfig = isValidArrayAndNotEmpty(newFilterConfig) && newFilterConfig.filter(
      (config: IFilterConfig) => config?.ID !== dynamicFilter?.ID && primaryUserFilter?.ID !== config?.ID,
    );

    if (dynamicFilter && !dynamicFilter?.LinkedTo) {
      dynamicFilter.LinkedTo = primaryUserFilter?.LinkedTo;
      dynamicFilter.LinkedPreAppliedFilterId = preAppliedUserFilter?.ID || '';
      dynamicFilter.DataType = primaryUserFilter?.DataType;
      dynamicFilter.IsPrimaryUserFilter = true;
    }
    if (dynamicFilter) {
      newFilterConfig.push(dynamicFilter);
      newAppliedFilters[dynamicFilter.ID] = new FilterFetchUtility(null).GetDefaultSingleFilter(dynamicFilter, null);

      const userMultiSelectFilterData = isValidArrayAndNotEmpty(newFilterConfig) && newFilterConfig.find(
        (config: IFilterConfig) => config.Type === FilterType.UserMultiSelect && config.IsPrimaryUserFilter,
      );

      if (userMultiSelectFilterData) {
        newState.reportQueryBuilder.SelectedQueryData.updatedInfo.filterBuilder.isUsersModified = true;
        newAppliedFilters[userMultiSelectFilterData.ID] = new FilterFetchUtility(null).GetDefaultSingleFilter(
          userMultiSelectFilterData,
          null,
        );
      }
    }

    newState.reportQueryBuilder.SelectedQueryData.updatedInfo.filterBuilder.filterConfig = newFilterConfig;
    newState.reportQueryBuilder.SelectedQueryData.updatedInfo.filterBuilder.appliedFilters = newAppliedFilters;
  }

  return newState;
};
/**
 * Generates the dimension metafields payload for saving a report.
 *
 * @param dimennsionMetaFields - The existing dimension metafields.
 * @param dimensions - The list of all dimensions.
 * @returns An updated array of dimension metafields including the applied user dimension.
 */
export const getSavePayloadDimensionMetafields = (state: IReportBuilderState,
  dimennsionMetaFields: IDimensionsMetaFields[],
  dimensions: IDimension[],
  addSubBuilderMetaFields?: boolean,
  entityGroupStore?: Record<string, string>,
  entityGroupOptionsMap?: Record<string, IDimensionMetaField[]>,
  selectedQuery?: string): IDimensionsMetaFields[] => {
  const updatedDimenstionMetaFields = getSavePayloadEntityGroupDimensionMetafields(dimennsionMetaFields, dimensions, entityGroupStore, entityGroupOptionsMap);
  if (!addSubBuilderMetaFields) return updatedDimenstionMetaFields;

  if (addSubBuilderMetaFields) {
    const queryList = state?.reportQueryBuilder?.DynamicQueryList;

    queryList.forEach((query) => {
      let queryAppliedDimensions = [];

      if (selectedQuery && query?.Id === selectedQuery) {
        queryAppliedDimensions = state?.reportQueryBuilder.SelectedQueryData?.updatedInfo?.AppliedDimensions;
      } else {
        queryAppliedDimensions = query?.QueryDataInfo?.updatedInfo?.AppliedDimensions;
      }

      if (isValidArrayAndNotEmpty(queryAppliedDimensions)) {
        const appliedQueryUserFields = queryAppliedDimensions.filter(
          (dim: IDimension) => dim.Applied === DimensionStatus.Applied
          && !dim.Props?.IsUserDynamicField
          && dim.BuilderConfig?.Alias !== 'LeadType' && dim.BuilderConfig?.Alias !== 'LeadLeadType'
          && !dim?.Props?.IsSourceCustomColumn,
        );

        appliedQueryUserFields?.forEach((appliedQueryUserField) => {
          const exists = updatedDimenstionMetaFields.some(
            (field) => field.QueryId === query?.Id
            && field.Id === appliedQueryUserField?.Id,
          );

          if (!exists) {
            const appliedQueryDimensionMetaField: IDimensionsMetaFields = {
              Id: appliedQueryUserField?.Id,
              Dimension: appliedQueryUserField?.Name,
              QueryId: query?.Id,
              Type: 'User',
              Fields: [
                {
                  SchemaName: UserNameConstant,
                  Alias: appliedQueryUserField?.ReferTo,
                  Id: appliedQueryUserField?.ReferTo,
                },
              ],
            };

            updatedDimenstionMetaFields.push(appliedQueryDimensionMetaField);
          }
        });
      }
    });
  }
  return updatedDimenstionMetaFields;
};

export const getHierarchyField = (dimension: IDimension) => {
  const fieldName = dimension.Id.split(UserDelimiter);
  return fieldName[0] + UserHierarchy;
};

export const getReportHierarchy = (dimension: IDimension, hierarchy: IHierarchy) => {
  if (dimension) {
    return {
      ...hierarchy, DimensionId: dimension?.Id, DimensionAlias: dimension?.Name, HierarchyField: getHierarchyField(dimension),
    };
  }
  return isValidObjectAndNotEmpty(hierarchy) ? hierarchy : {};
};

export const isNamespaceSelectionModified = (namespaceList1:string[], namespaceList2:string[]) => {
  if (namespaceList1.length !== namespaceList2.length) {
    return true;
  }
  if (isEqual(sortBy(namespaceList1), sortBy(namespaceList2))) {
    return false;
  }
  return true;
};
/**
 * reformats the get-data-sources api response
 *
 * @param res - get-data-sources api response
 * @returns updated response
 */
export const getUpdatedDataSourceResponse = (state: IReportBuilderState, res: IDataSourceApiResponse[]): IDataSourceResponse => {
  const existingDataSources = state.dataSourceInfo.dataSources || {};
  const subBuilders = state.updatedReportBuilderInfo?.reportBuilderSavePayload?.SubBuilders || [];
  const updatedDataSourceList :IDataSourceResponse = {};
  if (isValidArrayAndNotEmpty(res)) {
    res.forEach((dataSource: IDataSourceApiResponse) => {
      const namespaceId = dataSource.NamespaceId;
      const defaultFieldObj = dataSource.DefaultField;
      updatedDataSourceList[namespaceId] = {
        ...dataSource,
        DefaultField: {
          DataType: defaultFieldObj?.BuilderConfig?.DataType,
          DisplayName: defaultFieldObj?.BuilderConfig?.DisplayName,
          SchemaName: defaultFieldObj?.BuilderConfig?.Alias, // setting alias as schema name because within api response of report config join object, the key is schema but the value is alias
        },
        AdditionalFields: isValidArrayAndNotEmpty(dataSource?.AdditionalFields) ? dataSource.AdditionalFields.map((col: IColumn) => ({
          DataType: col?.BuilderConfig?.DataType,
          DisplayName: col?.BuilderConfig?.DisplayName,
          SchemaName: col?.BuilderConfig?.Alias,
        })) : null,
        IsQuery: false,
      };
    });
  }
  if (isValidArrayAndNotEmpty(subBuilders)) {
    subBuilders.forEach((subBuilder) => {
      updatedDataSourceList[subBuilder.QueryId] = {
        NamespaceId: subBuilder.QueryId,
        Entity: FieldEntitiesType.Query,
        DisplayName: subBuilder.DisplayName,
        DefaultField: existingDataSources[subBuilder.QueryId]?.DefaultField || updatedDataSourceList[subBuilder.QueryId]?.DefaultField,
        AdditionalFields: existingDataSources[subBuilder.QueryId]?.AdditionalFields || updatedDataSourceList[subBuilder.QueryId]?.AdditionalFields || null,
        IsQuery: true,
      };
    });
  }
  return updatedDataSourceList;
};

export const getUpdatedDataSourceFieldsResponse = (state: IReportBuilderState, res: IColumn[], dataSourceId:string):IDataSourceResponse => {
  const existingDataSources = state.dataSourceInfo.dataSources || {};
  const getAddFields = res?.map((col: IColumn) => ({
    DataType: col?.BuilderConfig?.DataType,
    DisplayName: col?.BuilderConfig?.DisplayName,
    SchemaName: col?.BuilderConfig?.Alias,
  })) ?? [];
  const updatedDataSourceList :IDataSourceResponse = {};
  const dataSourceKeys = Object.keys(existingDataSources);
  dataSourceKeys.forEach((item) => {
    if (item === dataSourceId) {
      updatedDataSourceList[item] = {
        ...existingDataSources[item],
        AdditionalFields: getAddFields,
      };
    } else {
      updatedDataSourceList[item] = existingDataSources[item];
    }
  });
  return updatedDataSourceList;
};

export const convertDrilldownMappingIntoIdMapping = (currentDrilldownMapping: any, appliedMeasuresList: IColumn[]):DrilldownConfigMapping => {
  const currentDrilldownMappingKeys = Object.keys(currentDrilldownMapping);
  const updatedIdBasedMapping = {} as DrilldownConfigMapping;

  currentDrilldownMappingKeys.forEach((drilldownGroupingKey: string) => {
    const drilldownMeasuresList = currentDrilldownMapping[drilldownGroupingKey];
    const updatedMapping = drilldownMeasuresList.map((measureName: string) => {
      const measureObj = appliedMeasuresList?.find((measure: IColumn) => measure?.Name === measureName);
      return {
        Name: measureObj?.Name,
        Entity: measureObj?.BuilderConfig?.Entity,
        JoinId: measureObj?.BuilderConfig?.JoinID,
        Id: measureObj?.Id,
      };
    });
    updatedIdBasedMapping[drilldownGroupingKey] = updatedMapping;
  });

  return updatedIdBasedMapping;
};

export const updateSelectedFn = (state: IReportBuilderState, payload: IUpdateQueryPayload) => {
  const {
    queryId, variables, updateBreadcrumb, breadcrumbType,
  } = payload;
  const { reportQueryBuilder } = state;
  reportQueryBuilder.SelectedQuery = queryId;
  const { DataSourceMapping, DynamicQueryList } = reportQueryBuilder;
  const queryExtraData = DynamicQueryList.find((query) => query.Id === queryId);
  const selectedQueryUIInfo = queryExtraData?.QueryDataInfo;
  const queryConfig = queryExtraData?.QueryConfig;
  if (selectedQueryUIInfo) {
    reportQueryBuilder.SelectedQueryData = queryExtraData.QueryDataInfo;
  } else {
    // Use a dedicated object so we don't mutate parent's QueryDataInfo; required after cancel → re-edit
    const freshSelectedQueryData = cloneDeep(initialReportBuilderState.reportQueryBuilder.SelectedQueryData);
    if (queryConfig) {
      prepareUICompatibleConfig(
        state,
        queryConfig,
        freshSelectedQueryData,
        variables,
        DataSourceMapping[queryId]?.PrimaryNamespace,
        DynamicQueryList,
      );
    }
    // When QueryConfig is null (first visit to subquery), overlay ShowInMainReport
    // filter values from the main report's current appliedFilters so the subquery
    // picks up any changes the user made at the main report level.
    if (!queryConfig && freshSelectedQueryData.updatedInfo?.filterBuilder) {
      const mainAppliedFilters = state.filterBuilder.appliedFilters;
      overlayMainReportFilterValues(freshSelectedQueryData.updatedInfo?.filterBuilder, mainAppliedFilters);
    }
    reportQueryBuilder.SelectedQueryData = freshSelectedQueryData;
    if (queryExtraData) queryExtraData.QueryDataInfo = freshSelectedQueryData;
  }
  if (queryId === ROOT_QUERY_KEY) {
    reportQueryBuilder.SelectedQueryData.NameSpace = DataSourceMapping[ROOT_QUERY_KEY]?.PrimaryNamespace;
  }
  if (updateBreadcrumb) {
    const breadcrumbItem = {
      label: isValidObjectAndNotEmpty(queryExtraData) ? queryExtraData.Name : '',
      isActive: false,
      queryId: state.reportQueryBuilder.SelectedQuery,
      type: SubQueryPanelType.query,
    };
    if (state.reportQueryBuilder.BreadcrumbData?.length > 0) {
      if (state.reportQueryBuilder.BreadcrumbData[state.reportQueryBuilder.BreadcrumbData.length - 1].queryId === ROOT_QUERY_KEY) {
        state.reportQueryBuilder.BreadcrumbData[state.reportQueryBuilder.BreadcrumbData.length - 1].isActive = true;
      } else {
        state.reportQueryBuilder.BreadcrumbData[state.reportQueryBuilder.BreadcrumbData.length - 1].isActive = DataSourceMapping[queryId].isEditMode;
      }
      state.reportQueryBuilder.BreadcrumbData = [...state.reportQueryBuilder.BreadcrumbData, breadcrumbItem];
    }
  } else {
    // case - edit of query, when user navigates by clicking on a breadcrumb
    const breadcrumbs = [...state.reportQueryBuilder.BreadcrumbData];
    const breadcrumbItemIndex = breadcrumbs.findIndex((item) => item.queryId === queryId && item.type === breadcrumbType);
    breadcrumbs.splice(breadcrumbItemIndex + 1);
    breadcrumbs[breadcrumbItemIndex].isActive = false;
    state.reportQueryBuilder.BreadcrumbData = breadcrumbs;
  }
};

export const getStateOnSaveSubQuery = (state: IReportBuilderState, saveSubQueryPayload: SaveSubQueryPayload) => {
  const { queryName, partitionColumnFilterDateLimit } = saveSubQueryPayload;
  const newState = state;
  const selectedQueryData = newState.reportQueryBuilder.SelectedQueryData;
  const selectedQueryId = newState.reportQueryBuilder.SelectedQuery;
  const queryList = newState.reportQueryBuilder.DynamicQueryList;
  let dataSources = newState.dataSourceInfo.dataSources;
  const BreadcrumbData = newState.reportQueryBuilder.BreadcrumbData;
  const parentQueryId = newState.reportQueryBuilder.DynamicQueryList.find((item: IQueryInfo) => item.Id === selectedQueryId)?.ParentQueryId;
  const queryExtraData = queryList.find((query) => query.Id === selectedQueryId);
  queryList.forEach((item: IQueryInfo) => {
    if (item.Id === selectedQueryId) {
      item.IsDraft = false;
    }
  });
  newState.reportQueryBuilder.DataSourceMapping[selectedQueryId].isDataSourceSaved = false;
  newState.reportQueryBuilder.DynamicQueryList.forEach((item: IQueryInfo) => {
    if (item.Id === newState.reportQueryBuilder.SelectedQuery) {
      item.Name = queryName;
    }
  });

  const breadcrumbs = [...BreadcrumbData];
  const updatedbreadcrumbs = breadcrumbs.filter((item) => !(item.queryId === selectedQueryId && item.type === SubQueryPanelType.query));
  if (updatedbreadcrumbs.length > 0) {
    updatedbreadcrumbs[updatedbreadcrumbs.length - 1].isActive = false;
  }
  state.reportQueryBuilder.BreadcrumbData = updatedbreadcrumbs;

  const builder = prepareBuilderSavePayloadForQuery(
    selectedQueryId,
    selectedQueryData,
    newState.reportQueryBuilder.DataSourceMapping,
    queryExtraData.QueryConfig,
    queryExtraData.Name,
    partitionColumnFilterDateLimit,
  );
  queryList.forEach((query: IQueryInfo) => {
    if (query.Id === selectedQueryId) {
      query.QueryPayload = builder;
      query.QueryDataInfo = selectedQueryData; // the latest changes for a query
    }
  });

  const defaultField = selectedQueryData.updatedInfo.AppliedDimensions?.find((field) => field.Applied === DimensionStatus.Applied);
  let displayName = defaultField?.BuilderConfig?.DisplayName;
  if (defaultField?.Props?.ReferTo) {
    displayName = selectedQueryData?.updatedInfo?.AppliedDimensions?.find((item) => item.Id === defaultField?.Props?.ReferTo)?.Name;
  }

  dataSources = {
    ...dataSources,
    [selectedQueryId]: {
      NamespaceId: selectedQueryId,
      Entity: FieldEntitiesType.Query,
      DisplayName: queryName,
      DefaultField: {
        DataType: defaultField?.BuilderConfig?.DataType,
        DisplayName: displayName,
        SchemaName: defaultField?.Id,
      },
      AdditionalFields: getCompatibleAdditionalFields(selectedQueryData),
      IsQuery: true,
    },
  };
  const parentdataSourceMappingInfo = newState.reportQueryBuilder.DataSourceMapping[parentQueryId];
  if ((selectedQueryData?.QueryJoinRelation?.JoinBlockindex === 0 && selectedQueryData?.QueryJoinRelation?.JoinBlockFieldSelection === DataSourceSelectionType.lhsTable) || (selectedQueryData?.QueryJoinRelation?.JoinBlockFieldSelection === DataSourceSelectionType.querySource)) {
    parentdataSourceMappingInfo.PrimaryNamespace = selectedQueryId;
  }
  if (isValidArrayAndNotEmpty(parentdataSourceMappingInfo.Joins)) {
    const joinIndex = selectedQueryData.QueryJoinRelation.JoinBlockindex;
    if (joinIndex < 0 || joinIndex >= parentdataSourceMappingInfo.Joins.length) return newState;
    const originalJoin = parentdataSourceMappingInfo.Joins[joinIndex];
    const joinData = cloneDeep(originalJoin);
    if (!joinData.Primary && joinData.On) joinData.Primary = getDataSourcesFromJoinObj(joinData).primaryDataSource;
    switch (selectedQueryData.QueryJoinRelation.JoinBlockFieldSelection) {
      case DataSourceSelectionType.lhsTable: {
        joinData.Primary = selectedQueryId;
        joinData.On = getDefaultJoinCriteria(joinData.Primary || parentdataSourceMappingInfo.PrimaryNamespace, joinData?.With, dataSources, parentdataSourceMappingInfo.PrimaryNamespace, joinData.On, queryList, selectedQueryData);
        break;
      }
      case DataSourceSelectionType.rhsTable: {
        joinData.With = selectedQueryId;
        joinData.ID = `${JoinPrefix}${selectedQueryId}`;
        joinData.On = getDefaultJoinCriteria(joinData.Primary || parentdataSourceMappingInfo.PrimaryNamespace, joinData?.With, dataSources, parentdataSourceMappingInfo.PrimaryNamespace, joinData.On, queryList, selectedQueryData);
        joinData.IsCTE = parentdataSourceMappingInfo.PrimaryNamespace !== selectedQueryId;
        break;
      }
      default: break;
    }

    for (let i = joinIndex; i < parentdataSourceMappingInfo.Joins.length; i += 1) {
      const queryId = parentdataSourceMappingInfo.Joins[i]?.Primary;
      if (selectedQueryId === queryId) {
        parentdataSourceMappingInfo.Joins[i].On = getDefaultJoinCriteria(parentdataSourceMappingInfo.Joins[i].Primary || parentdataSourceMappingInfo.PrimaryNamespace, parentdataSourceMappingInfo.Joins[i].With, dataSources, parentdataSourceMappingInfo.PrimaryNamespace, parentdataSourceMappingInfo.Joins[i].On, queryList, selectedQueryData);
      }
    }
    const associatedQueryId = selectedQueryData.QueryJoinRelation.JoinBlockFieldSelection === DataSourceSelectionType.lhsTable ? originalJoin?.Primary : originalJoin?.With;
    if (joinIndex < parentdataSourceMappingInfo.Joins.length - 1
      && joinIndex === parentdataSourceMappingInfo.JoinBlockIndexBeingEdited
      && associatedQueryId
      && selectedQueryId !== associatedQueryId
    ) {
      for (let i = joinIndex; i < parentdataSourceMappingInfo.Joins?.length; i += 1) {
        const queryId = associatedQueryId;
        const isQueryExists = queryList?.some((query) => query.Id === queryId);
        if (isQueryExists) {
          deleteSubQueryFn(state, queryId, false);
        }
      }
      parentdataSourceMappingInfo.Joins.splice(joinIndex + 1);
    }
    parentdataSourceMappingInfo.Joins[joinIndex] = joinData;
  }

  if (parentQueryId !== ROOT_QUERY_KEY) {
    queryList.forEach((item: IQueryInfo) => {
      if (item.Id === parentQueryId) {
        if (!item.LinkedQueryIds) {
          item.LinkedQueryIds = [];
        }
        item.LinkedQueryIds.push(selectedQueryId);
      }
    });
    newState.reportQueryBuilder.DynamicQueryList = queryList;
  }
  newState.reportQueryBuilder.DataSourceMapping = { ...newState.reportQueryBuilder.DataSourceMapping, [parentQueryId]: parentdataSourceMappingInfo };
  newState.dataSourceInfo.dataSources = dataSources;
  newState.reportQueryBuilder.DataSourceMapping[parentQueryId] = parentdataSourceMappingInfo;
  if (parentQueryId === ROOT_QUERY_KEY) {
    newState.reportQueryBuilder.DataSourceMappingPayload = cloneDeep(newState.reportQueryBuilder.DataSourceMapping);
    newState.reportQueryBuilder.StaticQueryList = newState.reportQueryBuilder.DynamicQueryList;
  }
  return newState;
};

const getCompatibleAdditionalFields = (selectedQueryData: ISelectedQueryInfo) => {
  let addtMeasures = [] as IDataSourceFieldType[];
  let addtDimensions = [] as IDataSourceFieldType[];
  if (isValidArrayAndNotEmpty(selectedQueryData.updatedInfo.AppliedDimensions)) {
    addtDimensions = selectedQueryData.updatedInfo.AppliedDimensions
      .filter((col: IDimension) => col.Applied)
      ?.map((col: IDimension) => {
        let displayName = col?.BuilderConfig?.DisplayName;
        if (col.Props.ReferTo) {
          displayName = selectedQueryData?.updatedInfo?.AppliedDimensions?.find((item) => item.Id === col?.Props?.ReferTo)?.Name;
        }
        return ({
          DataType: col?.BuilderConfig?.DataType,
          DisplayName: displayName,
          SchemaName: col?.Id, // replace schema Name with Id for fields derived from query
        });
      });
  }
  if (isValidArrayAndNotEmpty(selectedQueryData.updatedInfo?.AppliedMeasures)) {
    addtMeasures = selectedQueryData.updatedInfo?.AppliedMeasures
      ?.map((col) => ({
        DataType: col?.BuilderConfig?.DataType,
        DisplayName: col?.Name,
        SchemaName: col?.Id, // replace schema Name with Id for fields derived from query
      }));
  }

  return [...addtDimensions, ...addtMeasures];
};

export const prepareUICompatibleConfig = (
  state: IReportBuilderState,
  response: IRawTemplate,
  SelectedQueryData: ISelectedQueryInfo,
  variables: IVariables,
  primaryNamespace: string,
  queryList?: IQueryInfo[],
) => {
  const ReportConfig = response?.ReportConfig;
  const allColumnsAndMeasures = [...ReportConfig?.Builder[0]?.Select?.Dimensions, ...ReportConfig?.Builder[0]?.Select?.Measures];
  if (state.reportEditInfo.isEditing) {
    ReportConfig.Columns = isValidArray(ReportConfig?.Columns) && ReportConfig?.Columns?.map((column: IColumn) => {
      const correspondingColumnEntryInBuilder = allColumnsAndMeasures.find((col) => col?.Id === column?.Id);
      if (column?.Props?.Measure?.IsCustomExpression) {
        const customMeasureBuilder = isValidArrayAndNotEmpty(ReportConfig.Builder) && ReportConfig.Builder[0].Select.Measures.find((measure) => measure?.Id === column?.Id);
        column = {
          ...column,
          BuilderConfig: {
            ...column.BuilderConfig,
            Alias: column?.Name,
            Entity: FieldEntitiesType.Custom,
            uniqueKey: column.Id,
          },
          Props: {
            ...column?.Props,
            Measure: {
              ...column?.Props?.Measure,
              Expression: customMeasureBuilder.MeasureExpression,
            },
          },
        };
      }
      if (column?.Props?.Dimension?.IsCustomExpression) {
        column = {
          ...column,
          BuilderConfig: {
            ...column.BuilderConfig,
            uniqueKey: column.Id,
            Entity: FieldEntitiesType.Custom,
          },
        };
      }
      return {
        ...column,
        Props: {
          ...column?.Props,
          IsSourceCustomColumn: correspondingColumnEntryInBuilder?.IsSourceCustomColumn,
        },
      };
    });
  }
  const selectedQueryId = state.reportQueryBuilder.SelectedQuery;
  const filterMetaInfo: IFilterMetaInfo[] = response?.FilterMetaInfo;
  const appliedMeasures = getMeasureColumnsFromBuilder(ReportConfig?.Columns, ReportConfig?.Builder, ReportConfig?.CalculatedColumns, true);
  const appliedDimensions = getAppliedDimensionsFromColumns(ReportConfig?.Columns, filterMetaInfo);
  const calculatedColumns = new Set<string>(ReportConfig?.CalculatedColumns?.map((calculatedColumn: IBuilderMeasure) => calculatedColumn.Alias));
  const expressionStore = getExpressionStoreFromConfig(ReportConfig, {});
  const reconstructedFilterConfig = getFilterConfigFromBuilder(ReportConfig?.Builder, filterMetaInfo, []); // For Query passing sub Builder as empty array to not process the sub builder filters
  // Sub-query view: the wrapper UI entry is a main-report-level concept and must not appear in
  // this query's filter list. reconstructCustomFilters above collapsed constituents into a wrapper
  // (and dropped the constituent rows); expand each wrapper back to its ConstituentFilterConfigs
  // so the query report shows the actual standalone filter. Also strip AssociatedCustomFilterId
  // on the local clones — without this, getMergedFilterConfig's legacy fallback would
  // re-synthesize a wrapper at render time, breaking the appliedFilters lookup. Saves of the
  // query report dissociate the marker from FilterGroup items as well, so persisted data
  // matches this in-memory shape.
  const filterConfig = reconstructedFilterConfig.flatMap((f: IFilterConfig): IFilterConfig[] => {
    if (f.IsCustomFilter && isValidArrayAndNotEmpty(f.ConstituentFilterConfigs)) {
      return f.ConstituentFilterConfigs.map((c: IFilterConfig) => ({ ...c, AssociatedCustomFilterId: '' }));
    }
    return [f];
  });

  if (isValidArrayAndNotEmpty(filterMetaInfo)) {
    const groupIdFilterList = filterMetaInfo.filter(
      (filterInfo) => filterInfo?.ID?.startsWith(GroupFilterId),
    );

    if (isValidArrayAndNotEmpty(groupIdFilterList)) {
      groupIdFilterList.forEach((groupIdFilter) => {
        const newId = `${groupIdFilter?.ID?.replace(`_${selectedQueryId}`, '') ?? ''}_${selectedQueryId}`;
        const render: IFilterGroupRender = {
          ID: newId,
          Type: groupIdFilter.Type,
          DefaultValue: null,
          LinkedTo: groupIdFilter.LinkedTo,
          Label: groupIdFilter.Label,
          Metadata: groupIdFilter.Metadata,
          StyleConfig: null,
        };

        const updatedGroupIdFilter = {
          ...groupIdFilter,
          ID: newId,
          IsAdditional: false,
          AlwaysEnabled: false,
          DataType: ColumnDataTypes.String,
          Render: render,
        };

        if (!filterConfig?.some((config) => config.ID === newId)) {
          filterConfig.push(updatedGroupIdFilter);

          // Update LinkedTo in other filters
          filterConfig.forEach((filter) => {
            if (filter?.LinkedTo === GroupFilterId) {
              filter.LinkedTo = newId;
            }
          });
        }

        queryList?.forEach((query) => {
          if (query.Id === selectedQueryId) {
            ReportConfig.Builder[0].Filter.FilterGroup.push(updatedGroupIdFilter);
          }
        });
      });
    }
  }
  SelectedQueryData.NameSpace = primaryNamespace;
  SelectedQueryData.updatedInfo.AppliedDimensions = appliedDimensions;
  SelectedQueryData.updatedInfo.AppliedMeasures = appliedMeasures;
  SelectedQueryData.updatedInfo.CalculatedColumns = calculatedColumns;
  SelectedQueryData.updatedInfo.ExpressionStore = { ...expressionStore };
  if (state.reportEditInfo.isEditing) {
    SelectedQueryData.updatedInfo.filterBuilder.filterConfig = getUpdatedReportFilterConfig(filterConfig);
  } else {
    SelectedQueryData.updatedInfo.filterBuilder.filterConfig = filterConfig;
  }
  if (state.reportEditInfo.isEditing) {
    SelectedQueryData.Type = ReportConfig?.Builder[0]?.Type;
  }
  SelectedQueryData.updatedInfo.filterBuilder.UserDropdownSelectType = getUserDropdownSelectTypeFromRawConfig(state.reportEditInfo.rawReportConfig, selectedQueryId);
  SelectedQueryData.updatedInfo.filterBuilder.appliedFilters = getAppliedFilterFromTemplate(state, variables, filterConfig, SelectedQueryData?.updatedInfo?.filterBuilder?.UserDropdownSelectType);

  SelectedQueryData.updatedInfo.sortState = ReportConfig?.Sorting;
  SelectedQueryData.updatedInfo.Paging = ReportConfig?.Paging || initialReportBuilderState.reportQueryBuilder?.SelectedQueryData?.updatedInfo?.Paging;
  queryList?.forEach((query) => {
    if (query.Id === selectedQueryId) {
      query.QueryDataInfo = SelectedQueryData;
      SelectedQueryData.QueryJoinRelation = query.QueryJoinRelation;
    }
  });
};

export const getUserDropdownSelectTypeFromRawConfig = (rawConfig: IReportConfig, selectedQueryId: string) => {
  const filtersMetadata = rawConfig?.FiltersMetadata;
  if (isValidObjectAndNotEmpty(filtersMetadata) && selectedQueryId) {
    const subBuilderFiltersMetadata = filtersMetadata?.SubBuilderFiltersMetadata;
    if (isValidArrayAndNotEmpty(subBuilderFiltersMetadata)) {
      const queryMeta = subBuilderFiltersMetadata.find((metadata) => metadata.QueryId === selectedQueryId);
      return queryMeta?.UserDropdownSelectType ?? UserFilterPayloadType.All;
    }
  }
  return UserFilterPayloadType.All;
};

export const prepareBuilderSavePayloadForQuery = (
  queryId: string,
  queryData: ISelectedQueryInfo,
  dataSourceMapping: IDataSourceMapping,
  queryConfig: IRawTemplate,
  queryDisplayName: string,
  partitionLimit: number,
): IBuilder => {
  const builderList: IBuilder = null;
  if (!queryId) return builderList;
  const addedFilter = queryData.updatedInfo?.filterBuilder?.filterConfig.filter(
    (config: IFilterConfig) => config.IsRemoved !== true,
  );
  const appliedDimensions = queryData.updatedInfo?.AppliedDimensions;
  let appliedUserDimension = null as IDimension;

  const primaryUserFilter = addedFilter.find((filItem: IFilterConfig) => filItem.Type === FilterType.UserMultiSelect && filItem.IsPrimaryUserFilter);
  if (primaryUserFilter) {
    appliedUserDimension = appliedDimensions.find((dim: IDimension) => primaryUserFilter.LinkedDimensionId === dim.Id);
  }

  let newAppliedFilters = queryData.updatedInfo?.filterBuilder?.appliedFilters;
  if (isStringFieldApplied(appliedDimensions)) {
    newAppliedFilters = getUpdatedAppliedFiltersForPartitionColumn(
      queryData.updatedInfo.filterBuilder.filterConfig,
      newAppliedFilters,
      partitionLimit,
    );
  }

  const dimensions = getSavePayloadBuilderDimensions(queryData.updatedInfo.AppliedDimensions, queryConfig?.ReportConfig.Builder[0]?.Select?.Dimensions, queryData.updatedInfo.filterBuilder.filterConfig, undefined, undefined, undefined, queryId);
  const measures = getSavePayloadBuilderMeasures(queryData.updatedInfo.AppliedMeasures, queryConfig?.ReportConfig.Builder[0]?.Select?.Measures, queryId);

  // Generate custom columns from expression store
  let updatedCustomColumns: IReportBuilderCustomColumns[] = [];
  if (isValidObjectAndNotEmpty(queryData.updatedInfo.ExpressionStore)) {
    Object.values(queryData.updatedInfo.ExpressionStore).filter((customExp: ICustomExpression) => customExp.ExpressionType === ExpressionContext.Custom).forEach((customExp: ICustomExpression) => {
      try {
        const {
          Name, Id, BuilderConfig, Props,
        } = buildCustomDimension(customExp.displayName, customExp.Mode, customExp.jsonExpression, customExp.uniqueId, customExp.DataType, customExp?.dimensionType, customExp?.description);

        const updatedCustomColumn = {
          Name, Id, BuilderConfig, Props,
        } as IReportBuilderCustomColumns;

        updatedCustomColumn.Props = {
          ...updatedCustomColumn.Props,
          Description: customExp.description,
          Dimension: {
            ...updatedCustomColumn.Props.Dimension,
            Applied: customExp.Mode === ColumnModes.NotApplied ? DimensionStatus.NotApplied : DimensionStatus.Applied,
          },
        };

        updatedCustomColumns = [...updatedCustomColumns, updatedCustomColumn];
      } catch (error) {
        console.error('Error building custom column dimension', error);
      }
    });
  }
  const isUnionType = isUnionJoinType(dataSourceMapping[queryId].Joins);

  // Query report saves dissociate AssociatedCustomFilterId from every filter in the
  // persisted FilterGroup. Custom filter membership lives only on the main report's
  // CustomFilterDefinitions; carrying the marker on a sub-query's FilterGroup makes
  // updateReportTemplateFilterBuilder's orphan check drop the constituent on the next
  // save, and tricks getMergedFilterConfig into synthesizing a wrapper at render time.
  const stripAssociation = (groups: IFilterGroup[]): IFilterGroup[] => groups.map((g: IFilterGroup) => {
    if (!g.AssociatedCustomFilterId) return g;
    const { AssociatedCustomFilterId: _omit, ...rest } = g;
    return rest as IFilterGroup;
  });
  const dissociateBuilderFilter = (bf: IBuilderFilter): IBuilderFilter => ({
    ...bf,
    FilterGroup: isValidArrayAndNotEmpty(bf?.FilterGroup) ? stripAssociation(bf.FilterGroup) : bf?.FilterGroup,
    SubFilters: isValidArrayAndNotEmpty(bf?.SubFilters) ? bf.SubFilters.map(dissociateBuilderFilter) : bf?.SubFilters,
  });

  const queryFilter = dissociateBuilderFilter(
    getSavePayloadBuilderFilters(addedFilter, newAppliedFilters, queryConfig?.ReportConfig.Builder[0]?.Filter, queryId),
  );

  const builder: IBuilder = {
    Namespace: dataSourceMapping[queryId]?.PrimaryNamespace,
    Source: dataSourceMapping[dataSourceMapping[queryId]?.PrimaryNamespace] ? QuerySourceType.Query : QuerySourceType.Table,
    Select: {
      Dimensions: dimensions,
      Measures: measures,
    },
    Filter: queryFilter,
    Hierarchy: getReportHierarchy(appliedUserDimension, queryConfig?.ReportConfig.Builder[0]?.Hierarchy),
    Joins: dataSourceMapping[queryId].Joins,
    UnionConfig: isUnionType ? getUnionConfigFromJoins(dataSourceMapping[queryId].Joins, dataSourceMapping[queryId]?.PrimaryNamespace) : null,
    QueryId: queryId,
    DisplayName: queryDisplayName,
    Paging: queryData.updatedInfo?.Paging,
    Sorting: queryData.updatedInfo?.sortState,
    CustomColumns: updatedCustomColumns,
    Type: queryData?.Type,
    CustomHierarchies: null,
  };
  return builder;
};

export const updateNestedSchemaPropertyForCol = (obj: ObjModel.Obj, keyToFind: string, colId: any, colList:any[], isDim:boolean) :any => {
  if (typeof obj !== 'object' || obj === null) return obj;

  if (Object.prototype.hasOwnProperty.call(obj, keyToFind)) {
    let updatedSchemaName = obj.Column.SchemaName;
    if (isValidUUID(obj.TableNameOverride)) {
      const selectedColObj = colList?.find((col) => col.Id === colId);
      const objParamToSearch = isDim ? selectedColObj?.GroupByExpression : selectedColObj?.MeasureExpression;
      updatedSchemaName = objParamToSearch ? findSchemaNameForCol(objParamToSearch, 'SchemaName') : updatedSchemaName;
    }
    obj.Column.SchemaName = updatedSchemaName;
    return obj;
  }
  Object.keys(obj).forEach((key) => {
    if (typeof obj[key] === 'object' && obj[key] !== null) {
      updateNestedSchemaPropertyForCol(obj[key], keyToFind, colId, colList, isDim);
    }
  });
  return obj;
};

export const findSchemaNameForCol = (obj: ObjModel.Obj, keyToFind: string) :any => {
  if (typeof obj !== 'object' || obj === null) return null; // Return null instead of obj

  if (Object.prototype.hasOwnProperty.call(obj, keyToFind)) {
    return obj[keyToFind];
  }

  // eslint-disable-next-line no-restricted-syntax
  for (const key of Object.keys(obj)) {
    if (typeof obj[key] === 'object' && obj[key] !== null) {
      const result = findSchemaNameForCol(obj[key], keyToFind);
      if (result !== undefined) return result;
    }
  }

  return undefined;
};

export const updateSchemaNameForDimBuilderDimColumns = (colList:IBuilderDimension[], selectColList:IBuilderDimension[]) => colList.map((col: IBuilderDimension) => {
  const colCopy = cloneDeep(col);
  return {
    ...colCopy,
    GroupByExpression: {
      ...updateNestedSchemaPropertyForCol(colCopy.GroupByExpression, 'Column', colCopy.Id, selectColList, true),
    },
  };
});
export const updateSchemaNameForMeasureBuilderColumns = (colList:IBuilderMeasure[], selectColList:IBuilderMeasure[]) => colList.map((col:IBuilderMeasure) => {
  const colCopy = cloneDeep(col);
  return {
    ...colCopy,
    MeasureExpression: {
      ...updateNestedSchemaPropertyForCol(colCopy.MeasureExpression, 'Column', colCopy.Id, selectColList, false),
    },
  };
});
export const getSchemaNameUpdatedPayloadForSubBuilder = (queryPayload: IBuilder, builderSelectObj: IBuilderDimensionMeasure) => {
  let updatedDimensions = queryPayload.Select?.Dimensions;
  let updatedMeasures = queryPayload.Select?.Measures;
  updatedDimensions = updateSchemaNameForDimBuilderDimColumns(queryPayload.Select?.Dimensions, builderSelectObj?.Dimensions);
  updatedMeasures = updateSchemaNameForMeasureBuilderColumns(queryPayload.Select?.Measures, builderSelectObj?.Measures);
  const updatedSubBuilder = {
    ...queryPayload,
    Select: {
      ...queryPayload.Select,
      Dimensions: updatedDimensions,
      Measures: updatedMeasures,
    },
  };

  return updatedSubBuilder;
};
export const getSubBuilders = (queryId: string, parentQueryId: string, queryList: IQueryInfo[], builders: IBuilder[]) => {
  if (!queryId) return builders;
  let linkedQueryIds: string[] = [];
  const queryData = queryList.find((queryItem) => queryItem.Id === queryId);
  if (queryId !== ROOT_QUERY_KEY) {
    if (queryData?.QueryPayload && queryId !== parentQueryId) {
      if (builders?.findIndex((builder) => builder.QueryId === queryData.Id) < 0) {
        let builderPayload = queryData?.QueryPayload;
        // const expressionStore = queryData?.QueryDataInfo?.updatedInfo?.ExpressionStore || {};
        // add the custom columns to the builder payload if they are present in the query config

        // if queryId === selectedQuery, then populate the custom columns in the save payload from the expression store,
        // else populate the custom columns in the save payload from the query config
        // if (queryId === selectedQuery) {
        //   expressionStore = state?.reportQueryBuilder?.SelectedQueryData?.updatedInfo?.ExpressionStore || {};
        // } else {}

        // populate the custom columns in the save payload
        // let updatedCustomColumns: IReportBuilderCustomColumns[] = [];
        // const expStore = queryData?.QueryDataInfo?.updatedInfo?.ExpressionStore || {};
        // Object.values(expStore)?.filter((customExp: ICustomExpression) => customExp.ExpressionType === ExpressionContext.Custom)?.forEach((customExp: ICustomExpression) => {
        //   try {
        //     const {
        //       Name, Id, BuilderConfig, Props,
        //     } = buildCustomDimension(customExp.displayName, customExp.Mode, customExp.jsonExpression, customExp.uniqueId, customExp.DataType, customExp?.dimensionType);
        //     const updatedCustomColumn = {
        //       Name, Id, BuilderConfig, Props,
        //     } as IReportBuilderCustomColumns;

        //     updatedCustomColumn.Props = { ...updatedCustomColumn.Props, Dimension: { ...updatedCustomColumn.Props.Dimension, Applied: customExp.Mode === ColumnModes.NotApplied ? DimensionStatus.NotApplied : DimensionStatus.Applied } };

        //     /** check if the custom column is already present in the save payload
        //  * If present, then update the mode of the custom column, else add it to the save payload
        //  */
        //     updatedCustomColumns = (updatedCustomColumns ?? []) as IReportBuilderCustomColumns[];
        //     const customColumnIndex = updatedCustomColumns.findIndex((col) => col.Id === updatedCustomColumn.Id);
        //     if (customColumnIndex !== -1) {
        //       updatedCustomColumns[customColumnIndex] = updatedCustomColumn;
        //     } else {
        //       updatedCustomColumns = [...(updatedCustomColumns ?? []), updatedCustomColumn];
        //     }
        //   } catch (error) {
        //     console.error('Error building custom column dimension', error);
        //   }
        // });

        if (isValidArrayAndNotEmpty(queryData?.QueryConfig?.ReportConfig?.Builder[0]?.Select)) {
          builderPayload = getSchemaNameUpdatedPayloadForSubBuilder(queryData?.QueryPayload, queryData?.QueryConfig?.ReportConfig?.Builder[0]?.Select);
        }
        const isUnionType = isUnionJoinType(builderPayload?.Joins);
        const builderPayloadCopy = {
          ...builderPayload,
          UnionConfig: isUnionType ? getUnionConfigFromJoins(builderPayload?.Joins, builderPayload.Namespace) : null,
          // CustomColumns: updatedCustomColumns || [],
        };
        builders.push(builderPayloadCopy);
      }
    }
    linkedQueryIds = queryData.LinkedQueryIds;
  } else {
    linkedQueryIds = queryList.filter((query) => query.ParentQueryId === ROOT_QUERY_KEY)?.map((query) => query.Id);
  }
  if (isValidArrayAndNotEmpty(linkedQueryIds)) {
    linkedQueryIds.forEach((item) => {
      getSubBuilders(item, queryData?.ParentQueryId, queryList, builders);
    });
  }
  return builders;
};

export const getNestedQuerySaveReportConfigPayload = (state?:IReportBuilderState): IReportConfig => {
  const newState = cloneDeep(state) || store.getState().reportBuilder as IReportBuilderState;
  const partitionColumnFilterDateLimit = store?.getState()?.settings?.data?.Configuration[ModuleName.ReportBuilder].Settings?.Filter?.StringFieldPartitionFilterLimit;
  const {
    DynamicQueryList, SelectedQuery, SelectedQueryData, DataSourceMapping,
  } = state.reportQueryBuilder;

  if (!SelectedQuery || SelectedQuery === ROOT_QUERY_KEY) {
    return getRootQuerySaveReportConfigPayload(newState);
  }
  const linkedQueryIds: String[] = [];
  DynamicQueryList.forEach((query) => {
    if (query.ParentQueryId === ROOT_QUERY_KEY) {
      linkedQueryIds.push(query.Id);
    }
  });
  const selectedQueryExtraData = DynamicQueryList.find((query) => query.Id === SelectedQuery);
  const savePayloadReportConfig: IReportConfig = cloneDeep(selectedQueryExtraData.QueryConfig?.ReportConfig || newState.updatedReportBuilderInfo.reportBuilderSavePayload);
  const defaultBuilderMeasures: IBuilderMeasure[] = [];
  const addedFilter = SelectedQueryData.updatedInfo.filterBuilder.filterConfig.filter(
    (config: IFilterConfig) => config.IsRemoved !== true,
  );
  const appliedDimensions = SelectedQueryData.updatedInfo.AppliedDimensions;
  const appliedMeasures = SelectedQueryData.updatedInfo.AppliedMeasures;
  const newAppliedFilters = SelectedQueryData.updatedInfo?.filterBuilder?.appliedFilters;
  savePayloadReportConfig.Builder = [prepareBuilderSavePayloadForQuery(SelectedQuery, SelectedQueryData, DataSourceMapping, selectedQueryExtraData?.QueryConfig, undefined, partitionColumnFilterDateLimit)];
  savePayloadReportConfig.SubBuilders = getSubBuilders(SelectedQuery, SelectedQuery, DynamicQueryList, []);
  const dimensions = getSavePayloadDimensionColumns(
    appliedDimensions,
    SelectedQueryData.updatedInfo?.filterBuilder?.filterConfig,
    SelectedQuery,
  );
  const measures = getSavePayloadMeasureColumns(
    appliedMeasures,
    getDefaultMeasures(defaultBuilderMeasures, selectedQueryExtraData.QueryConfig?.ReportConfig.Columns || []),
    selectedQueryExtraData.QueryConfig?.ReportConfig,
    SelectedQuery,
  );
  savePayloadReportConfig.Columns = [...dimensions, ...measures];
  savePayloadReportConfig.FiltersMetadata = getFilterMetaDataInfo(
    addedFilter,
    newAppliedFilters,
    DynamicQueryList,
    isValidArrayAndNotEmpty(DynamicQueryList),
    newState.updatedReportBuilderInfo?.reportBuilderSavePayload?.FiltersMetadata,
  );
  savePayloadReportConfig.Sorting = SelectedQueryData.updatedInfo?.sortState;
  savePayloadReportConfig.DimensionsMetaFields = getSavePayloadDimensionMetafields(state, savePayloadReportConfig.DimensionsMetaFields, newState.updatedReportBuilderInfo.appliedDimensions, true, {}, {}, SelectedQuery);
  savePayloadReportConfig.Paging = SelectedQueryData.updatedInfo?.Paging?.PageSize === -1 ? null : SelectedQueryData.updatedInfo?.Paging;
  savePayloadReportConfig.FeatureContext = savePayloadReportConfig?.FeatureContext ?? FeatureContext.Sales;
  return savePayloadReportConfig;
};

export const getQueryConfigFromRawConfig = (state: IReportBuilderState, selectedQueryId?:string): IReportConfig => {
  const { SelectedQuery, DynamicQueryList } = state.reportQueryBuilder;
  const queryId = selectedQueryId || SelectedQuery;
  const queryConfig = state.reportEditInfo.rawReportConfig;
  const queryBuilder = queryConfig.SubBuilders?.filter((subBuilder) => subBuilder.QueryId === queryId);
  const linkedQueries = DynamicQueryList?.find((query) => query.Id === queryId)?.LinkedQueryIds || [];
  const subBuilders = queryConfig.SubBuilders?.filter((subBuilder) => linkedQueries.includes(subBuilder.QueryId));
  return {
    ...queryConfig,
    Builder: [
      ...queryBuilder,
    ],
    SubBuilders: [
      ...subBuilders,
    ],
  };
};

export const getRootQuerySaveReportConfigPayload = (state?: IReportBuilderState): IReportConfig => {
  const newState = state;
  const partitionColumnFilterDateLimit = store?.getState()?.settings?.data?.Configuration[ModuleName.ReportBuilder].Settings?.Filter?.StringFieldPartitionFilterLimit;
  const template = newState.updatedReportBuilderInfo.selectedTemplate;
  const queryList = newState.reportQueryBuilder.DynamicQueryList;

  const dataSourceMapping = state.reportQueryBuilder.DataSourceMapping;
  const linkedQueryIds: String[] = [];
  queryList.forEach((query) => {
    if (query.ParentQueryId === ROOT_QUERY_KEY) {
      linkedQueryIds.push(query.Id);
    }
  });
  const savePayloadReportConfig: IReportConfig = cloneDeep(newState.updatedReportBuilderInfo.reportBuilderSavePayload);
  let defaultBuilderMeasures: IBuilderMeasure[] = [];
  const addedFilter = newState.filterBuilder.filterConfig.filter(
    (config: IFilterConfig) => config.IsRemoved !== true,
  );

  const primaryUserFilter = addedFilter.find((filItem: IFilterConfig) => filItem.Type === FilterType.UserMultiSelect && filItem.IsPrimaryUserFilter);
  const appliedDimensions = newState.updatedReportBuilderInfo.appliedDimensions;
  const appliedUserDimension = appliedDimensions.find((dim: IDimension) => primaryUserFilter?.LinkedDimensionId === dim.Id);
  let newAppliedFilters = newState?.filterBuilder?.appliedFilters;
  if (isStringFieldApplied(appliedDimensions)) {
    newAppliedFilters = getUpdatedAppliedFiltersForPartitionColumn(
      newState.filterBuilder.filterConfig,
      newAppliedFilters,
      partitionColumnFilterDateLimit,
    );
  }
  savePayloadReportConfig.Builder = savePayloadReportConfig.Builder.map(
    (item, builderIdx) => {
      defaultBuilderMeasures = [...defaultBuilderMeasures, ...item.Select.Measures || []];
      if (savePayloadReportConfig?.CalculatedColumns) {
        defaultBuilderMeasures = defaultBuilderMeasures.concat(savePayloadReportConfig.CalculatedColumns).flat();
      }
      return ({
        ...item,
        CustomHierarchies: newState?.updatedReportBuilderInfo?.customHierarchies,
        Namespace: dataSourceMapping[ROOT_QUERY_KEY]?.PrimaryNamespace,
        Source: dataSourceMapping[dataSourceMapping[ROOT_QUERY_KEY]?.PrimaryNamespace]?.PrimaryNamespace ? QuerySourceType.Query : QuerySourceType.Table,
        Select: {
          ...item.Select,
          Dimensions: getSavePayloadBuilderDimensions(
            newState.updatedReportBuilderInfo.appliedDimensions,
            [
              ...newState.updatedReportBuilderInfo.selectedTemplate.ReportConfig
                .Builder[0].Select.Dimensions,
            ],
            newState?.filterBuilder?.filterConfig,
          ),
          Measures: [...getSavePayloadBuilderMeasures(
            newState.updatedReportBuilderInfo.appliedMeasures,
            template.ReportConfig.Builder[builderIdx].Select.Measures, // TODO: Find by namespace, not by index.
          ),

          ],
        },
        Filter: getSavePayloadBuilderFilters(
          addedFilter,
          newAppliedFilters,
          template.ReportConfig.Builder[builderIdx].Filter,
        ),
        Hierarchy: getReportHierarchy(appliedUserDimension, item?.Hierarchy),
      });
    },
  );
  savePayloadReportConfig.SubBuilders = getSubBuilders(ROOT_QUERY_KEY, ROOT_QUERY_KEY, queryList, []);
  const dimensions = getSavePayloadDimensionColumns(
    newState.updatedReportBuilderInfo.appliedDimensions,
    newState?.filterBuilder?.filterConfig,
  );
  const measures = getSavePayloadMeasureColumns(
    newState.updatedReportBuilderInfo.appliedMeasures,
    getDefaultMeasures(defaultBuilderMeasures, template.ReportConfig.Columns),
    template.ReportConfig,
  );
  savePayloadReportConfig.Columns = [...dimensions, ...measures];

  // populate the custom columns in the save payload
  // The second part of the condition is to ensure that the custom columns are populated for the appropriate and applicable namespace
  if (isValidObjectAndNotEmpty(newState.updatedReportBuilderInfo.expressionStore) && dataSourceMapping[ROOT_QUERY_KEY]?.PrimaryNamespace === newState.updatedReportBuilderInfo.reportBuilderSavePayload.Builder[0].Namespace) {
    const setOfCustomColumnsInExpressionStore = new Set(Object.keys(newState.updatedReportBuilderInfo.expressionStore).filter((key) => newState.updatedReportBuilderInfo.expressionStore[key]?.ExpressionType === ExpressionContext.Custom));
    const existingCustomColumns = savePayloadReportConfig.Builder[0]?.CustomColumns ?? [];

    const filteredCustomColumns = existingCustomColumns.filter((col) => setOfCustomColumnsInExpressionStore.has(col.Id));

    Object.values((newState.updatedReportBuilderInfo?.expressionStore ?? [])).filter((customExp: ICustomExpression) => customExp?.ExpressionType === ExpressionContext.Custom).forEach((customExp: ICustomExpression) => {
      try {
        const {
          Name, Id, BuilderConfig, Props,
        } = buildCustomDimension(customExp.displayName, customExp.Mode, customExp.jsonExpression, customExp.uniqueId, customExp.DataType, customExp?.dimensionType, customExp?.description, customExp?.Formatter);
        const updatedCustomColumn = {
          Name, Id, BuilderConfig, Props,
        } as IReportBuilderCustomColumns;

        updatedCustomColumn.Props = { ...updatedCustomColumn.Props, Description: customExp.description, Dimension: { ...updatedCustomColumn.Props.Dimension, Applied: customExp.Mode === ColumnModes.NotApplied ? DimensionStatus.NotApplied : DimensionStatus.Applied } };

        /** check if the custom column is already present in the save payload
       * If present, then update the mode of the custom column, else add it to the save payload
       */

        const customColumnIndex = filteredCustomColumns.findIndex((col) => col.Id === updatedCustomColumn.Id);
        if (customColumnIndex !== -1) {
          filteredCustomColumns[customColumnIndex] = updatedCustomColumn;
        } else {
          filteredCustomColumns.push(updatedCustomColumn);
        }
        savePayloadReportConfig.Builder[0].CustomColumns = filteredCustomColumns;
      } catch (error) {
        console.error('Error building custom column dimension', error);
      }
    });
  } else {
    savePayloadReportConfig.Builder[0].CustomColumns = [];
  }

  savePayloadReportConfig.Sorting = newState?.updatedReportBuilderInfo?.sortState;
  savePayloadReportConfig.DimensionsMetaFields = getSavePayloadDimensionMetafields(state, savePayloadReportConfig.DimensionsMetaFields, newState.updatedReportBuilderInfo.appliedDimensions, true);

  savePayloadReportConfig.FiltersMetadata = getFilterMetaDataInfo(
    addedFilter,
    newAppliedFilters,
    queryList,
    isValidArrayAndNotEmpty(queryList),
    newState.updatedReportBuilderInfo?.reportBuilderSavePayload?.FiltersMetadata,
  );
  savePayloadReportConfig.FeatureContext = savePayloadReportConfig?.FeatureContext ?? FeatureContext.Sales;
  // Funnel charts: reconcile the saved dimension / measure against the current applied columns (see
  // the primary save/preview path above) so a removed or hidden column is never persisted.
  if (savePayloadReportConfig?.Visualization?.Type === VisualizationTypes.FunnelChart
    && savePayloadReportConfig?.Visualization?.Builder?.Properties) {
    savePayloadReportConfig.Visualization.Builder.Properties = reconcileFunnelAttributes(
      savePayloadReportConfig.Visualization.Builder.Properties,
      newState.updatedReportBuilderInfo.appliedDimensions,
      newState.updatedReportBuilderInfo.appliedMeasures,
      newState.updatedReportBuilderInfo.expressionStore,
      newState.filterBuilder.customFilterDefinitions,
    );
  }
  savePayloadReportConfig.Visualization = getUpdateVisualization(
    savePayloadReportConfig?.Visualization?.DisplayName,
    savePayloadReportConfig?.Visualization?.Type,
    savePayloadReportConfig?.Visualization?.Builder?.Properties,
    savePayloadReportConfig?.Visualization?.DrilldownConfigMapping,
    savePayloadReportConfig?.Visualization?.DrilldownConfigIdMapping,
    savePayloadReportConfig?.Visualization?.DrilldownPagination,
    savePayloadReportConfig?.Builder[0]?.Type,
    undefined,
    newState.updatedReportBuilderInfo.linkedReportsConfig,
    savePayloadReportConfig?.Visualization?.Builder as ReportResponseModel.IChartVisualizationBuilder,
  );

  return savePayloadReportConfig;
};

export const getBuilderObj = (
  reportBuilder: IReportBuilderState,
  builderObj: IBuilder,
  updatedReportConfig: IReportConfig,
  useIdsKey: boolean,
  pageContext?: PageContext,
  updateType?:UpdateType,
): IReportMetaInfo | IReportMetaInfoV2 => {
  const { dataSourceInfo: { dataSources }, reportQueryBuilder: { DynamicQueryList, SelectedQueryData, SelectedQuery } } = reportBuilder;
  const {
    Namespace, Joins, Source, Select, Filter, CustomColumns,
  } = builderObj;
  const isSubBuilderAvail = Joins?.some((join) => join.IsCTE) || builderObj.Source === QuerySourceType.Query;

  const updatedNamespaceList = getDataSourceTitle(Namespace, Joins, dataSources, true) as string[];
  updatedReportConfig.Builder[0] = builderObj;
  let queryBuilderConfig: QueryBuilderConfig | null = null;
  // if (pageContext) {
  const dimMetaData = [] as IDimensionsMetaFields[];
  const queryIds = updatedReportConfig?.SubBuilders?.map((builder) => builder?.QueryId);
  const queryList = DynamicQueryList.filter((queryItem) => queryIds?.includes(queryItem?.Id));

  if (isValidArrayAndNotEmpty(queryList)) {
    queryList.forEach((query) => {
      const queryAppliedDimensions = query?.QueryDataInfo?.updatedInfo?.AppliedDimensions;
      if (isValidArrayAndNotEmpty(queryAppliedDimensions)) {
        const appliedQueryUserFields = queryAppliedDimensions.filter(
          (dim: IDimension) => dim.Applied === DimensionStatus.Applied
          && !dim.Props?.IsUserDynamicField
            && dim.BuilderConfig?.Alias !== 'LeadType' && dim.BuilderConfig?.Alias !== 'LeadLeadType'
          && !dim.Props?.IsSourceCustomColumn,
        );
        appliedQueryUserFields?.forEach((appliedQueryUserField) => {
          const exists = dimMetaData.some(
            (field) => field.QueryId === query?.Id
        && field.Id === appliedQueryUserField?.Id,
          );

          if (!exists) {
            const appliedQueryDimensionMetaField: IDimensionsMetaFields = {
              Id: appliedQueryUserField?.Id,
              Dimension: appliedQueryUserField?.Name,
              QueryId: query?.Id,
              Type: 'User',
              Fields: [
                {
                  SchemaName: UserNameConstant,
                  Alias: appliedQueryUserField?.ReferTo,
                  Id: appliedQueryUserField?.ReferTo,
                },
              ],
            };

            dimMetaData.push(appliedQueryDimensionMetaField);
          }
        });
      }
    });
  }

  const addedFilter = SelectedQueryData?.updatedInfo?.filterBuilder?.filterConfig?.filter(
    (config: IFilterConfig) => config.IsRemoved !== true,
  );

  const newAppliedFilters = SelectedQueryData?.updatedInfo?.filterBuilder?.appliedFilters;
  const filterMetaInfoData = getFilterMetaDataInfo(
    addedFilter,
    newAppliedFilters,
    queryList.filter((queryItem) => queryItem.Id !== SelectedQuery),
    true,
  );
  const selectedQueryInfo = DynamicQueryList?.find((query) => query.Id === SelectedQuery);
  const selectedQueryPayload = selectedQueryInfo?.QueryPayload;
  const sort = selectedQueryPayload?.Sorting;
  const paging = selectedQueryPayload?.Paging;

  const isUnionType = isUnionJoinType(Joins);
  queryBuilderConfig = {
    Builder: [{
      Namespace, Hierarchy: selectedQueryPayload?.Hierarchy, Joins, Source, Select, Filter, Sorting: sort, Paging: paging, Type: updatedReportConfig.Builder[0]?.Type, UnionConfig: isUnionType ? getUnionConfigFromJoins(Joins, Namespace) : null,
    }],
    SubBuilders: updatedReportConfig.SubBuilders,
    DimensionsMetaFields: dimMetaData,
    FiltersMetadata: filterMetaInfoData,
  };
  // }

  // // adding the key called ExistingCustomColumns to the queryBuilderConfig
  const existingCustomColumns: IReportBuilderCustomColumns[] = [];

  // when the report is in edit mode, then there might be some custom columns that are present as part of the SubBuilders.
  // so we need to include them as well in the save payload

  // // /** generating the existing custom columns from the selected query data expression store */
  if (isValidObjectAndNotEmpty(reportBuilder.reportQueryBuilder.SelectedQueryData?.updatedInfo?.ExpressionStore)) {
    Object.values(reportBuilder.reportQueryBuilder.SelectedQueryData?.updatedInfo?.ExpressionStore)?.filter((customExp: ICustomExpression) => customExp.ExpressionType === ExpressionContext.Custom).forEach((customExp: ICustomExpression) => {
      const {
        Name, Id, BuilderConfig, Props,
      } = buildCustomDimension(customExp.displayName, customExp.Mode, customExp.jsonExpression, customExp.uniqueId, customExp.DataType, customExp?.dimensionType, customExp?.description);
      const updatedCustomColumn = {
        Name, Id, BuilderConfig, Props,
      } as IReportBuilderCustomColumns;

      updatedCustomColumn.Props = { ...updatedCustomColumn.Props, Dimension: { ...updatedCustomColumn.Props.Dimension, Applied: customExp.Mode === ColumnModes.NotApplied ? DimensionStatus.NotApplied : DimensionStatus.Applied } };

      existingCustomColumns.push(updatedCustomColumn);
    });
  }
  if (isValidObjectAndNotEmpty(queryBuilderConfig)) {
    queryBuilderConfig = { ...queryBuilderConfig, Builder: [{ ...queryBuilderConfig?.Builder?.[0], CustomColumns: UpdateType.CustomColumns === updateType ? existingCustomColumns : CustomColumns as IReportBuilderCustomColumns[] || [] }] };
  }

  return {
    ...(useIdsKey ? { Ids: updatedNamespaceList } : { Namespaces: updatedNamespaceList }),
    RequestType: isSubBuilderAvail ? RequestType.Query : RequestType.Namespace,
    FeatureContext: updatedReportConfig.FeatureContext ?? FeatureContext.Sales,
    QueryBuilderConfig: queryBuilderConfig,
    Joins,
    UnionConfig: isUnionType ? getUnionConfigFromJoins(Joins, Namespace) : null,
    Type: !isSubBuilderAvail ? updatedReportConfig.Builder[0]?.Type : undefined,
  } as IReportMetaInfo;
};

export const resetSelectedQueryToParent = (
  state: IReportBuilderState,
  parentQueryId: string,
  QueryConfig: IRawTemplate,
  selectedQueryData: ISelectedQueryInfo,
  variables: IVariables,
) => {
  const { reportQueryBuilder } = state;
  const { DataSourceMapping } = reportQueryBuilder;
  prepareUICompatibleConfig(state, QueryConfig, selectedQueryData, variables, DataSourceMapping[parentQueryId].PrimaryNamespace);
  reportQueryBuilder.SelectedQueryData = selectedQueryData;
  reportQueryBuilder.SelectedQuery = parentQueryId;
};

export const resetDataSourceOfLinkedQueries = (state: IReportBuilderState, currentQuery: string) => {
  if (!currentQuery) return;
  const queryExtraData = state.reportQueryBuilder.DynamicQueryList.find((query) => query.Id === currentQuery);
  const { Joins, PrimaryNamespace } = getInitialDataSource(state, queryExtraData, currentQuery);
  state.reportQueryBuilder.DataSourceMapping[currentQuery] = {
    ...state.reportQueryBuilder.DataSourceMapping[currentQuery],
    Joins,
    PrimaryNamespace,
    isDataSourceSaved: false,
  };
  queryExtraData?.LinkedQueryIds?.forEach((linkedQueryId) => {
    resetDataSourceOfLinkedQueries(state, linkedQueryId);
  });
};

const getInitialDataSource = (state: IReportBuilderState, queryData: IQueryInfo, currentQuery: string): IDataSourceItems => {
  // works for first level of queries since DataSourceMappingPayload has the updated values from DataSourceMapping
  if (state.reportQueryBuilder.DataSourceMappingPayload[currentQuery]) {
    return cloneDeep(state.reportQueryBuilder.DataSourceMappingPayload[currentQuery]);
  }
  // if not first level query, then fetch from QueryData in QueryList
  return {
    Joins: queryData.QueryPayload?.Joins,
    PrimaryNamespace: queryData.QueryPayload?.Namespace,
    JoinBlockIndexBeingEdited: 0,
    isEditMode: false,
    isDataSourceSaved: false,
  };
};

export const populateSubQueryDetailsFromConfig = (
  state: IReportBuilderState,
  reportConfig: IReportConfig,
) => {
  const { reportQueryBuilder } = state;
  const { Builder: builder, SubBuilders: subBuilders } = reportConfig;
  const dynamicQueryList: IQueryInfo[] = [];
  const linkedQueriesIdMap = getLinkedQueriesId(subBuilders);
  const source = builder[0]?.Source;
  let primaryQueryId = '';
  if (source === QuerySourceType.Query) {
    // when query is the only data source
    if (!isValidArrayAndNotEmpty(builder[0]?.Joins)) {
      primaryQueryId = subBuilders[0]?.QueryId;
    } else {
      const { primaryDataSource } = getDataSourcesFromJoinObj(builder[0]?.Joins[0]);
      primaryQueryId = primaryDataSource || '';
    }
  }
  subBuilders.forEach((subBuilder) => {
    let parentQuery = isValidObjectAndNotEmpty(linkedQueriesIdMap) ? linkedQueriesIdMap[subBuilder.QueryId]?.parentQuery : null;
    if (!parentQuery) {
      parentQuery = builder[0];
    }
    const joinIndex = getJoinBlockIndex(parentQuery, subBuilder.QueryId);
    let joinBlockFieldSelection = primaryQueryId === subBuilder.QueryId ? DataSourceSelectionType.lhsTable : DataSourceSelectionType.rhsTable;
    if (joinIndex !== -1 && isValidArrayAndNotEmpty(parentQuery?.Joins)) {
      const joinItem = parentQuery.Joins[joinIndex];
      if (joinItem.Primary === subBuilder.QueryId) joinBlockFieldSelection = DataSourceSelectionType.lhsTable;
      else if (joinItem.With === subBuilder.QueryId) joinBlockFieldSelection = DataSourceSelectionType.rhsTable;
      else {
        const { primaryDataSource } = getDataSourcesFromJoinObj(joinItem);
        if (subBuilder.QueryId === primaryDataSource) joinBlockFieldSelection = DataSourceSelectionType.lhsTable;
      }
    }

    dynamicQueryList.push({
      Id: subBuilder.QueryId,
      Name: subBuilder.DisplayName,
      LinkedQueryIds: linkedQueriesIdMap[subBuilder.QueryId]?.linkedQueries,
      ParentQueryId: parentQuery?.QueryId || ROOT_QUERY_KEY,
      Type: subBuilder.Type,
      QueryPayload: subBuilder,
      QueryJoinRelation: {
        ParentQueryId: parentQuery?.QueryId || ROOT_QUERY_KEY,
        JoinBlockindex: joinIndex,
        JoinBlockFieldSelection: joinBlockFieldSelection,
      },
      IsDraft: false,
      QueryConfig: null,
      QueryDataInfo: null,
    });
    reportQueryBuilder.DataSourceMapping = {
      ...reportQueryBuilder.DataSourceMapping,
      [subBuilder.QueryId]: {
        Joins: subBuilder.Joins,
        PrimaryNamespace: subBuilder.Namespace,
        JoinBlockIndexBeingEdited: 0,
        isEditMode: false,
        isDataSourceSaved: false,
      },
    };
  });
  reportQueryBuilder.DynamicQueryList = dynamicQueryList;
  reportQueryBuilder.StaticQueryList = dynamicQueryList;
  reportQueryBuilder.SelectedQueryData = initialReportBuilderState.reportQueryBuilder.SelectedQueryData;
  reportQueryBuilder.DataSourceMappingPayload = cloneDeep(reportQueryBuilder.DataSourceMapping);
};

export const getJoinBlockIndex = (parentQueryBuilder: IBuilder, queryId: string): number => {
  const joins = parentQueryBuilder?.Joins;
  if (!joins || joins.length === 0) return 0;
  return joins.findIndex((joinItem) => {
    if (joinItem.Primary === queryId || joinItem.With === queryId) return true;
    const { primaryDataSource, withDataSource } = getDataSourcesFromJoinObj(joinItem);
    return queryId === primaryDataSource || queryId === withDataSource;
  });
};

export const getDataSourcesFromJoinObj = (joinItem: JoinItem) => {
  const expression: IExpression | undefined = joinItem?.On;
  let primaryDataSource: string | undefined;
  if (expression) {
    const { conditions } = extractJoinConditions(expression);
    if (isValidArrayAndNotEmpty(conditions)) {
      const firstCondition = conditions[0];
      const part = firstCondition?.Part as any;
      if (part?.LHS?.Part?.TableNameOverride) {
        primaryDataSource = part.LHS.Part.TableNameOverride.replace(JoinPrefix, '');
      }
    }
  }
  const withDataSource = joinItem.With;
  return { primaryDataSource, withDataSource };
};

/**
 * Walks DataSourceMapping starting at ROOT_QUERY to derive the report's
 * currently-valid data-source identifiers. The map can carry orphan entries
 * after a data-source change (e.g. a previous query whose key is no longer
 * referenced from ROOT_QUERY); those are unreachable here and dropped
 * automatically.
 *
 * Outputs:
 *   validQueryIds    — every QueryId reachable from ROOT_QUERY at any depth.
 *   validNamespaces  — every leaf-node table namespace reached during the walk
 *                      (anywhere — root primary, root-joined, or nested inside
 *                      a reached query). A "leaf" is any endpoint that isn't
 *                      itself a key in DataSourceMapping.
 *
 * Used by CustomFilterEditor's linkable-pool predicate to drop sub-builder
 * filters whose query is no longer part of the report — see issue
 * `stale-sub-builder-linkable-filters-after-data-source-change`.
 */
export const computeValidDataSourceIdentifiers = (
  dataSourceMapping: IDataSourceMapping | undefined,
): { validQueryIds: Set<string>; validNamespaces: Set<string> } => {
  const validQueryIds = new Set<string>();
  const validNamespaces = new Set<string>();
  if (!dataSourceMapping) return { validQueryIds, validNamespaces };

  const visited = new Set<string>();
  const stripPrefix = (id?: string) => (id ? id.replace(JoinPrefix, '') : id);

  // Classify every reached endpoint uniformly: keys in the map are queries
  // (recurse); everything else is a leaf table namespace and gets collected.
  const classify = (idRaw?: string) => {
    const id = stripPrefix(idRaw);
    if (!id) return;
    if (dataSourceMapping[id]) {
      validQueryIds.add(id);
      walk(id);
    } else {
      validNamespaces.add(id);
    }
  };

  function walk(key: string): void {
    if (visited.has(key)) return;
    visited.add(key);
    const entry = dataSourceMapping[key];
    if (!entry) return;
    classify(entry.PrimaryNamespace);
    (entry.Joins || []).forEach((join) => {
      classify(join.Primary);
      classify(join.With);
    });
  }

  walk(ROOT_QUERY_KEY);
  return { validQueryIds, validNamespaces };
};

export const getLinkedQueriesId = (subBuilders: Array<IBuilder>): ObjModel.Obj => {
  const queryToLinkedQueriesMap: ObjModel.Obj = {};
  const childToParentMap: Record<string, IBuilder> = {};
  const allQueries = subBuilders?.map((subBuilder) => subBuilder.QueryId);
  subBuilders.forEach((subBuilder) => {
    const linkedQueryIds: string[] = [];
    if (isValidArrayAndNotEmpty(subBuilder.Joins)) {
      subBuilder.Joins.forEach((joinItem) => {
        const expression: IExpression | undefined = joinItem?.On;

        let primaryDataSource: string;
        const { conditions } = extractJoinConditions(normalizeJoinConditions(expression));
        if (isValidArrayAndNotEmpty(conditions)) {
          const firstCondition = conditions[0];
          const part: any = firstCondition?.Part;
          primaryDataSource = part?.LHS?.Part?.TableNameOverride?.replace(JoinPrefix, '');
        }

        const withDataSource = joinItem.With;

        if (subBuilder.Source === QuerySourceType.Query && primaryDataSource) {
          linkedQueryIds.push(primaryDataSource);
          const parentBuilder = subBuilders.find((b) => b.QueryId === subBuilder.QueryId);
          if (parentBuilder) {
            childToParentMap[primaryDataSource] = parentBuilder;
          }
        }

        if (joinItem.IsCTE && withDataSource) {
          linkedQueryIds.push(withDataSource);
          const parentBuilder = subBuilders.find((b) => b.QueryId === subBuilder.QueryId);
          if (parentBuilder) {
            childToParentMap[withDataSource] = parentBuilder;
          }
        }
      });
      queryToLinkedQueriesMap[subBuilder.QueryId] = {
        linkedQueries: linkedQueryIds.filter(Boolean),
      };
    } else if (!isValidArrayAndNotEmpty(subBuilder.Joins)) {
      if (allQueries?.includes(subBuilder.Namespace)) {
        const parent = subBuilders.find((builder) => builder?.QueryId === subBuilder.Namespace);
        if (parent) {
          childToParentMap[parent.QueryId] = subBuilder;
        }
        queryToLinkedQueriesMap[subBuilder.QueryId] = {
          linkedQueries: [subBuilder.Namespace],

        };
      }
    }
  });

  subBuilders?.forEach((subBuilder) => {
    queryToLinkedQueriesMap[subBuilder.QueryId] = {
      ...queryToLinkedQueriesMap[subBuilder.QueryId],
      parentQuery: childToParentMap[subBuilder.QueryId],
    };
  });

  return queryToLinkedQueriesMap;
};

export const findAndUpdateAssociatedUserFilters = (
  newFilterConfig: IFilterConfig[],
  filterId: string,
  selectedQueryId: string,
  showInReport: boolean,
): void => {
  const updateRender = (index: number) => {
    if (index === -1) return;
    const filter = newFilterConfig[index];
    newFilterConfig[index].Render = {
      ...filter?.Render,
      ShowInMainReport: showInReport,
      LinkedQueryId: selectedQueryId,
    };
  };

  const findIndexById = (id?: string): number => newFilterConfig.findIndex((config) => config.ID === id);

  const findIndexByLinkedTo = (linkedToId: string): number => newFilterConfig.findIndex((config) => config.LinkedTo === linkedToId);

  const currentIndex = findIndexById(filterId);
  const currentFilter = newFilterConfig[currentIndex];
  if (!currentFilter) return;

  switch (currentFilter.Type) {
    case FilterType.UserMultiSelect: {
      const linkedTo = currentFilter.LinkedTo;
      const groupFilterIndex = findIndexById(linkedTo);

      if (
        groupFilterIndex !== -1
        && linkedTo?.startsWith(GroupFilterId)
      ) {
        updateRender(groupFilterIndex);

        const preAppliedLinkedTo = newFilterConfig[groupFilterIndex]?.LinkedTo;
        const userFilterIndex = findIndexById(preAppliedLinkedTo);
        updateRender(userFilterIndex);
      }

      break;
    }

    case FilterType.GroupMultiSelect: {
      if (filterId.startsWith(GroupFilterId)) {
        const userFilterIndex = findIndexByLinkedTo(filterId);
        const preAppliedLinkedTo = currentFilter.LinkedTo;
        const preAppliedUserFilterIndex = findIndexById(preAppliedLinkedTo);

        updateRender(userFilterIndex);
        updateRender(preAppliedUserFilterIndex);
      }
      break;
    }

    default:
      break;
  }
};

// Return the updated State on fetching meta selector options.
// @state: Report Builder State
// @payload: Updated dimension info
export const getStateOnSetEntityGroupingOptions = (
  state: IReportBuilderState,
  payload: ISetMetaSelectorOptionsPayload,
): IReportBuilderState => {
  const entityGroupOptionsMap = state.updatedReportBuilderInfo.entityGroupOptionsMap;
  state.updatedReportBuilderInfo.entityGroupOptionsMap = getUpdatedMetaSelectorOptions(payload, entityGroupOptionsMap);
  return state;
};

/**
 * Applies entity grouping to dimensions in the report builder state
 * Handles both drilldown and regular dimension grouping scenarios
 * @param state - Current state of the report builder
 * @param payload - Payload containing entity grouping configuration
 * @returns Updated report builder state with applied entity grouping
 */
export const getStateOnApplyEntityGrouping = (
  state: IReportBuilderState,
  payload: ISetDimensionsEntityGroupingPayload,
): IReportBuilderState => {
  const newState = state;
  const {
    activeId, index, mode, data, res,
  } = payload;
  const {
    entityGroupStore, appliedDimensions, drilldownConfigInfo, reportBuilderSavePayload,
  } = newState.updatedReportBuilderInfo;
  const isDrilldown = isDrilldownTabActive(activeId);

  if (isDrilldown) {
    const configInfo = drilldownConfigInfo;
    const drilldownConfig = configInfo.drilldownColumnConfig[activeId];
    if (!drilldownConfig) return newState;
    let column = cloneDeep(data) as IColumn;
    const defaultColumns = [...drilldownConfig.defaultColumns];
    if (isValidMetaSelectorOptions(res)) {
      const selectedColumn = res[0].Config.at(-1);
      column = createEntityGroupedDrilldown(column, selectedColumn, DimensionStatus.Applied);
    } else {
      // Fallback processing
      column = createFallbackDrilldownColumn(column, defaultColumns);
      drilldownConfig.additionalDrilldownColumns = updateAdditionalColumns(drilldownConfig.additionalDrilldownColumns, column.Id);
    }
    defaultColumns.push(column);
    updateEntityGroupStore(entityGroupStore, column);
    drilldownConfig.defaultColumns = defaultColumns;
    drilldownConfig.sortState = rebuildSortState(
      drilldownConfig.sortState,
      appliedDimensions,
      newState.updatedReportBuilderInfo.appliedMeasures,
      defaultColumns,
      false,
      true,
    );
    return newState;
  }

  // Handle dimension case
  let dimension = cloneDeep(data) as IDimension;
  let newDimensions = cloneDeep(appliedDimensions);

  if (isValidMetaSelectorOptions(res)) {
    const selectedOption = mode === 0 ? res[0] : res.at(-1);
    const isMetaColumnPresent = selectedOption.Config.length > 1;
    dimension = createEntityGroupedDimension(dimension, selectedOption.Config.at(-1), DimensionStatus.Applied, isMetaColumnPresent, mode);
    newDimensions = addDimensionToGrouping(appliedDimensions, dimension, selectedOption, index, isMetaColumnPresent, false);
  } else {
    // Fallback processing
    dimension.Applied = DimensionStatus.Applied;
    dimension.DimensionMode = mode;
    newDimensions = newDimensions.filter((d) => d.Id !== dimension.Id);
    newDimensions.splice(index, 0, dimension);
  }
  updateEntityGroupStore(entityGroupStore, dimension);
  newState.updatedReportBuilderInfo.appliedDimensions = reOrderDimensions(newDimensions);
  const isReportListType = isListReport(reportBuilderSavePayload?.Builder[0]?.Type);
  newState.updatedReportBuilderInfo.sortState = rebuildSortState(
    newState.updatedReportBuilderInfo.sortState,
    newDimensions,
    newState.updatedReportBuilderInfo.appliedMeasures,
    [],
    false,
    false,
    isReportListType,
  );

  return newState;
};

const createFallbackDrilldownColumn = (
  column: IColumn,
  existingColumns: IColumn[],
): IColumn => {
  const nameSource = column.BuilderConfig.IsDynamicField
    ? column.BuilderConfig.DisplayName
    : column.Name;

  const updatedName = getUpdatedDrilldownColsName(nameSource, existingColumns);

  return {
    ...column,
    Name: updatedName,
    Props: {
      ...column.Props,
      Dimension: {
        ...column.Props.Dimension,
        Applied: DimensionStatus.Applied,
      },
    },
    BuilderConfig: {
      ...column.BuilderConfig,
      DisplayName: column.BuilderConfig.IsDynamicField ? updatedName : column.BuilderConfig.DisplayName,
      IsDynamicField: false,
    },
  };
};

const updateAdditionalColumns = (columns: IColumn[] = [], targetId: string): IColumn[] => columns.map((item) => (item.Id === targetId ? {
  ...item,
  Props: {
    ...item.Props,
    Dimension: {
      ...item.Props.Dimension,
      Applied: DimensionStatus.Applied,
    },
  },
} : item));

/**
 * Updates the report builder state when entity grouping configuration changes
 * Handles both drilldown and regular dimension grouping scenarios
 * @param state - Current state of the report builder
 * @param payload - Payload containing updated entity grouping configuration
 * @returns Updated report builder state with modified entity grouping
 */
export const getStateOnEntityGroupingChange = (
  state: IReportBuilderState,
  payload: ISetEntityGroupingPayload,
): IReportBuilderState => {
  const newState = state;
  const { index, opt, activeId } = payload;
  const { appliedMeasures, entityGroupStore } = newState.updatedReportBuilderInfo;
  const isDrilldown = isDrilldownTabActive(activeId);
  let newAppliedDimensions = isDrilldown
    ? newState.updatedReportBuilderInfo.drilldownConfigInfo.drilldownColumnConfig[activeId].defaultColumns
    : newState.updatedReportBuilderInfo.appliedDimensions;
  if (opt && isValidObjectAndNotEmpty(opt.Config)) {
    newAppliedDimensions = isDrilldown
      ? updateEntityGroupedDrilldown(index, newAppliedDimensions as IColumn[], opt)
      : updateEntityGroupedDimension(index, newAppliedDimensions as IDimension[], opt, false);
    updateEntityGroupStore(entityGroupStore, newAppliedDimensions[index]);
  }
  newState.updatedReportBuilderInfo.entityGroupStore = entityGroupStore;
  if (isDrilldown) {
    newState.updatedReportBuilderInfo.drilldownConfigInfo.drilldownColumnConfig[activeId].defaultColumns = newAppliedDimensions as IColumn[];
  } else {
    newState.updatedReportBuilderInfo.appliedDimensions = newAppliedDimensions as IDimension[];
    newState.updatedReportBuilderInfo.sortState = rebuildSortState(
      newState.updatedReportBuilderInfo.sortState,
      newAppliedDimensions as IDimension[],
      appliedMeasures,
      [],
      false,
      false,
      isListReport(newState.updatedReportBuilderInfo.reportBuilderSavePayload?.Builder[0]?.Type),
    );
  }
  return newState;
};

export const getStateOnUpdateCustomHierarchies = (
  state: IReportBuilderState,
  payload: ICustomHierarchy[],
): IReportBuilderState => {
  state.updatedReportBuilderInfo.customHierarchies = payload;
  return state;
};
export const getUnionConfigFromJoins = (joinsArray: JoinItem[], primaryNamespace: string) => {
  if (!isValidArrayAndNotEmpty(joinsArray)) {
    return null;
  }
  const unionConfigArray = joinsArray.map((join) => ({
    Mode: join.Type === JoinType.UNION || join.Type === JoinType.UNIONALL ? getUnionModeFromJoinType[join.Type] : join.Type,
    Namespace: join.With,
    Source: QuerySourceType.Query,
  }));

  return {
    Id: `${UnionPrefix}${primaryNamespace}`,
    DisplayName: UnionTableDisplayName,
    UnionWith: unionConfigArray,
  };
};

export const isUnionJoinType = (joinsArray: JoinItem[]) => joinsArray?.some((item) => item.Type === JoinType.UNION || item.Type === JoinType.UNIONALL);

export const getUnionModeFromJoinType = {
  [JoinType.UNION]: 'DISTINCT',
  [JoinType.UNIONALL]: 'ALL',
};

export const UnionPrefix = '_UNION_';

export const UnionTableDisplayName = 'Union Table';

/**
 * validates the dataTypes of columns for union join type
 * @param dataType1- dataType of LHS query column
 * @param dataType2- dataType of RHS query column
 * @returns boolean - true if dataTypes are compatible, false otherwise
 */
export const areDataTypesCompatibleForUnion = (dataType1: string, dataType2: string): boolean => {
  if (dataType1 === dataType2) return true;
  const intTypes = ['Int', 'Int64']; // treat Int and Int64 as compatible
  return intTypes.includes(dataType1) && intTypes.includes(dataType2);
};

/**
 * Recursively collects all filter IDs that are dependent on the given filter ID.
 * This handles multi-level dependencies (grandparent -> parent -> child -> ...).
 * Only includes filters that are applied (IsRemoved !== true).
 * If an intermediate filter is removed, the chain is broken and its children are not included.
 */
export const getAllDependentFilterIds = (
  filterId: string,
  filterConfig: IFilterConfig[],
  customFilterDefinitions?: ICustomFilterDefinition[],
): string[] => {
  const dependentIds: string[] = [];

  // If filterId is a custom filter with a FilterKey, only the FilterKey constituent's ID
  // acts as an additional parent ID (standalone filters may have LinkedTo pointing to it).
  const effectiveParentIds = [filterId];
  if (customFilterDefinitions) {
    const cfDef = customFilterDefinitions.find((d) => d.ID === filterId);
    if (cfDef?.FilterKey) {
      effectiveParentIds.push(cfDef.FilterKey);
    }
  }

  const findDependents = (parentId: string) => {
    filterConfig.forEach((item) => {
      // Only include filters that are applied (not removed) and break chain if removed
      const extractLinkedToValue = item?.QueryId ? item?.LinkedTo?.replace(`_${item.QueryId}`, '') : item.LinkedTo;
      if ((extractLinkedToValue === parentId || item?.Render?.LinkedTo === parentId) && !dependentIds.includes(item.ID) && item.IsRemoved !== true) {
        dependentIds.push(item.ID);
        findDependents(item.ID);
      }
    });
  };
  effectiveParentIds.forEach((pid) => findDependents(pid));

  // The dependent filter ids calculated above could also be part of custom filters.
  // So, it's necessary to calculate and add those custom filters as well whose filter keys point to
  // the dependent filter IDs. Below logic does that.
  const setOfFilterKeysForDependentFilterIds = new Set();
  filterConfig.forEach((filter) => {
    if (dependentIds.includes(filter.ID) && filter?.Metadata?.FilterKey) {
      setOfFilterKeysForDependentFilterIds.add(filter?.Metadata?.FilterKey);
    }
  });

  filterConfig.forEach((filterItem) => {
    if (setOfFilterKeysForDependentFilterIds.has(filterItem?.Metadata?.FilterKey)) {
      if (!dependentIds.includes(filterItem.ID)) dependentIds.push(filterItem.ID);
    }
  });
  return dependentIds;
};
